export default {
  common: {
    noFace: 'Жүйрік бет жоқ',
    noPermissionTip: 'Бұл қызметті қолдануға рұқсатыңыз жоқ. Қалыптастыру үшін тіркеліңіз',
    selected: 'Таңдалды',
    continue: 'Жалғастыру',
    open1: 'Ашу',
    doubleClick: 'Екі рет басу',
    inputKeywordSearch: 'Кілт сөзді іздеу енгізіңіз',
    inputKeywordStartSearch: 'Іздеуді бастау үшін кілт сөз енгізіңіз',
    searchHistory: 'Іздеу тарихы',
    clearHistory: 'Тарихты тазалау',
    notFoundRelatedResults: 'Байланысты нәтижелер табылмады',
    switch: 'Ауыстыру',
    searchProductionLine: 'Өндіріс желісі',
    selectProductionLine: 'Өндіріс желісін таңдаңыз',
    rotateAngleTip: '{angle} айналдыру',
    plankText: 'Тақта',
    sendToEzSort: 'EzSort-ке жіберу',
    downloadEzSort: 'EzSort жүктеп алу',
    notDownloadTip: 'Егер EzSort қалыпты түрде ашылмаса, бұл сіз оны жүктеп алмағандығыңызды білдіруі мүмкін. EzSort жүктеп алу үшін төмендегі түймені басыңыз',
    updateTip: 'Программалық жаңалдау жəнг edilді. Қосіңіз Guigui!',
    betaTest: 'Бета сынақ кезеңінде тегін',
    ersortSpecail: 'Түсті белгілерге арналған',
    exclusiveFeature: 'Эксклюзивті функция',
    elementCanBeDragTip: 'Элементті сүйреуге болады',
    checkPlankIsConflict: 'Панель күйі тексерілуде',
    preferenceSaveErr: 'Қалауларды сақтау қатесі',
    guimen: 'Кабинет есігі',
    preferenceLoadTip: 'Сіздің қалауларыңыз жүктелуде...',
    preferenceLoadErrTip: 'Қалауларды жүктеу сәтсіз аяқталды. Қате қалауларды болдырмау үшін бетті жаңартып, қайта көріңіз!',
    localFileIsBeingWrite: 'Жергілікті файл жазылуда',
    taskMonitor: 'Тапсырманы бақылау',
    downloadByType: '{type} жүктеу',
    slotKnifeErr: 'Ұяшыққа арналған арнайы өңдеу құралы жоқ. Өндіріс желісінің баптауларын тексеріңіз! 【{msg}】',
    anewChooseCatalog: 'Каталогты қайта таңдау',
    downloadSetting: 'Жүктеу параметрлері',
    attention: 'Назар аударыңыз',
    unit: 'Единица',
    defaultUse: 'Әдетті пайдалану',
    defaultChooseUse: 'Әдетті таңдау',
    requestFail: 'Сұрау сәтсіз аяқталды',
    downloadDoneByType: '{type} жүктеу аяқталды',
    sysTip: 'Жүйе ескертуі',
    pleaseChoose: 'Таңдаңыз',
    confirmDelete: 'Жоюды растау',
    notDataTipByType: 'Деректер жоқ, алдымен {msg} жасаңыз',
    paginationTotalTip: '{total} элементтің {current}-{page} жолдары',
    chooseAmountData: '{number} деректер таңдалды',
    moreOperate: 'Қосымша',
    transferByType: '{type} ауыстыру',
    clickCopy: '{type} көшіру үшін басыңыз',
    currentLine: 'Ағымдағы жол',
    remark: 'Ескертпе',
    customFunction: 'Теңшелетін функция',
    limitedTimeTrial: 'Limited Free',
    startDate: 'Басталу күні',
    endDate: 'Аяқталу күні',
    startTime: 'Басталу уақыты',
    endTime: 'Аяқталу уақыты',
    lastMonth: 'Соңғы ай',
    lastSixMonth: 'Соңғы алты ай',
    lastYear: 'Соңғы жыл',
    searchByType: '{type} енгізіп іздеңіз',
    addTime: 'Уақыт қосу',
    startArrange: 'Орнатуды бастау',
    select: 'таңдау',
    search: 'Іздеу',
    name: 'аты',
    plankNo: 'тақта нөмірі',
    plankName: 'тақта атауы',
    orderNo: 'тапсырыс нөмірі',
    order: 'тапсырыс',
    partNameWithoutRoomCabinet: 'тақта атауы (бөлме/шкафсыз)',
    plankRemark: 'тақта туралы қосымша ақпарат',
    room: 'бөлме',
    orderAddress: 'жобаның мекен-жай',
    matCode: 'материал',
    matCode2: 'матеріал',
    plankMatCode: 'тақта матеріал',
    count: 'сан',
    customer: 'клиент',
    customerInfo: 'клиент туралы ақпарат',
    factoryOrderNo: 'фабрика тапсырыс нөмірі',
    roomName: 'бөлме',
    color: 'түс',
    plankColor: 'тақта түсі',
    plankThick: 'тақта қалыңдығы',
    plankHighGloss: 'Атрибуттарды бөлектеу',
    thick: 'қалыңдығы',
    front: 'алдыңғы',
    back: 'артыңғы',
    slot: 'шұңқыр',
    hole: 'тесік',
    hsInfo: '{hole} тесігі {slot} шұңқыр',
    diameter: 'диаметр',
    finishedWidth: 'тамамшық ені',
    finishedHeight: 'тамамшық биіктігі',
    finishedArea: 'тамамшық ауданы (㎡)',
    remarks: 'түсініктеме',
    remark1: 'түсініктеме 1',
    remark2: 'түсініктеме 2',
    remark3: 'түсініктеме 3',
    remark4: 'түсініктеме 4',
    remark5: 'түсініктеме 5',
    remark6: 'түсініктеме 6',
    remark7: 'түсініктеме 7',
    remark8: 'түсініктеме 8',
    remark9: 'түсініктеме 9',
    remark10: 'түсініктеме 10',
    remark11: 'түсініктеме 11',
    remark12: 'түсініктеме 12',
    remark13: 'түсініктеме 13',
    remark14: 'түсініктеме 14',
    remark15: 'түсініктеме 15',
    remark16: 'түсініктеме 16',
    texture: 'текстура',
    normal: 'тік текстура',
    reverse: 'қайта текстура',
    notCare: 'текстурасыз',
    holeSlotsStastic: 'тесік-шұңқыр саны',
    edge: {
      title: 'кенет',
      info: 'кенет туралы ақпарат',
      front: 'алдыңғы кенет',
      back: 'артыңғы кенет',
      left: 'сол kenet',
      right: 'оң kenet',
      up: 'юғары kenet',
      down: 'түшіңгі kenet'
      },
    isSpecial: 'арнайы',
    notSpecial: 'арнайы емес',
    textOfDoorPlank: 'есік тақта',
    textOfNotDoorPlank: 'есік тақта емес',
    isDoorPlank: 'есік тақта',
    notDoorPlank: 'есік тақта емес',
    width: 'ен',
    long: 'биіктігі',
    plankWidth: 'тақта ені',
    plankHeight: 'тақта биіктігі',
    shortLong: 'қысқа биіктігі',
    shortWidth: 'қысқа ені',
    plankShape: 'Тақтайдың пішіні',
    detail: 'Толығырақ',
    cancel: 'жокко ету',
    confirm: 'тастықтау',
    alreadyKnow: 'Мен бұл жөнүндӓ білеймін',
    Noprompts: 'Ешқандай көрсеткі бермей',
    deep: 'тереңдік',
    other: 'басқа',
    heighGloss: 'жоғары глянс',
    heighGlossPlank: 'жоғары глянс тақта',
    heighGlossSide: 'жоғары глянс жақ',
    notHeighGloss: 'жоғары глянс емес',
    notHeighGlossPlank: 'жоғары глянс емес тақта',
    saveSuccess: 'сақталды',
    deleteSuccess: 'жойалды',
    addSuccess: 'қосалды',
    editSuccess: 'өзгертілді',
    engraving: 'оюлу машина',
    electronicSaw: 'электрондық кескіш',
    glassEquip: 'шыны кескіш машина',
    labelingMachine: 'Таптама машина',
    copy: 'Көшіру',
    paste: 'Қою',
    undo: 'Кері ал',
    move: 'Қозғалт',
    PTP: 'PTP',
    dock56FDrill: 'алтышақтық бұрғалау машина',
    sideHoleDrill: 'жақшалық тесік бұрғалау машина',
    combination: 'комбинациялық машина',
    integration: 'бірліктегі машина',
    standardPlank: 'стандартты тақта',
    standardMaterial: 'Стандартты материал',
    standardMaterialTip: 'Ескерту: Үлкен тақта ақпаратын реттеуді аяқтағаннан кейін, шкафтарды орналастыру өндірісін қолданатын пайдаланушылар ең соңғы өзгерістерді қолдану үшін шкаф клиентін қайта іске қосуы керек!',
    specialMaterial: 'Арнайы материал',
    specialPlank: 'арнайы тақта',
    singlePlank: 'біржақты тақта',
    previous: 'алдыңғысі',
    plankInfo: 'Үлкен тақта ақпараты',
    moreResult: 'Тексеру шешімінің артық мөлшері',
    moreResultTip: 'Үлкен тақтада қабырғадан өңдеу үшін үзілістер бар, және үлкен тақта туралы қайта құрылымдауға қатыспайды.',
    ok: 'Растау',
    dispersePaibanTip: 'Үлкен тақталардың бір бөлігі құрылымда бөлінбейді, құрылымды қолмен түзету немесе өзгерту мүмкіндігін пайдалануға болады, тақталарды қалайтудан қорғау!',
    next: 'келесісі',
    rate: 'пайдалану көрсеткіші',
    paibanBatch: 'баспа топтығы',
    return: 'қайта',
    FGNo: 'келісім нөмірі',
    refresh: 'жаңарту',
    inde: 'нөмірі',
    productionLine: 'производственная линия',
    operation: 'операция',
    colorPlaceHolder: 'Ентерді басып, автоматты түрде түстік картасын құру',
    saveAndContinue: 'сақтау және жалғастыру',
    reset: 'қайта орнату',
    check: 'тексеру',
    inputPlaceholder: 'кіріңіз',
    filter: 'сіру',
    all: 'барлығы',
    exportPDF: 'PDF экспорттау',
    exportPic: 'сурет экспорттау',
    add: 'қосу',
    edit: 'өзгерту',
    delete: 'жою',
    restore: 'қалпына келтіру',
    save: 'сақтау',
    saveSetting: 'параметрлерді сақтау',
    isHeightGloss: 'Жоғары глянстық тақта екенін таңдаңыз',
    noSync: 'синхронization іштемеу',
    sync: 'синхронизация',
    formatSuccess: '{type} тастықталды',
    dataLoading: 'Деректер жүктеледі......',
    warmTip: 'қызметті кеңес',
    importantTip: 'Маңызды қызметті кеңес',
    wellcome: 'Қолдануға қош келдіңіз! Кейіптік жобалау',
    timeOut: 'Жобалау уақыты асып кетті, жаңадан жобалау керек пе?',
    notSawKnifeTip: 'Назар аударыңыз: Ара кескіш ою машинасында Көлденең кескіш орнатылмағандықтан, орналастыру жұмысын орындау мүмкін емес. Оны қосыңыз!',
    doorFrameKnifeRadiusErr: 'Сіз "Ара кескіш ою машинасы - Есік жақтауы кесу" функциясын қостыңыз. Кесу пышағы радиусы ара кесу қалыңдығынан үлкен, орналастыру орындалмайды!',
    doorFrameIrregularPlankErr: 'Сіз "Ара кескіш ою машинасы - Есік жақтауы кесу" функциясын қостыңыз. Бұл функция әзірше стандартты емес панельдерді орналастыруды қолдамайды!',
    warning: 'ескерту',
    export: 'экспорттау',
    mark: 'белгілеу',
    noMark: 'белгілемеу',
    sawArrange: 'кескіш жобалау',
    directArrange: 'тікелей кескіш жобалау',
    area: 'ауқым',
    plankNum: 'тақта нөмірі',
    loc: 'Шкафтар',
    cutHeight: 'кесу биіктігі',
    cutWidth: 'кесу ені',
    defaultProduction: 'әдетті өндіріс линиясы',
    surplusNum: 'Артық материалдың штрих-коды',
    tip: 'ұсынысы',
    history: 'тарих',
    hinge: 'қаптар сақинасы',
    hingeScrew: 'Аспалы есік панелі пилоттық тесіктері',
    CCPXHole: 'Үш бирлик эксцентрик от',
    stretchHinge: 'Түзөткүч слоты жана гишт тамақ отверстие',
    stretch: 'тіреуіш',
    stretcher: 'тіреуіш сақинасы',
    eccHole: 'эксцентрикалық тесік',
    preHole: 'алдын ала енгізілген тесік',
    clothole: 'киімдік сақинасы',
    backPlank: 'арқалық тақта сақинасы',
    ALS: 'қараңғы тұтқасы сақинасы',
    doorSlot: 'есик тақта металл сақинасы',
    drawerSlot: 'тартма металл сақинасы',
    lkSlot: 'Құлып ойығы',
    KC: 'штантар сақинасы',
    stealth: 'Көрінбейтін бөлшек',
    lightSlot: 'Жеңіл науа',
    ConventionalHole: 'Аdaqаллы бollik',
    Keyhole: 'Кілт саңылауы',
    allHole: 'арнайы тақтадағы барлық тесіктер',
    allSlot: 'арнайы тақтадағы барлық сақиналар',
    freedomAllHoleSlot: 'арнайы тақтадағы барлық тесіктер және сақиналар',
    freedomAllHoleSlotTip: 'арнайы тақта: бұрышы бір жақты емес тақта',
    millInfo: 'bûріш туралы ақпарат',
    haiTang: 'Айгүл бұрышы',
    FSDrill: 'алтышақтық/бесшақтық бұрғалау машина',
    engraving2: 'қырқызу машина',
    xyReverse: 'XY осьдері ауысу',
    autoXYReverse: 'Кескіш қабылдау құрылғысын автоматты түрде сәйкестендіру',
    autoXYReverseTip: 'Қосулып, алтышақтық бұрғалау машинасының өңдеу мәліметтері және бұрғалау машинасының өңдеу мәліметтері автоматты түрде XY осьтерінің ауысуына сәйкестендіріледі',
    autoXYReverseTip2: 'Ескерту: PTP қолданбаған',
    xyReverseTip: 'XY ассау айналасу функциясының L-шапағатты қалайтын қалпына келтіруге үйлесімді емес, қақтықты қолданыңыз',
    rect: 'Тік пішін',
    Ltype: 'L пішін',
    archive: 'Архив',
    tellPlaceholder: 'Ұялы телефон нөміріңізді кіріңіз',
    knivesStore: 'Кескіш қорап',
    roll: 'Кескіштің бетін ауыстыру',
    pause: 'Тынықтау',
    editTrans: 'Тәрҗеме редакторы',
    translateManager: 'Аударма басқару',
    grating: 'Тор',
    addressEditErr: 'Қос тапсырыстарға жобаның мекенжайін өзгертуге болмайды',
    customerEditErr: 'Қос тапсырыстарға клиенттің деректерін өзгертуге болмайды',
    factoryEditErr: 'Қос тапсырыстарға зауыттың номерін өзгертуге болмайды',
    roomNameEditErr: 'Қос тапсырыстарға бөлменің атауын өзгертуге болмайды',
    remarkEditErr: 'Қос тапсырыстарға тапсырыс ескертуін өзгертуге болмайды',
    toMaterialList: 'Қайрау тізіміне өту',
    deleteFail: 'Жою сәтсіз аяқталды, кейінірек қайталап көріңіз!',
    batchRestore: 'Топпен қалпына келтіру',
    batchDelete: 'Топпен жою',
    workShop: 'Цех өндірісі',
    FGAdrress: 'Жоба мекенжайы/Шарт нөмірі',
    cuttingSize: 'Кесу өлшемі',
    finishedSize: 'Дайын өлшемі',
    labelImg: 'Жапсырма сурет',
    layoutImg: 'Тәртіп суреті',
    file: 'Файл',
    folder: 'Қаптама',
    reName: 'Атауын өзгерту',
    to: 'Кімге',
    plankUnit: 'Дана',
    tagTemp: 'Тегтің үлгісі',
    roomRemark: 'Бөлме туралы ескертпелер',
    noModificationPermission: 'Өзгертуге рұқсат жоқ',
    modificationRecord: 'Жазбаны өзгерту',
    page: 'бет',
    strip: 'жолақ',
    jump: 'секіру',
    freeAgreement: 'Бағдарламалық қамтамасыз етуден бас тарту туралы келісім',
    preStep: 'Алдыңғы',
    nextStep: 'Келесі',
    upload: 'жүктеп салу',
    uploading: 'жүктеп салу',
    iAgree: 'Мен келісемін',
    pleaseSelectPlank: 'Кем дегенде бір тақтайшаны таңдауыңызды сұраймын',
    saveToStoreTip: 'Кем дегенде бір кесілмеген тақтайшаны таңдауыңызды сұраймын',
    fileIsNotExist: 'Файл жоқ',
    selectAll: 'Барлығын таңдау',
    pdfTag: 'PDF Тегі',
    tagImage: 'Тег суреті',
    guigui: 'guigui',
    gratingSlot: 'Торлы ойық',
    deleteTip: 'Бұл деректерді жоюдан кейін олар қалпына келтірілмейді, деректерді жоюға жоспарлануда мұрайсыз ба?',
    deleteError: 'Có hay không xác nhận việc xóa dữ liệu',
    cancelDelete: 'Жоюді тоқтатты',
    confirmDeleteTip: 'Жойғаннан кейін тақта беттің төменгі оң жақ бұрышына «Тақта типтес болуға тиіс – сақталмайды» деген бетке енгізіледі, деректердің жойылғанын растаудың орындылығы бар ма?',
    confirmDeleteBujianTip: 'Жойғаннан кейін бөлік беттің төменгі оң жақ бұрышындағы "Бөлшектер кітапханасына" енгізіледі, деректерді жоюды растайсыз ба?',
    confirmSureDeleteTip: 'Ағымдағы орналасу кітапханасында бірдей материалдан жасалған кішігірім тақталар анықталды, осы үлкен тақтаны жоюды жалғастыруды растайсыз ба?',
    deleteEmptyTip: 'Бұл үлкен тақтаны жою керек пе',
    notCanDelete: 'Қиып алынған қалған материалдар қоймалауды қолдамайды',
    new: 'New',
    innerBluneFailure: 'қосылды',
    deleteBigPlankTip: 'Үлкен плитаны материал түсінің ағымдағы қалыңдығының астында ұстау керек және оны жоюға болмайды!',
    continueExport: 'Елемеу және шығыс файлына өту',
    toCheck: 'Тексеруге өту',
    pleaseCheck: 'Көрсөтүлгөн тизме кескин: Эгемендик борбордук панельде тешик жойлашуы/учак майдалары ажырады/тереңдик аномалиясы бар. Баарын текшериңиз!',
    clampHandCheck: 'Кейбір панельдеріңіздегі саңылаулар қысу күйінен аулақ бола алмайтыны анықталды. Оны қолмен реттеңіз.',
    conflictPartDetail: 'Thông tin chi tiết về các thành phần xung đột',
    colorNotUndefined: 'Түс бос болуы мүмкін емес',
    materialNotUndefined: 'Материал бос болмауы керек',
    newSetting: 'қосылды',
    downImageErrTip: 'Фотоны шығару баталды, өйткені улгама тақтадан бөлмелерге бөлінген шыңырақ суреттерді шығару арзандыруы қол жетімді етілді, бірігі міндетті түрде бейне тақталарын таңдау керек',
    downNcErrTip: 'NC файлдарын жүктеу баталды, өйткені улгама тақта бойынша суреттерді бөлмелерге бөлу қызметі қосылды. Бірігі міндетті түрде бейне тақталарын таңдау керек.',
    downNcErrTipForSurFolder: 'NC файлдарын жүктеу баталды, өйткені улгама тақта бойынша суреттерді бөлмелерге бөлу қызметі қосылды. Бірігі міндетті түрде бейне тақталарын таңдау керек.',
    yes: 'Яс',
    no: 'Жоқ',
    checkColorPrint: 'Қазіргі уақытта түс белгісі қосылды, басып шығару үшін түсті принтерді пайдалануыңызды сұраймыз©~',
    colorRules: 'Түрлі-түсті жапсырмалардың буынын қосқаннан кейін тапсырыстар/бөлмелер/шкафтар/есік панельдері түсі бойынша ажыратылады,kазіргі уақытта деректердің бір түрі үшін қолдау көрсетілетін түс белгілерінің ең көп саны 12, нақты ережелер мынадай:',
    greyPart: 'Жапсырманың оң жағындағы сұр бөлігі',
    region: 'аймақ',
    notSame: '{regionName} аймағының түсі әр түрлі',
    doorTip: 'Сұр — есік панелі, ақ — есіксіз панель',
    exist: 'бар',
    limitNotEffect: 'Егер 12-ден астам деректер болса, түс белгісі күшіне енбейді',
    hoverTip: 'Bmp жұрнағы бар суреттер қара-ақ түспен кодталады және түс белгілерімен шығарылуы мүмкін емес',
    lock: 'блоктау',
    unlock: 'блоктаудан ажырату',
    batchLock: 'томарлау блоктау/блоктаудан ажырату',
    surplusLock: 'қалайтын материалдарды блоктау',
    surplusUnlock: 'қалайтын материалдарды блоктаудан ажырату',
    is: 'Иә',
    not: 'Жоқ',
    savingHistory: 'Тарих файлын сақтау',
    saveHistorySuccess: 'Тарих файлын сәтті сақтаңыз',
    saveHistoryFail: 'Тарих файлын сақтау сәтсіз аяқталды',
    bw: 'Қара-ақ жапсырмаларды экспорттаудың орындылығы',
    modular: 'Бөлімше шкафтары',
    autoAdjust: 'Авто реттеу',
    cutOrderTip: '【{errorCutOrdersString}】 плитасында қате анықталды! NC файлын жүктеу алдында түзетулер енгізуіңізді сұраймын',
    lockedCutOrderTip: '【{errorCutOrdersString}-арттық тақта】блокланды, өздіктіңіз бұлын өзгерту үшін өтіңіз',
    paibanImgCutOrderTip1: 'Сіздің анықтағаныңыз',
    paibanImgCutOrderTip: 'Кесу тәртібінде қате бар! Орналасу файлын экспорттамас бұрын реттеу үшін орналасу бетіне өтіңіз',
    goAdjust: 'Реттеу',
    autoAdjustWarning: 'Ағымдағы типтеу нәтижесі автоматты реттеуді қолдамайды',
    checkNetwork: 'Интернет байланысыңызды тексеріңіз',
    moreInfo: 'Толығырақ ақпарат',
    continueLayout: 'Орналасуды жалғастыру',
    adjustPosition: 'Орналасуды реттеу',
    specialAndFiveSix: 'Бес/алты жақты бұрғылау арқылы тақталарды өңдеу кезінде, дұрыс емес ұя салуды қосу тақтаның кесіліп кетуіне әкелуі мүмкін. Орналасуды жалғастыруды растайсыз ба?',
    plankPathErr: 'Пластина ішінде дұрыс емес деректер қатесі, құралдың сипаттамаларына сәйкес келетінін тексеріңіз!【{plankIDList}】',
    edgeCheck: 'Система тексеруі түрде анықтады, көп бөлімдің қысқартуы өзгертілген; жүйесін жаңартыңыз, өңдеу арқылы дұрысдықты жоқыңыз',
    iKnow: 'Мен білім жасамын',
    versionErrTip: 'Сауда автоматын соңғы нұсқасына жаңартыңыз!',
    annualFeeExpired: 'Сіздің жылдық төлем мерзіміңіз өтіп кетті, жаңартуды өтінеміз!',
    holeEquipment: 'Бұрғылау жабдығы {num}',
    customizedService: 'Теңшелетін қызметтерді қолдау, сіздің жеке өндірістік жоспарыңызды жасаңыз',
    exampleCombination1: 'Ою машинасы + Бес/алты жақты бұрғылау + Бүйірлік тесік машинасының комбинациясы',
    exampleCombination2: 'Электрондық ара + Бес/алты жақты бұрғылау + Бүйірлік тесік машинасының комбинациясы',
    exampleCombination3: 'Толық автоматты біріктірілген өндірістік желі + Бес/алты жақты бұрғылау комбинациясы',
    feedback: 'Сіз өзіңіздің қажеттіліктеріңізді Guigui бағдарламалық жасақтамасының сатушысына немесе сатудан кейінгі қызмет көрсету қызметкеріне тікелей хабарлай аласыз',
    markModifiedBoards: 'Өзгертілген шағын тақталарды белгілеу',
    showMoveStep: 'Жобалау клавиатурасын қозғалыс қадамын белгілеу',
    moveStep: 'Жобалау клавиатурасын қозғалыс қадамы',
    existChangeBoards: 'Өзгертілген шағын тақталар бар',
    crossMaterialBoard: 'Материал-түс аралас тақта',
    skipCrossMaterialTip: 'Бұл орналасымда қайталап көрсетпеу',
    crossMaterialConfirmTip: 'Сіз қазір кіші тақтаны әртүрлі материал немесе түс арқылы жылжытып жатырсыз. {highlight} Жалғастырасыз ба?',
    crossMaterialConfirmTipHighlight: 'Шығарылған тақта бөлінген тапсырыспен сәйкес келмеуі мүмкін',
    exportHoleSlotPDF: 'Тесіктер мен ойықтардың сызбасын экспорттау',
    pdfFormat: 'PDF форматы',
    dxfFormat: 'DXF форматы',
    specialShapeKnivesInfo: 'Бұрғылау жабдықтарын таңдау',
    specialShapeKnivesInfoTips: 'Шағын тақта {stockNum}:',
    specialShapeKnivesInfoTips2: 'Бұрғылау жабдықтарын таңдау режимі қосылған, тақталардың орналасуы дұрыс емес, қайта орналастыруды қайталаңыз немесе бұрғылау жабдықтарын таңдау режимін өшіріңіз',
    default: 'Бастапқы',
    exportLanguage: 'Экспорт тілі',
    exportLanguageTip: 'Ескерту: PDF түрінде шығарған кезде кейбір мәтін элементтерін аудару мүмкін емес.',
    highGlossNameTip: 'Шкафтан синхрондалған жалтыр тақталар басқа мәтінмен сипатталуы мүмкін, бірақ олардың жалтыр қасиеттері өзгермейді.',
    mixPaibanPlanSetting: 'Бұрғылау жоспарын орнату',
    mixPaibanPlanSettingTip: 'Бұрғылау жоспарын орнату өзгертілген, өзіңіздің бұрғылау жоспарын таңдаңыз!',
    mixPaibanPlanSettingOk: 'Бұрғылау жоспарын орнату',
    mixPaibanPlanSettingCancel: 'Жоқ, тікелей орналастыру',
    noMixPaibanPlan: 'Бұрғылау жоспары жоқ',
    mixColors: 'Бұрғылау түстері',
    mixPai: 'Бұрғылау',
    plan: 'Жоспар',
    mixPaibanTitle: 'Бұрғылау түстері бірге орналасуы',
    mixColorsTip: 'Бұрғылау түстері бірге орналасуы мүмкін, бірақ олардың бұрғылау түстері өзгермейді.',
    mixColorsTip2: 'Жоспарды қосудан кейін кесу тізімінде қосылуы тиіс',
    mixColorsTip3: 'Бұрғылау түстері бірге орналасуы мүмкін, бірақ олардың бұрғылау түстері өзгермейді.',
    mixErrTip: 'Бұрғылау жоспарының міндетті өрістері жоқ, тексеріңіз',
    addPlan: 'Жоспар қосу',
    chooseMatcode: 'Материалды таңдау',
    chooseColor: 'Түсті таңдау',
    defineColor: 'Түсті анықтау',
    confirmDeletePlan: 'Жоспарды өшіруді растау',
    trimmingMethod: 'Қиып алу әдісі',
    followStandardTrim: 'Негізгі тақтадағы стандартты материалдың қиып алу мәнін пайдалану',
    trimToast: 'Назар аударыңыз: Сіз қалдық материалдың жеке қиып алу функциясын қолдандыңыз, тек аралау орналастыруды таңдауға болады',
    individualTrimValue: 'Қиып алу мәнін жеке орнату',
    topTrimEmptyToast: 'Жоғарғы қиып алу мәні бос болмауы керек',
    bottomTrimEmptyToast: 'Төменгі қиып алу мәні бос болмауы керек',
    leftTrimEmptyToast: 'Сол қиып алу мәні бос болмауы керек',
    rightTrimEmptyToast: 'Оң қиып алу мәні бос болмауы керек',
    topTrimBlurToast: 'Жоғарғы қиып алу мәнін енгізіңіз',
    bottomTrimBlurToast: 'Төменгі қиып алу мәнін енгізіңіз',
    leftTrimBlurToast: 'Сол қиып алу мәнін енгізіңіз',
    rightTrimBlurToast: 'Оң қиып алу мәнін енгізіңіз',
    effectToast: 'Жеке қиып алу функциясы тек дәнекерленген тақталарға қолданылады',
    defaultTrimSetting: 'Қалдықтар үшін әдепкі қырын орнату',
    enterHere: 'Міне, шур',
    permissionTipExportDxf: 'DXF тесік слот диаграммасын экспорттау',
    permissionTipSurplusRecycleBin: 'Қалдықтарды қайта өңдеу станциясы',
    permissionTipAdvancedNesting: 'Жетілдірілген бірегей ұяластыру',
    permissionTipPanelGrainAlign: 'Тақта дәнін туралау',
    permissionSeparator: ', ',
    missingPermissionTip: 'Келесі рұқсаттар жоқ: {permissions}'
    },
  home: {
    head: {
      production: 'Өнімді таныстыру',
      resolve: 'Шешімдер',
      about: 'Біз туралы',
      equipment: 'Машиналар жабдықтары',
      tell: 'Шикаять телефон',
      enter: 'Бұлт баспашылық кіріңіз'
      },
    swiper: {
      case1: {
        tag: 'Жаңа жаңарту версиясы',
        subTitle: 'Машинаның интеллектуалды ми',
        description: 'Өнеркәсіптік бастырақті онлайн баспашылық оптималдау бағдарламалық жасақтамасы'
        },
      case2: {
        title: 'Шкафтар өндірісі',
        subTitle: 'Технологиялық жаңартулар',
        description: 'Көптеген этикеткалеу машиналар, кескіш машиналар, جانболы отық машиналары, бесжақты PTP, бес/алтышақты бұрғалау машиналармен қосу'
        },
      case3: {
        title: 'Өнеркәсіптік ми',
        subTitle: 'Шешімдер',
        description: 'Интеллектуалды баспашылық алгоритмі тақта материалдарды тиімдірек пайдалануға мүмкіндік береді'
        }
      },
    statistics: {
      today: 'Бүгінгі күннің жұмыс плані',
      toMounth: 'Бүгінгі айдің жұмыс плані',
      outturn: 'Өнімділік көрсеткіші',
      cumulative: 'Жалпы пайдаланушылар саны'
      },
    intro: {
      title: 'Корпоративтік біг деректері Бұлт онлайн баспашылық бағдарламалық жасақтамасы',
      subTitle: 'Өнеркәсіптік ситуацияны бақылау, клиенттердің қажеттіліктеріне назар аудару, корпоративтік цифрлық трансформация мен автоматтандыруды іске асыру, Интернет-өнімдер өндірісінің индустриялық өзгерістеріне иішінарыс. Қазіргі板式 мебел өнімділіктеріне арналған AI қосымша алгоритмдері ұсынылады, олар корпоративтік өсімге жеткізуге мүмкіндік береді',
      menue: {
        case1: {
          title: 'Онлайн баспашылық',
          subTitle: 'Кез келген уақытта баспашылық жасауға болады',
          description: 'Бағдарламалық жасақтама жүктемей, кез келген уақытта баспашылық жасауға болады, компьютерге байланыс болмай-ақ кіріңіз'
          },
        case2: {
          title: 'Көптін өнімділік',
          subTitle: 'Өнімділік сызықты тез ауыстыру',
          description: 'Көптеген өнімділік сызықтарын бір мезгілде тез өңдеуге және ауыстыруге қол жетімді'
          },
        case3: {
          title: 'Ең нәзік өнімділік',
          subTitle: 'Ең назик баспашылық, параметрлерді назик баптау',
          description: 'Ең назик баспашылық, параметрлерді назик баптау, тақталар өнімділігін назик етуге мүмкіндік береді'
          },
        case4: {
          title: 'Жеке өнімділік',
          subTitle: 'Жеке этикеткалар, бес/алтышақты бурғылау, қалдық пішін',
          description: 'Жеке этикеткалар, жеке бес/алтышақты бурғылау, жеке қалдық пішін, комбинациялық жабдықтармен өңдеу'
          }
        }
      },
    fangan: {
      title: 'Өнеркәсіптік кәсіпорындарға арналған профессионалды шешімдер',
      subTitle: ' Төменгі бағасымен, жоғары өнімділікпен, интеллектуалды алгоритмдер арқылы тақта материалдарды тиімдірек пайдалануға болады. Бұл шешімдер көптеген дизайн бағдарламалармен үйлесімділікке ие және өнімділікті арттыруға мүмкіндік береді ',
      menue: {
        case1: {
          title: 'Онлайн ордерлік өндіріс біріктірілу',
          description: ' Қашықтан онлайн операциялар, кеңістіктің шектеулерін асып, кез келген уақытта ордерлерді зауытқа жіберу және дизайн мен өндіріс синхрондықтай бастау'
          },
        case2: {
          title: 'Бір батырмамен өндіріс желісі ауысу',
          description: 'Өзіндікеше ондіріс желісі, бірнеше өндіріс желісі мен көптілік құрылғыларды біріктіруге қолдайды'
          },
        case3: {
          title: 'Интеллектуалды алгоритмдер тақта материалдарды тиімдірек пайдалануға мүмкіндік береді',
          description: 'Традиционалды алгоритмдерде тақта материалдарды пайдаланудың тиімділігі төмен. Интеллектуалды алгоритмдермен параметрлерді нарықтай баптау және өнімділікті арттыруға арналған шешімдер'
          },
        case4: {
          title: 'Профессиональды кесу шесімі',
          description: 'Кесу реттілігі мен кесу бастамасын оптималдау, кесу жолдарын қысқа және кесудің тұрақтылығын арттыру'
          }
        }
      },
    aboutUs: {
      title1: 'Шинэгэр Үй-Жай Технологиясы',
      subTitle: 'Өрек жасау өнеркәсіптің трансформациялық лидер',
      description: 'Шинэгер компаниясы традиционалды өрек жасау өнеркәсібін интернетке трансформациялауға маманданған',
      culture: {
        case1: {
          title: 'Корпоративтік мақсаты',
          subTitle: 'Заводтарға үш есе өсім беру'
          },
        case2: {
          title: 'Культуралық құндылықтар',
          subTitle: 'Клиенттерге бағытталған, еңбекшілерге негізделген, қиын еңбекпен, халққа файда әкелу'
          },
        case3: {
          title: 'Нұсқаулық бағыт',
          subTitle: 'Халык жолымен, сатуу, өнімділік, ұйымдастықпен біріктірілген элита командасын құру'
          }
        },
      feature: {
        case1: 'Кәсіби топтық техникалық қызметтеу',
        case2: 'Үнемі жаңарту және итерлеу',
        case3: 'Бір-біріне қарастық кезімді қызмет көрсету',
        case4: 'Функцияларды жекешелендіру қызмет'
        }
      },
    cooperation: {
      title: 'Қатты ынтымақтастық, болашақтықтық құру',
      subTitle: 'Құрылғы брендтерінің 90% ішкі қоммунистік құрал-жабдықтарға қосылады, 107554 сандық саудагерлер бізбен бірге істеп жатыр '
      },
    footer: {
      contact: {
        title: 'Бізбен байланысыңыз',
        adrres: 'Адресі: Цзянсу қаласының Биньху ауданыңіздеги Сюйси 50-ші көшесі',
        subAdrres: 'K-park сервис орталығы 1-ші ғимараттың 16-ші қабат',
        tell: 'Телефон'
        },
      business: {
        title: 'Шинэгердің негізгі бизнесі',
        department1: 'Есік-шарпа шбақ бағдарламалық қамтамасыз ету бөлімі',
        department2: 'Өрек бағдарламалық қамтамасыз ету бөлімі',
        department3: 'Құрылыс-монтаж бөлімі',
        department4: 'Шинэгердің штаб-пәтерінің официалды сайты'
        },
      brand: {
        title: 'Шинэгердің саубақ брендтері',
        brand1: 'Цайшэнь цзиньфу',
        brand2: 'Менту ван',
        brand3: 'Динксин инвестишн',
        brand4: 'Саньчжанту технология',
        brand5: 'Шанхай фэньмò технология'
        },
      organization: {
        title: 'Шинэгердің жұмыс істеу орындары',
        organization1: 'Шинэгер-Жаньяй бюросы (Фошань филиалы)',
        organization2: 'Шинэгер-Шығыс бюросы (Линьи филиалы)',
        organization3: 'Шинэгер-Жантық бюросы (Чэнду филиалы)',
        organization4: 'Шинэгер-Гуigui батыс сервис орталығы',
        organization5: 'Шинэгер-Гуigui шығыс сервис орталығы',
        organization6: 'Шинэгер-агенттер топтығы',
        organization7: 'Шинэгер-халықаралық нарық бөлімі'
        },
      follow: {
        title: 'Гуigui-діңізге шықырыңыз'
        },
      friendLink: {
        link1: 'Шинэгер бағдарламалық қамтамасыз ету',
        link2: 'K шоу сауда-сатық бағдарламалық қамтамасыз ету',
        link3: 'Менту ван',
        link4: 'Толық алюминий шкаф бағдарламалық қамтамасыз ету',
        link5: 'ZOL бағдарламалық қамтамасыз ету жүктеу',
        link6: 'Хуа цзюнь бағдарламалық қамтамасыз ету орталығы',
        link7: 'Жүктеу үй',
        link8: 'ZOL бағдарламалық қамтамасыз ету жүктеу',
        link9: 'Жасыл ресурстар тобы',
        link10: 'Кішеньдіңізге қосылу',
        link11: 'Үй жихазына қосылу',
        link12: 'Мэйбiao вэнэй қосылу'
        }
      }
    },
  login: {
    title: 'Кіру',
    tell: 'Ұялы телефон нөмірі',
    password: 'Құпия сөз',
    passwordPlaceholder: 'Құпия сөзді кіріңіз',
    forget: 'Құпия сөзді ұмыттым',
    registerAccount: 'Құжатты тіркелу',
    backLog: 'Кіруге қайта оралу',
    verifyCode: 'Тексеру код',
    getVerifyCode: 'Тексеру кодты алу',
    verifyCodeErr: 'Тексеру коды қате',
    confimPassword: 'Құпия сөзді тастықтау',
    confimPasswordPlaceholder: 'Құпия сөзді тастықтайңыз',
    editPassword: 'Құпия сөзді өзгерту',
    register: 'Тіркелу',
    reSend: 'соңынан қайта алу',
    loginLoadText: 'Кіру процесіне кірісіңіз, солтүшіңіз...',
    loadingPageTextL: 'Кіру сәтті, беттің құрылымын жүктеуде...',
    loginSuccess: 'Кіру сәтті',
    tellErr: 'Ұялы телефон нөмірінің пішімі дұрыс емес',
    passwordErr: 'Құпия сөзді кіріңіз'
    },
  main: {
    head: {
      title: 'Bluen',
      subTitle: 'Save time, materials, and effort',
      task: 'Місія алу',
      arrange: 'Орнату',
      surplus: 'Қалдық материал',
      setting: 'Құрамды орноту',
      find: 'Табу',
      upgrade: 'жаңарту',
      editNickName: 'Атауды өзгерту',
      editPassword: 'Құпия сөзді өзгерту',
      logout: 'Кіруден шығу',
      notice: 'Жарнама',
      enterOfficial: 'Официалды сайтына кіру',
      equipment: 'Машиналар және құрылғылар',
      help: 'Қолдау',
      importFunc: 'Мағлуматтан тыс қосымша құрылыстарды қараңыз',
      enterThinkerOfficial: 'Жинэрдің официалды сайтына кіру',
      history: 'Қалптықтық сақтау',
      plankManager: 'Бастапқы материалдарды басқару',
      tagManager: 'Тексеруді басқару',
      suplumentManager: 'Толтыру материалдарды басқару',
      fileManager: 'Файлдарды басқару',
      productionLine: 'Құрылғылармен қосылу',
      workeShop: 'Бұлттық өндіріс',
      useLesson: 'Қолдану оқулығы',
      videoLesson: 'Видео оқулығы',
      prolineManager: 'Өндіріс желісін басқару',
      materialManager: 'Материалдарды басқару',
      productManual: 'продукт менюсى',
      medialRelated: 'Градиентке қатысты'
      },
    sideBar: {
      title: 'Өндіріс оптималдау',
      materialList: 'Материалдар тізімі',
      paibanTask: 'Татып түсіру тапсырмасы',
      paibanResult: 'Орнату жоспары',
      printTag: 'Тексеруді басып шығару',
      history: 'Қалптықтық сақтау',
      limitDate: 'Limited Free',
      surplusManager: 'Қалдық материалдарды басқару',
      translateManager: 'Тексеру кодын басқару',
      moreSettings: 'Қосымша параметрлер',
      deepSeekTitle: 'Кеңес беруші',
      paibanCommune: 'Жазуды реттеу пікірталас тобы'
      },
    allRead: 'Бәрі оқып шықты',
    learnMore: 'Толық мәлімет',
    noticeEmpty: 'Жарнамалар жоқ...',
    noticeErr: 'Жарнама мазмұнын алуда қателік',
    feedBack: {
      tab1: 'Пікірді беріңіз',
      tab2: 'Пікірлер тізімі',
      type: 'Пікір түрі',
      typePlaceholder: 'Қызметті функцияны таңдаңыз',
      description: 'Сипаттама',
      descriptionPlaceholder: 'хайр! Толық пайдалану сценарийін сипаттау үшін 15 аз емес әріптерді толтыруңыз, біз сізге жақсы көмек көрсетеміз, спасибо!',
      uploadPic: 'Суреттерді қосу, ең көп 6 суретті, әр суреттің көлемі 10 МБ-ден аспайды)',
      tell: 'Қолдану телефоны',
      submit: 'Беріңіз',
      admin: 'Бұлттарды орастыру әкімшісі:',
      picTip: 'Сурет: (суреттішекті ашу)',
      empty: 'Пікірлер деректері жоқ',
      picErr: 'Әр суреттің көлемі 10 МБ-ден аспайды',
      contentErr: 'Әріптер саны 15 - 300 аралығында болуы тиіс',
      necessary: 'Бұл параметрді толтыру керек'
      }
    },
  taskPage: {
    tab1: 'Өндірістік тапсырыс',
    tab2: 'Серілік өндіріс кезектесі',
    filter: {
      title: 'Сүзгілеу',
      unArrange: 'Орнатусіз',
      arranged: 'Орнату',
      allArranged: 'Барлығы орналастырылды',
      preLayout: 'Алдын ала орналастыру'
      },
    search: {
      placeholder: 'Іздеу мазмұнын енгізу',
      orderName: 'Тапсырыс атауы',
      sender: 'Жіберуші'
      },
    importTask: 'Тапсырыс імпорту',
    refuseTask: 'Тапсырысті қабылдамау',
    refreshList: 'Тізімді жаңарту',
    refuseRecord: 'Қабылдамай тіркеу',
    taskCard: {
      sender: 'Імпортталған материалдар тізімі',
      delivery: 'Келісімдеуіші мерзім',
      delete: 'Жою',
      addToBatch: 'Серілікке қосу',
      save: 'Архивдеу',
      arrange: 'Тікелей орнату',
      deleteTitle: 'Тапсырысты жою',
      checkDetail: 'Егжейінің ақпараттарын қарау үшін басыңыз',
      refuse: 'Қабылдамай',
      refuseTime: 'Қабылдамай уақыты',
      refuseReason: 'Қабылдамай себебі',
      refuseTask: 'Тапсырысты қабылдау',
      refuseTaskPlaceholder: 'Қабылдау себебін енгізіңіз',
      addErr: 'Қосу сәтсіз, кейінірек қайталап көріңіз!'
      },
    batchNo: 'Серілік нөмірі',
    batchArrange: 'Серілік орнату',
    clearBatch: 'Кезектесті босатау',
    taskCount: 'Қазіргі тапсырыстар саны: ',
    checkAllTask: 'Барлық материалдар тізімін қарау',
    clearSuccess: 'Босату табысты',
    record: {
      batchNo: 'Серілік нөмірі',
      saveDate: 'Архивдеу мерзімі',
      materialList: 'Материалдар тізімі',
      arrangedRecord: 'Орнату жоспар',
      searchPlaceholder: 'Серілік нөмірін енгізу',
      tipText: 'Бұл архивті жою ма?'
      },
    errTip: 'Құжаттарды өңдеу үшін мүмкіндіктер жоқ, тапсырыс тізіміне өту үшін қосу керек!',
    emptyErr: 'Тапсырыс төлемінде тақталардың мәліметтері жоқ, жасау бағдарламасына жалдау көрсетілмейді!',
    operationSuccess: 'Орындалу сәтті',
    operationFail: 'Орындалу сәтсіз, кейінірек қайталап көріңіз!',
    saveSuccess: 'Сақтау сәтті',
    plankMaxLimit: 'Кіші тақталардың саны ең көп бағдарлама шектесінен асып кетті',
    batchWorning: 'Бағдарламаны бөлек өндіру керек',
    batchEmptyErr: 'Тапсырыс тізімінде тақталар мәліметтері жоқ, бөлек өндіруді жалдау мүмкін емес!',
    noRoomTip: 'Оданыштар жоқ, бөлекше өндіруге мүмкін емес!',
    refuseHistory: 'Қабылдау тарихы'
    },
  materialPage: {
    specialProcess: 'Арнайы процесс',
    distanceFromTop: 'Жоғарғы шекарадан қашықтық',
    distanceFromRight: 'Оң жақ шекарадан қашықтық',
    hingeData: 'Шарнир деректері',
    labelBackProcTip: 'Бұл апдейлама большай панелнің артындағы белгілік методын оптималдаştırdı. Энди, белгінін ізе бойынша тегіп, дырластап және патықластап көрсеткен боласыз. Білесіз деп тұлаганмын!',
    openDir: 'Есіктің ашылу бағыты',
    edgeEmptyTip: 'Қию мәні бос болмауы керек',
    edgeNumberLimit: 'Қию мәні тек сан болуы керек',
    chooseSurplusQuantity: 'Қол жетімді артық материалдардың {total} түрі бар, {quantity} түрі таңдалды',
    noCanSaveInfo: 'Сақтау мүмкіндігі жоқ ақпарат',
    chooseBujianStoreQuantity: 'Барлығы {total} қосымша бөлік, {quantity} тақтайларды қосуға болады, таңдалғаны {chooseQuantity} тақтай',
    isConfirmPushToAwaitStore: 'Таңдалған тақтайларды орналастыруды күту қоймасына қосуға сенімдісіз бе?',
    enterAutoCreateMatCode: 'Материалды автоматты түрде жасау үшін Enter басыңыз',
    chooseAwaitStoreQuantity: 'Орналастыруды күту қоймасында {total} шағын тақтай бар, орналастыруға {quantity} тақтай қосуға болады, таңдалғаны {chooseQuantity} тақтай',
    defaultFold: 'Панельдік деректер әдепкі бойынша жабылады',
    startArrange: 'Орнатуды бастау',
    importMaterial: 'Материалдар тізімін імпорту',
    saveToHistory: 'Тарихқа сақтау',
    addPlank: 'Панельді қосу',
    addBujian: 'Қосымша қойым қойылымына қосу',
    deletePlank: 'Панельді жою',
    batchEdit: 'Топтық өңдеу',
    moreSetting: 'Қосымша орноту',
    plankSize: 'Панельдің өлшемдері',
    plankSize2: 'Өлшемдер (Ұзындығы * Ені * Қалыңдығы)',
    searchPlaceholder: 'Панельдің атауы/панель нөміріні іздеу',
    checkArranged: 'Орнатуды қарау',
    checkErr: 'Орнатуды жасалмады, қарауға болмайды!',
    downloadSheet: 'Үлгі парақ жүктеу',
    downloadSheetShowScientific: 'Үлгі парағын жүктеу (ғылыми нотацияны көрсету)',
    exportHoleSlotPDF: 'Панельдің тесіктері-жұмсақ шабаларын экспорттау',
    style1: 'Стиль 1',
    style2: 'Стиль 2',
    style2PDF: 'Стиль 2 (PDF)',
    style2DXF: 'Стиль 2 (DXF)',
    style3: 'Стиль 3',
    importNoCover: 'Материалдар тізіміңіздің імпортуі қаптамау',
    openBujianPlankRecommend: 'Patch Miniplate ұсынысын ашу',
    openAwaitStorePlankRecommend: 'Түрге жататын кітапхананың ұсыным тақтасын ашу',
    openSurplusPlankRecommend: 'Қалған материал плитасын ашу ұсынылады',
    pushToAwaitStore: 'Түрге жататын кітапханадағы депозит',
    setTableHead: 'Материалдар тізімінің таблица бастығы орнату',
    syncConfirm: 'Қоршау мен Бұлттарды орастырудағы панельдердің деректері сәйкес келмейді! Қоршау деректеріне синхрондеуді тұра ма?',
    handleSync: 'Ескерту: Панельдерді басқаруда қолмен синхрондеуді істеуге болады',
    noMoreTip: 'Дараамай ескерту',
    checkMore: 'Қосымша қарау',
    noHistory: 'Тарихқа сақталмаған деректер жоқ...',
    sameOrder: 'Өнім файлды экспорттаған тапсырыс бар, қайталап өнім шығаруға тықсуыдын ескерту!',
    markOrder: 'Тапсырыс бетінде өнімді белгілеу ма?',
    editErrTip: 'Көптеген тапсырысдерді ақпаратты өңдеуге қол жетімді емес',
    autoSaveSuccess: 'Автоматты түрде тарихқа сақталды!',
    goAdd: 'Қосу барады',
    noProductionLine: 'Бұл жазбаның өндірістік желісі жойылған, материалдар тізіміні қайтадан орнатуға болады',
    fileErr: 'Файл мазмұнын талдау сәтсіз, файл мазмұнын тексеріңіз!',
    noCheckData: 'Деректер табылмады!',
    noArrangeTip: 'Орнатуды тікелей қарауға болмайды, орнатуды бастауға таңдау!',
    tooOld: 'Алтыжақты бұрғылау орнотуы ескі',
    contactUs: 'Техникалық қызмет көрсетушімен байланысып, қайтадан орнату',
    pathErr: 'Панель ішінде абайлы деректер бар (панель нөмірі: {errorPathPlankID}), тексеріңіз!',
    sizeErr: 'Тақтада әдеттен тыс деректер бар, тексеріңіз! Кішкентай тақта өлшемі：{width}-{height}',
    noKnife: 'Кескіш діаметрі орнатылмаған, орама машинасына кескіш орнатуға барады!',
    noKnifeDiameter: 'Өндірістік желі кескіш пышағының ({name}) диаметрі бос, сәйкес пышақ диаметрін қосуға өтіңіз',
    openDifferentMaterialCuttingKnives: 'Өзгеше материал кескіш пышақтары қосылды',
    sendFactorySuccess: 'Үйіштерге тапсырыс беруді сәтті',
    sendFactoryErr: 'Үйіштерге тапсырыс беруді сәтсіз, техникалық қызмет көрсетушімен байланысып көмек сұраңыз',
    createTaskCard: 'Қайталап тапсырыс картасын yaratу ма?',
    surplusStatistics: 'Қолданылатын қалдық материалдар',
    surplusStatistics2: 'таңдалды',
    suplementStatistic: 'қосымшалар, жалған барлығымен қосымша тақталарымен бірге',
    expand: 'Кеңейту',
    packUp: 'Қайтарату',
    importErr: 'Дұрыс файл таңдаңыз!',
    sendLoadingText: 'NC файлін өңдеу және жіберуде...',
    arrangeLoading: 'Барлығы',
    arrangeLoading2: 'Шағын панельдердің орнатуын оңтайландыруда...',
    dealing: 'Өңдеуде...',
    deleteConfirm: 'Өшіргеннен кейін, қалдық материал қайта өңдеу жәшігіне жіберіледі. Бұл материалды өшіргіңіз келетініне сенімдісіз бе?',
    copyTip: 'Таңдалған қалдық материалды көшіру әрекеті орындалады',
    copyTip2: 'Көшіру қажет санды растаңыз',
    surplusHead: {
      shape: 'Көрінісі',
      type: 'Түрі',
      remark: 'Ескерту',
      area: 'Өлшем (м²)',
      area1: 'Өлшем'
      },
    surplusTip: 'Қолданылатын қалдық материалдар жоқ, алдын ала',
    creatSurplus: 'Қалдық материал жаңадан құру',
    orderInfo: 'Тапсырыс ақпараты',
    suplement: {
      statistic: 'Жалпы {total} پارça толықтырушы материал, {useable} پارча толықтырушы материалды бірге жіберуге болады, {selected} парча таңдалды',
      exportSuplement: 'Толықтырушы материалдар тізімін экспорттау',
      suplementLoading: 'Толуктырушы материалдар деректері жүктеледі',
      exportSuplementIng: 'Қосымша тізімді экспорттау',
      noMatchSup: 'Пайдаланылуға қолдау келтіретін қосымша деректер табылмады',
      exportTip: 'Экспорттау алдында кем дегенде бір қосымша таңдаңыз'
      },
    empty: 'Панельдердің деректері жоқ',
    paibanSetting: {
      title: 'Орнатуды орноту',
      createTask: 'Орнату тапсырысын құру',
      selectProduction: 'Өндірістік желі таңдау',
      arrangeWay: 'Орнату схемасы таңдау',
      suitText: 'Қолданылады：',
      surplusTrimTip: 'Ескерту: Сіз қалдық материалдар үшін теңшелетін кесу функциясын пайдаландыңыз, тек ара кесу орналастыруын таңдауға болады',
      suitEquipmentNormal: 'Қалыпты орама машина',
      suitEquipmentSpecial: 'Шыны кескіш машина, пісік кескіш машина',
      lessRoll: 'Аз айналдыру',
      computedSpecial: 'Кешелікті есептеу',
      specialTip: 'Төмен жылдамдық',
      irregularNesting: 'Анықтылықсыз Күміс',
      primaryNesting: 'Бастапқы Күміс',
      specialShapedPanel: 'Арнайы Шәке',
      limitedTimeTrial: 'Limited Free',
      seniorShape: 'Басшылық Шәке',
      heteromorphicInlay: 'Өзгеріс Шәке',
      autoCutSurplus: 'Қалдық материал автоматты кесу',
      cutWay: 'Кесу әдісі',
      maxRect: 'Ең үлкен тікбұрышты кесу',
      fixedRect: 'Фиксирленген өлшемге кесу',
      minRectSetting: 'Ең кіші өлшемге кесу',
      firstCutL: 'L-пішінді қалдықты бірінші орындау',
      firstCutLTip: 'Қосылған кезде шарттарға сай тікбұрышты парақтарды L-пішінді қалдыққа кесуді бірінші орынға қояды',
      shortLine: 'Қысқа жақ',
      longLine: 'Ұзын жақ',
      setDifferentThickness: 'Әртүрлі қалыңдықтағы тақталардың ең кіші кесу өлшемін орнату',
      defaultRuleTip: 'Тақта қалыңдығы ережеге сәйкес келмеген жағдайда, әдепкі ережеге сәйкес кесіңіз',
      panelThickness: 'Панель қалыңдығы',
      duplicateMinCutSize: 'Ағымдағы қалыңдықта бірдей ең кіші кесу өлшемі бар',
      templateEmpty: 'Әртүрлі қалыңдықтағы тақталардың ең кіші кесу өлшемін орнату үлгі деректері бос болмауы керек!',
      duplicateThicknessData: 'Әртүрлі қалыңдықтағы тақталардың ең кіші кесу өлшемін орнату үлгі деректерінде қайталанатын қалыңдық деректері бар!',
      atLeastOne: 'Ең болмағанда бір элемент сақталуы керек!',
      maxAddFive: 'Ең көп дегенде бес элемент қосуға болады!',
      surplusTemplate: 'Қалдық материалдардың жиі қолданылатын үлгілер',
      add: 'Қосу',
      templateErr: 'Үлгілердің кемісіңізді таңдаңыз',
      cutLong: 'Кесу ұзындығы',
      cutWidth: 'Кесу ені',
      baseInfo: 'Негізгі ақпарат',
      continue: 'Тастықтап, жалғастыру',
      standardSelect: 'Стандартты үлкен плитканы таңдау',
      customPlankOrder: 'Таңдауыңызша үлкен тақта бөлімдеу реті',
      customPlankOrderDetail: 'Жоқ болып тұрған кіші тақта тізімі',
      customPlankOrderTip: 'Ішке қосылған ауыл кеңістігі бұл функция үшін іске асырылмайды',
      customPlankOrderBrandTip: 'Бөлімдеуді күтіп тұрған тапсырыстарда бренд түсті карта тақталары бар, бұл функция әдепкі бойынша қосылады',
      surplusPlank: 'Қалып құрылған кіші тақта тізімі',
      overSizePlank: 'Үлкен өлшемді тақта нәрсесі тізімі',
      plankOrder: 'Бөлімдеу реті',
      plankType: 'Тақта түрі',
      plankSize: 'Тақта өлшемдері',
      plankEdgeOff: 'Қысқарту мәні',
      amount: 'Құрту саны',
      amountMax: 'Құрту саны максималды',
      numAndOverSizeTip: 'Кіші тақталар өлшемінен асып, үлкен тақталардың қолданған мөлшері жеткіліксіз, бөлімдеу мүмкін емес',
      numErrorTip: 'Үлкен тақталардың қолданған мөлшері жеткіліксіз, бөлімдеу мүмкін емес',
      overSizeTip: 'Кіші тақталар өлшемінен асып, бөлімдеу мүмкін емес',
      restPartList: 'Таңдалмаған кіші тақталар тізімі',
      layoutOrder: 'Орналастыру тәртібі',
      arrangeAmount: 'Кесу саны',
      specialShapeTip: 'Арнайы пішінді қалдық материалдар кесу орналастыруын пайдалана алмайды',
      surplusConflictTip: 'Қалдық материалдарды кесу панель контурымен қайшылықта, қайта кесіңіз',
      stackingMethod: {
        title: 'Тексеру әдісі',
        long: 'Ұзын қабырға бойынша төсеу',
        short: 'Қысқа қабырға бойынша төсеу'
        },
      seniorShapeTip: '【Қосымша қалыптау】Бос мүмкіндік мөлшері шектелген, сіз қалыптау нәтижесін қарауға болады (қалыптау өндірісін орындау үшін қалыптау өндірісін орындауға ауыса аласыз); егер сіз қосымша қалыптау өндіріс файлын шығару керек болса, сатушылармен байланысыңыз~'
      },
    filter: {
      title: 'Панельдерді сүзгілеу',
      search: 'Іздеу',
      all: 'Бәріні таңдау',
      diskSize: 'Тізімге жатқан тізім үстелінің кеңістігі пайдаланылған',
      resetFilter: 'Сүзгілеуді жою'
      },
    edit: {
      title: 'Көпшілікті өзгерту',
      target: 'Өзгерту объекті',
      onlineSelectRow: 'Тек таңдалған жолдар',
      allRow: 'Барлық жолдар',
      editKey: 'Өзгерту керектілігі',
      editValue: 'Өзгерту дегенде',
      warningTip: 'Ескерту: Өзгертуден кейін тесіктір мен кескіштер ауыстырады',
      allEdge: 'Барлық жағалар'
      },
    add: {
      title: 'Панельді қосу',
      continue: 'Тастықтап, жалғастыру',
      matCodeErr: 'Материалды код бос болмайды',
      thickErr: 'Қалыңдық бос болмайды',
      colorErr: 'Түс бос болмайды',
      longErr: 'Жабдықтардың ұзындығы бос болмайды',
      widthErr: 'Жабдықтардың ені бос болмайды',
      countErr: 'Саны кем дегенде 1 болуы керек'
      },
    delete: {
      tip: 'Бұл деректерді жоюдан кейін қалпына келтіруге болмайды, деректерді жоюға тастықтанасыз ба?',
      errTip: 'Бұл операцияны жасау үшін кем дегенде бір панельді таңдаңыз!',
      errTip1: 'Тексеру жасау үшін кем дегенде бір панельді таңдаңыз',
      confirm: 'Деректерді жою'
      },
    restore: {
      confirm: 'Қалпына келтіруді растау'
      },
    restoreConfirm: 'Қалпына келтірілгеннен кейін, қалдық материал қалдықтар тізіміне немесе қоймасына қайтарылады. Бұл қалдық материалды қалпына келтіруге сенімдісіз бе?',
    restoreBatchConfirm: 'Таңдалған қалдық материалдарды қалпына келтіргіңіз келетініне сенімдісіз бе?',
    save: {
      errTip: 'Сақтайтын деректер жоқ!',
      title: 'Схема сақтау',
      subTitle: '(Ескерту: Жабық сақтайтын деректер бір жылға сақтайды)',
      name: 'Схема атауы',
      historyName: 'Жабық схема',
      successTip: 'Сақтау сәтті!',
      fieldTip: 'Сақтау сәтсіз!'
      },
    exportErr: 'Панельдер жоқ, экспорттау мүмкін емес',
    exportPicErr: 'Панельдердің тесіктір шемасын экспорттау кезінде белгісіз хата كелді, бізбен хабарласыңыз',
    plankNotFound: 'Панельдерді таба алмады! Панельдерді сызуды тастықтайсыз ба?',
    noPlankName: 'Панельдің атауы табылмады',
    plankDataErr: 'Панельдердің деректері қателік бар, мұқият тексеріңіз, өндіріске залал келмесін дегенді қамтамасыз етуіңіз',
    exportThreeViewErr: 'Тесіктір шемасының үш көрінісіні экспорттау сәтсіз, техникалық қызметке хабарласыңыз',
    heighGlossWarning: 'Ескерту: Материалдың мазасы жоғары бағыты болған кезде, материалды өзгертудің кейін плақтарды мазадан көтеру мүмкін емес!',
    reset: 'Кез-келгенді қалпына келтіру',
    settingHead: {
      title: 'Кескіштердің тізімдіңіздің басты қисмы',
      head: 'Басты қисм',
      customHeadName: 'Жеке басты қисм атауы',
      example: 'Үлгі',
      tip: 'Қолдану сүзі: Басты қисмнің деректер таңбашасын сол жаққа немесе оң жаққа сүйретуге болады',
      headerNameEmpty: 'Тақырып бос болмауы керек',
      duplicateHeader: 'Қайталанатын тақырып бар'
      },
    copyLine: 'Төмендегіге тегін қоймасын шертуңыз',
    copySuccess: '{name} деректері копирілді',
    arranging: 'Жалпы {count} кіші кескіштің оптималдау қалыптасуда......',
    overSize: {
      title: 'Кескіштің өлшемі асыпты',
      subTitle: 'Өлшемі асыпты кескіштердің тізімі',
      overSizeTip: 'Кескіштің өлшемі асыпты туралы ескерту',
      nonWorkInfo: 'Өңдеуге болмайды кескіштердің деректері',
      mergeFrameDoorWholeTip: 'Өзіндік кескіштердің бірігуіне арналған кескіштердің бөлшектері',
      conflictWorkInfo: 'Қарама-қайшы тақтайшалардың бөлшектері',
      warning: 'Кіші кескіштердің өлшемі тым ұзын, қалыптастыруға болмайды! Кіші кескіштердің өлшеміні өзгертіңіз немесе тиісті өлшемдігіттіңіз қосыңыз',
      checkInfo: 'Кескіштердің деректеріні қараңыз',
      tipContent: 'Система кіші кескіштердің қалыптасуында өлшемі асыпты кескіштерді табады. Кескіштердің кеңді мен бейіктігіңізді өзгертеңіз, содан кейін табліцаның астындағы “Бірден қосу” батырмасын басып, қалыптасуды тездіріңіз немесе “Оригиналды кескіштер - Әрікеше кескіштер” дегенге кіріңіз және кескіштерді қосыңыз',
      add: 'Бірден қосу',
      addPlank: 'Оригиналды кескішті қосу',
      error: 'Кескіштің өлшемі асыпты, қалыптасу сәтсіз',
      successTip: 'Кескіштіңіз қосты! Қалыптасуда...',
      warningTip: 'Кескіштің кендігіңізді толтыруңыз!'
      },
    arrangeErr: 'Кескіштердің ішкі деректері асыпты, қалыптасу және өндірісуге болмайды',
    nonDelete: 'Жою мүмкін емес',
    addOverSizeTip: 'Үлкен өлшем бар, оны қайта қосыңыз.',
    addPlankSuccess: 'Арнайы тақта сәтті қосылды',
    addPlankFail: 'Арнайы үлкен тақта қосылмады',
    paibanFeedback: 'Панельдердің қалыптасуы',
    cuttingAndPaoban: 'Панельдердің қалыптасуы',
    lowUtilizationRate: 'Панельдердің қалыптасуы',
    unreasonableLayout: 'Панельдердің қалыптасуы',
    feedbackSuccessTip: 'Панельдердің қалыптасуы',
    feedbackFailTip: 'Панельдердің қалыптасуы',
    mixedLayoutScheme: 'Бұл қосылыстар схемасы'
    },
  arrangedPage: {
    subtleDownloadCheckTip: 'Тақта деректері өзгерген, бірақ жоспар сақталмаған. Кейінгі операцияларды жалғастыру үшін алдымен жоспарды сақтау үшін OK басыңыз',
    paibanRequestFailed: 'Жобалау сұранысы сәтсіз аяқталды, қайталап көріңіз',
    accordingPlankCountOrder: 'Үлкен тақталардың санына сәйкес жоғарыдан төменге қарай сұрыптау',
    editOrder: 'Реттік нөмірді өңдеу',
    dragOrder: 'Сұрыптау үшін сүйрету',
    inputOrder: 'Ретті енгізу',
    editOrderTip: 'Ретті реттеу',
    range: 'Ауқым',
    unsupportRotateTip: 'Кейбір тақталар айналдырылған, қайта орналастыру қазіргі уақытта қолдау көрсетілмейді. Айналдырылған тақта нөмірлері:',
    slotErrTip: 'Ағымдағы панельде жиекті өңдеу үшін ойықтар бар, қайта орналастыру қолдау көрсетілмейді!',
    lockedPaibanTip: 'Тақта құлыпталған, оны қайта орналастыру мүмкін емес.',
    batchBujianErrTip: 'Ағымдағы бөлшек бастапқы материалдар тізімі деректерінде жоқ, оны қайта жоспарлау үшін қосымша/жоспарлауды күтіп тұрған кітапханадан таңдауға болады',
    useFolderIsNot: 'Файлды жүктеу сақталатын орын "{type}" жоқ екені анықталды! Файлдың жойылғанын тексеріңіз. Егер USB дискісін пайдалансаңыз, оның дұрыс қосылғанын тексеріңіз',
    useFolderIsNot1: 'Файл жүктеу орнын орнатпағаныңыз анықталды, алдымен каталогты таңдаңыз',
    downloadNC: 'NC жүктеу',
    downloadNC1: 'NC файлын жүктеу',
    reArrange: 'Қалыптасуды қайтадан орноту',
    reArrangeSpecifiedMaterialGroup: 'Көрсетілген тақта топтарын қайта орналастыру',
    specifiedMaterialRelayoutMoreResultTip: 'Көрсетілген тақта топтары қайта орналастырылғаннан кейін, қосымша орналастыру нәтижелері ұсынылмайды',
    searchMaterialGroup: 'Тақта топтарын іздеу',
    saveToHistory: 'Тарихқа сақтау',
    moreSetting: 'Қосымша',
    cutIndexRe: 'ctrl+z қылып бұрынғы әрекетін қайтару үшін',
    followExportTag: 'NC жүктеу кезінде етикеттер файлды экспорттау',
    followExportPaibanImg: 'NC экспорттау орналасу файлын жүктеп алыңыз',
    followExportWorkerShop: 'NC импортты сатып алу тапсырысын жүктеп алыңыз',
    tagTemplateSelect: 'Етикеттер шаблонды таңдау',
    showCuttingSequence: 'Кесу sırасын көрсету',
    showPlankSize: 'Кіші кескіштің өлшемін көрсету',
    sendToFactory: {
      title: 'Өңдеу цехіне жіберу',
      fileType: 'Етикеттер файл түрі'
      },
    checkData: 'Деректердің толықтығын тексеру...',
    dataLoading: 'Жүктеу...',
    addToBujianStore: 'Қосымша қойым қойылымына қосу...',
    updateTaskStatus: 'Тапсырыс мәртебесін жаңарту...',
    sending: 'Цехке жіберу...',
    waitLoadding: 'Күтеу',
    loadding: 'Жүзеге асыру...',
    finish: 'Ақырындау',
    loadSetting: 'Қалайтын жүктеу',
    loadPreference: 'Арақашты жүктеу',
    dealTemplate: 'Шаблонды өңдеу',
    initTagData: 'Етикеттер деректерді ініциализациялау',
    prepareDrawData: 'Етикеттерді сызу деректерін дайындау',
    drawDataText: 'Белгілерді суреттеу деректері',
    genPdfTagFile: 'PDF етикеттер файлді генерау',
    genPicTagFile: 'Жапсырма кескін файлын жасау',
    uploadFile: 'Файлды жүктеу',
    dealNCFile: 'NC файлды өңдеу',
    zipFile: 'Жергілікті жип файлді генерау',
    plankCount: 'Өріктегіш кескіштердің саны',
    rollCount: 'Қайтадан орноту сан',
    totalRate: 'Жалпы оңтайландыру шығырлылыгі',
    rate: 'Оңтайландыру шығырлылыгі',
    useArea: 'Оңтайландырылған аудан',
    materialList: 'Материалдар тізімі',
    saveSurplus: 'Қалдықтарды қоймаға сақтау',
    workeShop: 'Сатып алу ордері',
    batchTagging: 'Тегтерді көлемді толықтыру',
    batchTaggingTip: 'Төмендегі панельдерді таңдап, таңбалау керек',
    holeSlotErr: 'Кескіштердің ішіндегі отындар мен саңылаулардің тереңдігінің асыптысы байқалды!',
    knivesErr: 'Пластина үшін өңдеу құралын табу мүмкін емес екені анықталды!',
    checkDetail: 'Егжектілікті қарау',
    deepErr: {
      title: 'Кескіштің отындар мен саңылауларінің тереңдігінің асыптысы',
      errStatistic: 'Кіші кескіштердің {count} жерінде асыптысы бар',
      errText: 'Асыптық бөлік',
      markErrPart: 'Асыптық бөлікті қоршау'
      },
    warningTip: 'Екі жақты өңделген глаукоз қаптамасы: алдымен глаукоз беті өңдеңіз, содан кейін матты бет өңдеңіз; Бір жақты өңделген глаукоз қаптамасы: тікелей матты бет өңдеңіз',
    showDetail: {
      tip1: 'Бір кескішті таңдау үшін бір рет шертіңіз',
      tip2: 'Кескіштің этикеттерін қараңыз'
      },
    arrangeTip: '(Қалыптасуды атайын пішімделгенді қолдайды)',
    plankOpration: 'Кескіштің операциясы',
    rotate: '90 градусқа айналдыру',
    notCare: 'Кескіштің текстури жоқ',
    editRemark: 'Ескертуді өңдеу',
    clearRemark: 'Ескертуді тазалау',
    recalcIndex: 'Кескіштің кесу орнын және кесу реттілігін қайта есептеу',
    recalcIndexSuccess: 'Түсіру нүктесін қайта есептеу және кесу тізбегін сәтті жүргізу',
    storageArea: {
      title: 'Кескіштердің айналма сақтау орны',
      empty: 'Кескіштердің айналма сақтау орны бос',
      storageTip: 'Кескіштерді осы орынға сүйретуге болады'
      },
    subtleArrange: 'Теккіл қалыптасу',
    addPlank: 'Өріктегіш кескішті қосу',
    deletePlank: 'Өріктегіш кескішті өшіру',
    deletePlankErr: 'Өріктегіш кескіштің кіші кескіштер бар, өріктегіш кескішті өшіруге болмайды!',
    useSurplus: {
      title: 'Қалдықтарды пайдалану'
      },
    dragWarning: 'Кескішті өріктегіш кескішке сүйретуңіз!',
    areaWarning: 'Кескішті орналастыруға болмайды, бос орынның көлеміне назар аударыңыз',
    subtlePage: {
      cut: 'Қалдықтарды кесу',
      lineTip: 'Егер кесудің қолмен орындалуы қате болса, ctrl+z арқылы алдыңғы кесу нүктесіне қайта оралуға болады',
      cancelCut: 'Кесуді тоқтату',
      cutPoint: 'Қалдықтарды кесудің сүйреу нүктесі',
      storageArea: 'Айналма сақтау орны',
      cutErr: 'Кесу тек өріктегіш кескіштегі болады, кіші кескіштерге жамау болмайды!',
      saveErr: 'Қалдықтарды кесу үшін бір кескіш таңдаңыз',
      cutErr2: 'Үлкен бағанада тексеру жасалады, бағанадан тыс қалмайды!',
      selectTip: 'Таңдаңыз түс қылу қалдық плақтар',
      noCutPath: 'Қалыпты бөлімдер қвадратты қиып алу мүмкін емес',
      cutOperate: 'қалайтын материалдарды қиып шығару әрекеті',
      line: 'қолмен қоршау',
      cutErrtip: 'Кесу нүктесінде қиылысу мәселесі бар, қайта кесіңіз',
      cutErrtip2: 'Кесу нүктесі нүкте шектеуін асып кетеді: 9, қайта кесіңіз'
      },
    shortCut: 'Қысқа шықымдар',
    updownRoll: 'Жоғары-төмен слайд',
    leftRightRoll: 'Сол-оң слайд',
    zoomScale: 'Чоңайту-кішірейту',
    dragCanvas: 'Бетті сүйрету',
    mouseRoll: 'Мышыңыздың роликтікі',
    mouseRight: 'Мышыңыздың оң батырмақ',
    doublePlank: 'Өріктегіш кескішті екі рет шақыру',
    keyboard: 'Клавиатура',
    picSymble: 'Сүретті белгі',
    funished: 'Жазық',
    holeSlotConflict1: 'Отындар мен саңылаулардың қақтығысы',
    plankErr: 'Кескіштердің қақтығысы',
    frontSlot: 'Алдыңғы жақта саңылау',
    backSlot: 'Артыңғы жақта саңылау',
    frontHole: 'Алдыңғы жақта отын',
    backHole: 'Артыңғы жақта отын',
    resetScale: 'Өлшемді қайта орноту',
    maxLong: 'Ең ұзын',
    tempErr: 'Қосу сәтсіз, шаблонның орналасуы дұрыс емес немесе шаблон тым үлкен!',
    sendErr: 'Цехке жіберу сәтсіз, тегіннің үлгісі мен плақ түзетілгені дұрыс па, содан кейін қайта жіберіңіз',
    someTips: 'Сіз бұлттық орналастырудың дұрыс емес қалдықтар/дұрыс емес кірістіру функциясын уақытша сынап жатырсыз, өндіріс мәселелерін болдырмауға назар аударыңыз!',
    nestingTips: '【Жетілдірілген дұрыс емес кірістіру орналастыру】 функциясының уақытша тегін сынақ мерзімі аяқталды. Жалғастыру үшін сату бөліміне хабарласып сатып алыңыз!',
    frameDoorTip: 'Құрамдас рамка қақпалары анықталды, қақпаны қайта өңдеу алдында қақпаны қабықшамен қаптау керек!',
    cutOrderErr: 'Кесу тәртібі дұрыс емес, қайдан кесетін нүктелер мен кесу тәртібін қайта есептеу үшін басыңыз!',
    holeSlotConflict: 'Тешик жойлашуы кескин: Борбордук панельде тешик жойлашуы же учак майдалары ажырады',
    exportSetting: 'Експорттау параметрлері',
    currentTagTemp: 'Ағымдағы тег үлгісі',
    specialPaibanErr: 'Плақтардан кейін көрсетілген белгілі мамандар бар, әрекетті қайта аспаптай алмас!',
    moreResult: 'Көбірек нәтиже',
    moreResultTip: 'Улуу панельде қырғау үшін шаруашылық бар, сондықтан улуу панель қайта орналастыруда қатысмайды',
    batchBujian: 'Жиынтықты толтыру',
    batchOperation: 'Жиынтық операция',
    batchEditPlankSize: 'Үлкен тақта өлшемін топтық өзгерту',
    editPlankSize: 'Өлшемді өзгерту',
    editWay: 'Өзгерту әдісі',
    editByType: 'Түрі бойынша өзгерту',
    editByPlankNumber: 'Тақта нөмірі бойынша өзгерту',
    editContent: 'Өзгерту мазмұны',
    editContentTip: 'Өзгертілуі керек үлкен тақта түрін таңдаңыз',
    editContentTip1: 'Өзгертілуі керек үлкен тақта нөмірін таңдаңыз',
    editStart: 'Басталуы',
    editEnd: 'Аяқталуы',
    bigPlank: 'Үлкен тақта',
    editSize: 'Өлшем өзгертілді',
    bigPlankWidth: 'Үлкен тақта ені',
    bigPlankHeight: 'Үлкен тақта ұзындығы',
    bigPlankLengthMarking: 'Үлкен тақта ұзындығының белгісі',
    markedAs: 'Белгіленген',
    maxAddTen: 'Ең көбі 10 элемент қосуға болады',
    minValue: 'Ең төменгі мән',
    differentKnifeErr: 'Әртүрлі кесу пышағы бар үлкен тақталар таңдалған, өлшемді өзгерту мүмкін емес',
    noEditablePlank: 'Өзгертуге жарамды үлкен тақта жоқ',
    skipBrandPlankTip: 'Таңдалған ауқымда өлшемді өзгертуді қолдамайтын {count} брендтік үлкен тақта бар, олар өткізіп жіберілді',
    nonBrandToBrandTip: 'Бұл шағын тақтаны брендтік түс картасы бар үлкен тақтаға сүйреуге болмайды!',
    brandToNonBrandTip: 'Бұл шағын тақтаны брендтік емес түс картасы бар үлкен тақтаға сүйреуге болмайды!',
    brandToOtherBrandTip: 'Бұл шағын тақтаны басқа брендтік түс картасы бар үлкен тақтаға сүйреуге болмайды!',
    editNo: '№',
    editAllPlank: 'Барлық үлкен тақталар',
    editBigPartSize: 'Үлкен тақта өлшемін өзгерту',
    disPlaySetting: 'Көрсету түрін тандау',
    stored: 'Жиі қойылды',
    onlySurplus: 'Тек қалдық',
    UnuseSurplus: 'Пайдалану коэффициенті қалған материалды есептемейді',
    usePlankAdsorption: 'Тақтайдың адсорбциялық функциясы',
    dataDefaultCollapsed: 'Дереккізді түсіндірілген деректер жабылған',
    unit: 'Единица',
    cutSurplus: 'Қалдықты кесу',
    frontWarningTip: 'Екі жаға өңдеу: Әріптің мәтінін аяқтап, сәтті өңдеу<span class="font-style">матты</span>, кейін<span class="font-style"> мәтін</span>ты өңдеу<span>; &nbsp; Бір жаға өңдеу: дәл<span class="font-style"> мәтінді</span> өңдеу',
    selectTip: 'Төмендегіде күнделікті жапқа қосу қажет плақтарды таңдаңыз',
    plankKeyWordPlaceholder: 'Плақтың атауын немесе нөмірін енгізіңіз',
    surplusStoreSuccess: 'Жапкан сәтті қойылды',
    editCutOrder: 'Кесу тәртібін өңдеу',
    setCutPoint: 'Қойым кесу нүктесін көрсету',
    specialPaibanChangeErr: 'Плақтардан кейін көрсетілген белгілі мамандар бар, әрекетті аспаптап алмас!',
    storedSuccess: 'Жапкан сәтті толтырылды! Таңдалған плақтар қосымша құрылымдықтарға қойылды!',
    noSurplus: 'Қол жетімді қалдық табылмады',
    selectErrTip: 'Қалдық плақтарды қосу мүмкін емес, тегін плақтарды таңдаңыз',
    noRoomIDTip: 'Осы плақтарда өнім ID жоқ, себебі қаптамаға қосу мүмкін емес, төмендегі плақтарды таңдаңыз',
    noPlank: 'Плақтар табылмады',
    noPaibanData: 'Аспаптама деректері жоқ, аспаптау мүмкін емес',
    historyNameErr: 'Құжат атын енгізіңіз',
    tempErrTip: 'Сіз бес / алты жаға жүйесін қолданбай алдыңғыдай өтінішті плақтар үшін шаблондарды қоспай қалдықтың әдепкі қосымша жұмыс жасауды қаламаймыз, ескертіп: қосу аяқталған кейін өтінішті аспаптап көріңіз',
    changeDataTip: 'Ескертіп көріңіз: деректеріңізде өзгерістер табылды, жаңа тарихтар файлын құру үшін үшін сақтаңыз',
    upgrade: 'Жаңарту',
    upgradeTip: ', төмендегі түймеге басып жаңартуға болады',
    plankOverEdge: 'NC файл жүктеу сәтсіз! Плақтардың бірінше көліңіз жақты олтандықта немесе плақтардың шеттерін тексеріңіз',
    useSurplusTip: 'Қалдықты кестеу керек пе',
    noDataExport: 'Експортталатын аспаптық деректер жоқ',
    noPlankExport: 'Експортталатын плақтардың деректері жоқ',
    lockTip1: 'Шығу үшін басыңыз, шығудан кейін бағанышты редакциялауға болады',
    lockTip2: 'Бағанышты плақтардың орны мен атрибуттарын редакциялау',
    unlockTip1: 'Басқанда блоктау, блоктағаннан кейін әлі өтілмейді',
    unlockTip2: 'қысқартының орны мен қасиеттерін түзету',
    plankLockErr: 'Бұл үлкен бағана құлыпталған, оны орналастыру мүмкін емес',
    lockPartEditTip: 'Плақтар құлыпталған, оларды редакциялау мүмкін емес',
    glassEquipmentTip: 'Өнім қуғыштық машинасы болған жағдайда плақтар жылжытпай алмайды',
    expandedTip: 'Панельді ойық өңдеу ерекше, өңдеу операциясы қолдау көрсетілмейді!',
    sameWidthPlankTip: 'Көліңіз жақты олтандықта өңдеу, өңдеу операциясы қолдау көрсетілмейді!',
    expandedArrangeTip: 'Панельде арнайы ойық жасау процесі бар, оны қайта орналастыру қажет!',
    dragErrTip: 'Орналастыру мүмкін емес, плақтардың материалын, түсін және міндеттілігін тексеріңіз!',
    subtleSaveTip: 'Ағымдағы аспаптарды өңдеу жасалды, бірақ сақталған жоқ, шығу керек пе?',
    rollTip: 'Үлкен бағандарда отвор/шығыс бар, торға бұрылуға ұсынылмайды!',
    glossRollErr: 'Сәнгі аспаптар торға бұрылмайды',
    lockDeleteErr: 'Плақтар құлыпталған, оларды жою мүмкін емес',
    deleteConfirmTip: 'Жою операциясы қайтарымсыз емес',
    deleteContinueTip: 'Сіз жалғасаңыз ба?',
    deleteConfirm: 'Жоюды растау қажет',
    selectPlankTip: 'Плақтарды таңдаңыз және осы әрекетті орындаңыз',
    storeFailTip: 'Қалдықтарды кестеу сәтсіз! Плақтардың бірінше көліңіз жақты олтандықта немесе плақтардың шеттерін тексеріңіз',
    repeatStoreErr: 'Ағымдағы кесілген қалдық плақтар алдында кестелген',
    surplusStoreFail: 'Кестеу сәтсіз! Плақтардың түрі және L-формасын тексеріңіз!',
    plankConfilictErr: 'Осы ауданға бағанышты орнатуға қолдау көрсетілмейді, ол тағы да плақтармен қайшылық пайдалайды',
    surplusErrTip: 'Мұнда нүктелер орнатуға қолдау көрсетілмейді, жарамсыз қалдық жасайды',
    changeArrageSuccess: 'Аспапты өзгерту сәтті',
    trialProduction: {
      trialProductionSample: 'Өндіріс алдындағы сынамалар шкафы',
      trialProduced: 'Сынақ өндірісін жүргіздім',
      trialWarning: '{fontStyleStart}Егер{fontStyleEnd} сіз өзіңізге, басқаларға және үлгі шкафтың өндірісін тексермеуіңізден туындаған бұлтты теру бағдарламалық жасақтамасына барлық шығындар мен қолайсыз салдарлар үшін ғана жауап бересіз',
      trialSlotTip: 'Түнімдеу жүктелгенде, түрлі қатынау жолағындағы таспа шараптарының өлшемін, ұзындығын, орналасқан жақтарын және орналасқан жерін тексеріңіз',
      trialSlotTip1: 'қабыздың түрлі түндетуін қалайп жатқызу',
      trialSlotTip2: 'Сұрақ',
      pleaseUploadTrial: 'Құрастырылған прототип шкафының суретін кері жүктеуіңізді сұраймын',
      uploadTrial: 'Үлгі шкафын кері жүктеу'
      },
    awaitPlankStore: {
      store: 'Тақтайшалар тақтай қоймасында орналасуға тиіс',
      notTip: 'Сақтауға қойылмағанын енді талап етпейді',
      justLookCurrent: 'Тек ағымдағы тапсырыс тақтасын қарап шығыңыз',
      notInPushStorage: 'Қордаланбаған',
      beInStorage: 'Қоймалау',
      searchPlaceholder: 'Түрге жататын кітапхана тақтасын іздеу үшін тапсырыс пішінін енгізіңіз',
      plankUploading: 'Тақтайша сақталуда',
      oneClickStorage: 'Реттелуі тиіс тақта кітапханасына сақтау орнын бір нұқу',
      notUsePlank: 'Кішкентай тақтайшалар жоқ',
      notPlank: 'Пластинка қойылымының болмауы',
      dragPlankInHere: 'Тақтайшаларды тақтай қою үшін осында апаруға болады',
      surplusCannotBeStorage: 'Қалдықтар сақтауға қойыла алмайды',
      plankHasBeenDeduction: 'Шағын тақта шегерілді немесе бастапқы деректер жоқ және қоймада сақтала алмайды',
      plankLoadErr: 'Тақта ақпараты жүктелмеді',
      taskTitle: 'Пластиналарды типтес болу үшін кітапханаға кері жүктеу',
      dataGenErr: 'Деректерді генерациялау қателері',
      pushSuccess: 'Қоймалау сәтті өтті',
      pushErr: 'Белгісіз қате орын алды және қоймалау жаңылысы',
      awaitBoxExistPlank: 'Егер дестелеу мүкәммалы сақтауға қойылмаған шағын тақтада болса, қоймадан кейін пайдалану ұсынылады',
      mergeFrameDoorWholeTip: 'Өзіндік кескіштердің бірігуіне арналған кескіштердің бөлшектері',
      checkPlankStatus: 'Басқарманың мәртебесін есептеу...'
      },
    batchSetCut: 'Топтық кесу нүктелерін орнату',
    applyTo: 'Қолдану:',
    ncDownloadLifeText: {
      checkData: 'Деректерді тексеру',
      checkDone: 'Деректерді тексеру аяқталды',
      checkDataText: 'Деректерді анықтау',
      loadSetting: 'Параметрлерді жүктеу',
      settingLoadDone: 'Параметрлер жүктелді',
      loadSettingText: 'Деректерді анықтау',
      downloadNc: 'NC жүктеу',
      ncDownloadDone: 'NC жүктеу аяқталды',
      downloadText: 'NC жүктеп алу',
      loadPreferenceSetting: 'Қалаулы параметрлерді жүктеу',
      PreferenceSettingLoadDone: 'Қалаулы параметрлер жүктелді',
      loadPreferenceText: 'Қалауларды жүктеу',
      dealTemp: 'Үлгіні өңдеу',
      TempDealDone: 'Үлгіні өңдеу аяқталды',
      dealTempText: 'Үлгіні өңдеу',
      beBeingGenTagFile: '{fileType} файлын жасау',
      genTagFileDone: '{fileType} файлы жасалды',
      genTagFileText: '{fileType} файлын жасау',
      zip: 'Жергілікті сығылған файлды жасау',
      zipDone: 'Жергілікті сығылған файл жасалды',
      genZipText: 'Сығылған файлды жасау',
      fileTypeText: 'Сурет'
      },
    surplusCommonTemp: 'Қалған жалпы үлгі',
    plankErrTip: 'Ағымдағы материал жоспары бойынша кіші тақтайшаны орналастыруға жарамды үлкен тақтайша жоқ!',
    brandPlankErrTip: 'Ағымдағы материал жоспарында орналастыруға қолжетімді бренд тақтасы жоқ бренд бөлшектері бар!',
    overSizeTip: 'Үлкен тақталардың саны жеткіліксіз немесе өлшемі үлкен',
    uselessPart: 'Ағымдағы үлкен тақтада пайдалануға жарамды шағын тақта жоқ, қайта орналастырыңыз',
    splitArranged: 'Кішкене тақталар тым көп, қайта орналастырыңыз немесе топтап орналастырыңыз',
    arrangedErrTip: 'Үлкен тақталардың жеткіліксіздігі немесе шағын тақталардың үлкендігі салдарынан орналасу сәтсіз аяқталды',
    knivesModalTitle: 'Тесік ұясы бар және құралды табу мүмкін емес',
    cannotDownloadByKnivesErr: 'NC жүктеп алу мүмкін болмаса, жүйе келесі тесіктер мен ұяларды анықтайды және құралды таба алмайды.',
    viewPart: 'Мәселелер тақтасын қараңыз',
    deductionModalTitle: 'Тындау объектін таңдаңыз',
    bujianDeduction: 'Тындау жоламаға кіші платка',
    paibanDeduction: 'Тындау уақытша сақтау аймағының кіші платка',
    surplusDeduction: 'Қалысқы материалдарды тындау үлкен платка',
    unlockPaiban: 'Тypes жүйесіне қосылған қалысқы материалдардың блоктауды алып тастау',
    maintain: 'Тypes жүйесіне қосылған қалысқы материалдардың блоктауды сақтау',
    lockModalText: 'Қалысқы материалдардың үлкен платкаға қосу түрде басқа тапсырыстармен арналған, тypes жүйесін қайта жасау керек пе',
    lockNewSModalText: 'Ағымдағы қалысқы материалдардың үлкен платка басқа тапсырыстармен арналған, NC-файлдарды жүктеп алуды жалғастыру керек пе',
    rePaibanWarn: 'Қалысқы материалдардың үлкен платка басқа тапсырыстармен арналған, қолжетерлік үлкен платка жеткіліксіз, ашу жайлық тізіміне қайта types жасау үшін қарай',
    sawRePaiban: 'Аларым беріңіз: Сіз құрыш дәңгейіні қолданудасыз, қайшылық плиттардың түрлі құрылымын қосдыңыз, NC файлды жіберу үшін қайта түрлендіру керек',
    togglePlankTip: 'Тақтайда арнайы ойық жасау процесі бар, алдыңғы және артқы жағын ауыстыруға болмайды!',
    stepCuttingMsg: 'Қабаттап кесу тереңдігі тақтаның қалыңдығынан кіші болуы керек',
    stepCuttingMsg2: 'Қабаттап кесу тереңдігі тек 0-ден үлкен сан болуы керек',
    flipPlankTip: 'Қалысқы материалдардың үлкен платка басқа тапсырыстармен арналған, қолжетерлік үлкен платка жеткіліксіз, ашу жайлық тізіміне қайта types жасау үшін қарай',
    genNoCutTagNotSupportExportPic: 'Кесілмеген тег қосу қосылған, сурет экспорттау қолдау көрсетілмейді',
    allSmallPlanksAreNoCutNotInLayout: 'Барлық кіші тақталар кесілмеген тақталар және орналастыруға қатыспайды',
    canStillExportHoleSlotOrPrintTag: 'Сіз әлі де тесік пен ойық өңдеу файлдарын экспорттауға немесе тегтерді басып шығаруға болады',
    desMaterialNoCutNotSupportSwitchLine: 'Ағымдағы өндіріс желісі көрсетілген кіші тақта материалын кесілмеген ретінде қосқан, тікелей желі ауыстыру қолдау көрсетілмейді',
    desMaterialNoCutSettingChanged: 'Жүйе көрсетілген кіші тақта материалын кесілмеген параметрлерінің өзгертілгенін анықтады, өндірістің дәлдігін қамтамасыз ету үшін қайта орналастырыңыз',
    continueDownload: 'Жүктеуді жалғастыру',
    desMaterialNoCutErrorTip: 'Белгіленген кіші тақтай материалы кесілмеген тақтайларда ою машинасына берілген тесіктер/оңықтар/бітік пішіндер бар. Осы жүктемедегі барлық тесіктер/оңықтар/бітік пішіндер бес/алты жақты бұрғылауға берілген. Файлды жүктеуді жалғастырғыңыз келе ме?',
    clearReuseRelation: 'Қайта пайдалану байланысын тазалау үшін басыңыз',
    layoutReuseTip: 'Үлкен тақта орналасуын тез көшіру; тақта өзгергенде қайта пайдалану байланысы автоматты түрде жойылады',
    hasBeenReused: 'Қайта пайдаланылған',
    layoutReuse: 'Орналасуды қайта пайдалану',
    specialProcessNotSupported: 'Тақтада арнайы процестер бар, бұл операция қолдау көрсетілмейді',
    conflictNotSupported: 'Тақта қақтығысы бар, бұл операция қолдау көрсетілмейді',
    noAvailablePlankForReuse: 'Қайта пайдалануға болатын тақта жоқ',
    noMatchingPlankFound: 'Сәйкес тақта табылмады',
    reuseBoard: '{number} қатарындағы тақта қайта пайдалану',
    influenceTip: {
      title: 'Оңтайландыру шығырлылыгіне әсер ететін функциялар',
      empty: 'Жоқ',
      groupParams: 'Орналастыру параметрлері',
      surplusNoRoll: 'Артық материал аудармалаусыз',
      surplusCustomTrim: 'Жеке шеттеу мәні',
      otherPlateCustomTrim: 'Арнайы тақтаның жеке шеттеу мәні',
      knifeDiameter: 'Кесуші қаттың диаметрі',
      surplusNoFlip: 'Артық материал аудармалаусыз',
      surplusNotLayout: 'Артық тақтаның белгілі тақтасыз құрастыру',
      plankEdgeOff: 'Шеттеу',
      surplusCustomTrim2: 'Қалдықтарды қайта құрастыру',
      other: 'Әсер етуі мүмкін басқа функциялар',
      enabled: 'Іске қосылған',
      plankThicknessStacking: 'Тақта қалыңдығы қайта құрастыру',
      edgePreMilling: 'Тақта қабырғасын қайта құрастыру',
      multiMaterialCuttingBlade: 'Көп материалды қайта құрастыру',
      sawSpecialShapePart: 'Аралау және ою машиналарына арналған пішінді ойықты тақталар',
      longPlankCutting: 'Ұзын тақта екінші өңдеу'
      }
    },
  paibanImg: {
    title: 'Макет басқару',
    exportCustomPaibanImg: 'Пайдаланушы таңдаған макет суретін экспорттау',
    customPaibanImg: 'Жекелей реттелген кескін',
    isCustomName: 'Жекелей реттелген кескін аты',
    template: 'Құрастыру схемасының шаблоны',
    addTem: 'шаблон қосу',
    canvasIndexSearch: 'Бақтанын нөмірін іздеу',
    symbol: 'Қойын басылымын көрсеткіштері',
    frontSlot: 'Қарсы шығанақ',
    backSlot: 'Теріс шығанақ',
    frontHole: 'ең қарсы құбыр',
    backHole: 'Артқы жарқырау',
    printNum: 'Бір парақ қағазды ең көп көрсету',
    printUnit: 'Бір парақ орналастыру сызбасы',
    edit: 'Орналасу үлгісінің өңдеуі',
    temName: 'Үлгі атауы',
    rotate: 'Типографиялық айналу',
    showOverflow: 'Мәтін тақтадан асып кеткенде, сәйкестендіру жолы тақта деректерін көрсетеді',
    showHoleSlot: 'Тесік және ұяшық ақпаратын көрсетеді',
    bigPartCss: 'Үлкен тақтаның орналасу стилін реттеу',
    partCss: 'Шағын тақтаның орналасу стилін реттеу',
    addTemTip: 'Ең көбі 10 теру үлгісін қосуға болады!',
    exportTip: 'Экспорттау үшін кем дегенде бір орналасу үлгісін белгілеңіз!',
    editSaveTip: 'Сақтау алдында барлық қажетті заттардың толтырылғанын растаңыз!',
    exportDXF: 'DXF экспорттау',
    exportDxfGeneral: '2D жалпы DXF',
    exportDxf3d: '3D арнайы DXF',
    exportDxfGeneralTip: 'Қолмен өңдеуге, сызба бойынша кесуге немесе орналастыру нәтижесін тексеруге жарайды',
    exportDxf3dTip: 'Өндіру үшін үшінші тарап жүйелеріне импорттауға жарайды; Huiya лазерлік кесу біріктірілген станоктарына қолдау көрсетіледі'
    },
  historyPage: {
    matchErrBySpecialTip1: 'Келесі арнайы тақталар сәйкес келетін элементтерді таба алмайды, макет бетінде қайта макет жасауда мәселелер болады',
    specialPlankInfoErrTip2: 'Арнайы тақта туралы ақпарат алуда қате, бұл макет бетінің қайта макет функциясына әсер етеді',
    download: 'Жергілікті жүктеу',
    allType: 'Барлық сақтау',
    handleSave: 'Қолмен сақтау',
    specialPlank: 'Қарапайым',
    surplusPlank: 'Қалдық',
    autoSave: 'Автоматты сақтау',
    allArrange: 'Барлық қалыптасу',
    searchPlaceholder: 'Тапсырыс атауы / басып шығару топтамасы / тапсырыс нөмірі бойынша іздеу',
    saveHistoryName: 'Сақталған тарих атауы',
    trailProduction: {
      title: 'Сынақ өндіріс үлгі шкаф',
      lastTime: 'Ақырғы сынақ өндіріс күні',
      recordList: 'Сынақ өндіріс жазбалары',
      start: 'Сынақ өндірісін бастау',
      date: 'Уақыт',
      outputFrom: 'Шығу орны',
      empty: 'Деректер жоқ',
      record: 'Жүктелген сынақ өндіріс үлгі шкаф суреттерінің жазбалары',
      tip1: 'Назар аударыңыз: Қазіргі сынақ өндірісі тапсырысы әдепкі өндірістік деректерді пайдаланады',
      tip2: 'Назар аударыңыз: Қазіргі сынақ өндірісі тапсырысы ең соңғы технологиялық параметрлерді пайдаланбайды, сынақ өндіріс бөлмесіне өтіп, қайта сақтауға болады!',
      download: 'Өңдеу файлын жүктеу'
      },
    deleteTip: 'Толық тарихи жазбаларды жоюға жоспарлануда мұрайсыз ба?',
    startDate: 'Басталу күні',
    endDate: 'Аяқталу күні',
    lastWeek: 'Соңғы апта',
    lastMonth: 'Соңғы ай',
    lastSeason: 'Соңғы үш ай',
    toArrangePage: 'Тәртіп бетіне өту',
    notArrangedTip: 'Бұл жазбада тәртіп жасалмаған, алдымен материалдар тізіміне өтіңіз!',
    toMaterialPage: 'Материалдар тізімі бетіне өту',
    lessSelectTip: 'Бұл әрекетті орындау үшін кем дегенде бір жазбаны таңдаңыз',
    downloadNc: 'Өңдеу файлын жүктеу'
    },
  workShopPage: {
    warningTip: 'Бұл функциясы уақытша сынақты, тапсырыс өндірісінің рационалдықтыны қамтамасыз етіңіз!',
    fileManager: 'Өндіріс файлдарын басқару',
    selected: 'таңдалды',
    suplement: 'Қосымша бөлшектер қоймасы',
    size: 'Өлшем',
    saveToStore: 'Қосымша бөлшектер қоймасына қосу',
    enterArrange: 'Түзетуге кіріп жатыр...',
    deleteTip: 'Бұл деректерді жоюдан кейін олар қалпына келтірілмейді, деректерді жоюға жоспарлануда мұрайсыз ба?',
    arrangeTip: 'Қосымша бөлшектерді талдайды, ұсталыңыз...',
    store: 'Қосымша бөлшектер қоймасы',
    downloadFile: 'Өнім файлын жүктеу',
    notBujianFile: 'Қосымша файл табылмады',
    productLineDelete: 'Бұл өндірістік желі жойылды, NC файлын жүктеу мүмкін емес!'
    },
  basePlankManager: {
    saveTip: 'Ескерту: Қайта басу арқылы сақтау',
    offsetSize: 'Кескіштің өлшемі',
    overSizeTip: 'Өлшемі тым үлкен болған кезде, автоматты түрде үлкен өлшемді кескіштің қалыптасуын таңдайды',
    addTip: 'Қалыптасу кезінде кескіштің өлшемі тым үлкен болса, автоматты түрде арнайы үлкен кескіштің қосу диалогтық пенересісіні ашады',
    defaultOversizePlankValue: 'Үлкен өлшемді арнайы кескіштің үлкен өлшемін автоматты түрде таңдауды орнатыңыз',
    onlyLayoutTooBig: 'Тек үлкен өлшемді панельдер үлкен өлшемді кіші панельдер үшін орналастырылады',
    settingRemark: 'Ескертпе: Мұндағы бастапқы функция оң жақтағы параметрлерге реттеледі.',
    searchPlaceholder: 'Кескістің матеріал/түсті іздеу',
    syncData: 'Шкафтардың деректерін синхрондау',
    syncDataM: 'ئىشىك قابىلىقىنى ماس قىلىش',
    deletePlank: 'Арнайы үлкен кескіштің жою',
    addPlank: 'Жаңа арнайы кескіштің құру',
    matCodePlaceholder: 'Кескістің матеріалін таңдаңыз',
    thickPlaceHolder: 'Кескістің қалыңдығын таңдаңыз',
    widthErr: 'Кескістің ені бос болмау',
    heightErr: 'Кескістің ұзындығы бос болмау',
    matCodeErr: 'Кескістің матеріалы бос болмау',
    colorErr: 'Кескістің түсі бос болмау',
    editPlank: 'Кескістің өңдеу',
    deleteTip: 'Бұл деректерді жоюдан кейін олар қалпына келтірілмейді, деректерді жоюға жоспарлануда мұрайсыз ба?',
    plankKnifeSelect: 'Оригиналды кескістің кесу пышағыны таңдаңыз',
    plankKnifeSelectTip: 'Панель элементі бірнеше қауіптерге сейімленгенде, панельдің толығының ағымдылығы панель материалынан жоғары болады',
    knifeSelectTip: 'Ескерту: Ішкі қалыптасуда осы функция қолданылмайды',
    knife: 'Кесу пышағы',
    matcodeInput: 'Кескістің матеріалын енгізіңіз',
    thickInput: 'Кескістің қалыңдығын енгізіңіз',
    default: 'Системаның әдеттісі',
    unessential: 'Бұл бағаны: міндетті емес',
    emptyTip: 'Ескерту: Бұл бағаны толтырмау кезде оригиналды кескістің сәйкестігін бос қалдырылады!',
    defaultUse: 'Әдеттісімен таңдаңыз',
    editMatcode: 'Матеріалын өңдеу',
    syncTip: '{fromMc} деректерін аліп, қазіргі болмашы кескістің басқару деректеріне ауыстырады, синхрондауды жоспарлануда мурайсыз ба?',
    sameErr: 'Бұл деректердің оқшаш деректері бар',
    cancelDelete: 'Жоюді тоқтатты',
    syncErr: 'Синхрондау сәтсіз',
    syncSuccess: 'Синхрондау сәтті',
    syncDataTip: '${fromMc} деректерін синхрондау',
    editErrTip: 'Толтырмау деректер бар, тексеріңіз!',
    numberCheck: '{type} тек сан кіргізілуі тиіс!',
    deleteStandardPlate: 'Стандартты тақтаны жояды',
    createStandardPlate: 'Жаңа стандартты тақтайшалар',
    editStandardPlate: 'Стандартты тақтаны өңдеу',
    trimmingDimension: 'Жиегін кесу өлшемі',
    front: 'жоғары ',
    back: 'төмен ',
    left: 'сол ',
    right: 'оң ',
    frontTrim: 'жоғары өңдеу',
    backTrim: 'төмен өңдеу',
    leftTrim: 'сол жақ өңдеу',
    rightTrim: 'оң жақ өңдеу',
    customTrim: 'өңдеу мәні таңдауыңызша',
    trimValue: 'өңдеу мәні',
    notEmpty: '{type} бос болуы мүмкін емес!',
    edgeDir: 'өңдеу ({type})',
    brandPlank: 'Бренд тақтасы',
    brandPlankTip: 'Ескерту: Бренд тақталарын жою және өзгерту Cabinet клиентінің тақта ресурс кітапханасында орындалады',
    brand: 'Бренд',
    supplier: 'Жеткізуші',
    brandPlaceholder: 'Бренд таңдаңыз',
    supplierPlaceholder: 'Жеткізуші таңдаңыз',
    brandInput: 'Бренд енгізіңіз',
    supplierInput: 'Жеткізуші енгізіңіз',
    addBrandPlank: 'Бренд тақтасын қосу',
    deleteBrandPlank: 'Бренд тақтасын жою',
    editBrandPlank: 'Бренд тақтасын өңдеу',
    searchBrandPlaceholder: 'Бренд/жеткізуші/материал/түс іздеу'
    },
  bujianAndStore: {
    bujianStore: 'Қосалқы бөлшектер қоймасы',
    awaitStore: 'Тақтайларды орналастыруды күту қоймасы',
    depositAwaitStore: 'Орналастыруды күту қоймасына сақтау',
    pushToAwaitStore: 'Орналастыруды күту қоймасына салу',
    useTwoTableArrange: 'Екі кестені пайдаланып орналастыру',
    confirmUseTwoTableTip: 'Ағымдағы таңдалған шағын тақтайлар қосалқы бөлшектер қоймасы мен орналастыруды күту қоймасынан тұрады. Орналастыруды жалғастыруды қалайсыз ба?',
    confirmAddPlankToAwaitStore: 'Таңдалған тақтайларды орналастыруды күту қоймасына қосуға сенімдісіз бе?',
    pushStoreSuccess: 'Қоймаға сәтті қосылды',
    dataGenErr: 'Деректерді жасау қатесі',
    unknownErr: 'Белгісіз қате пайда болды, қоймаға қосу сәтсіз аяқталды'
    },
  surplusPage: {
    surplusMaterial: 'Қалған материалдар тізімі',
    surplusStore: 'Қалған материалдар қоймасы',
    recycleBin: 'Қалған материалдардың қалдықтары',
    recycleBinTip: 'Қалдық материалдар деректері қалдықтар жәшігіне салынғаннан кейін 90 күн өткен соң автоматты түрде жойылады',
    "deleteReason-0": 'Қолмен жою',
    "deleteReason-1": 'Беттеу шегерімі',
    "deleteReason-2": 'Guigui мобильді операция арқылы қоймадан шығару',
    surplusShape: 'Қалған материалдардың пішіні',
    batchTransfer: 'Жаппай ауыстыру',
    createNewSurplusStore: 'Жаңа қалған материалдар қоймасын құру',
    pushStoreSetting: 'Қалған материалдарды сақтау параметрлері',
    surplusStoreName: 'Қалған материалдар қоймасының атауы',
    surplusStoreName2: 'Қалған материалдар қоймасының атауы',
    addSurplusStore: 'Қалған материалдар қоймасын қосу',
    inventoryCeiling: 'Қойма шегі',
    autoTransferTip: 'Жойылғаннан кейін, қоймадағы қалған материалдар автоматты түрде қалған материалдар тізіміне ауыстырылады',
    asIndexPushStore: 'Қойманың сақталу жағдайына сәйкес тәртіппен сақтау',
    pushToSurplusMaterial: 'Қалған материалдар тізіміне сақтау',
    surplusStoreTable: {
      number: 'Нөмір',
      name: 'Қалған материалдар қоймасының атауы',
      quantity: 'Сақталған қалған материалдар саны (дана)',
      capacity: 'Қалған материалдар қоймасы шегі (дана)',
      rules: 'Қалыпты құрама жинақтау ережелері',
      remark: 'Ескертпе',
      operation: 'Операция'
      },
    editSurplusStore: 'Қалған материалдар қоймасын өңдеу',
    addSurplus: 'Қалдықтарды қосу',
    importSurplus: 'Қалдықтарды импорттау',
    downloadSurplusTemplate: 'Қалдықтарды импорттау мәндемесін жүктеп алу',
    batchExportSurplus: 'Қалдықтардың бүкіл тізімін шығару',
    surplusBatchImportExport: 'Қалдықтарды импорттау/шығару',
    surplusMaterialStorageCode: 'Артық материал сақтау коды',
    generateQRCodeSuccess: 'QR код сәтті жасалды',
    generateQRCodeFailed: 'QR код жасау сәтсіз аяқталды',
    refreshQRCode: 'QR кодын жаңарту',
    refreshQRCodeFailed: 'QR кодын жаңарту сәтсіз аяқталды',
    cancelRefresh: 'Жаңарту жойылды',
    refreshQRCodeTip: 'QR кодын жаңартқыңыз келе ме? Жаңартудан кейін ағымдағы QR код жарамсыз болады.',
    refreshQRCodeConfirm: 'Растау',
    refreshQRCodeCancel: 'Болдырмау',
    wechatScanTip: 'Артық материалды қолмен сақтау үшін WeChat ашып QR кодын сканерлеңіз',
    deletSurplus: 'Қалдықтарды жою',
    editSurplus: 'Қалдықты өзгерту',
    surplusNoRoll: 'Қалдықтарды қайтадан кесуді іске қосу',
    type: {
      all: 'Барлық пішіндер'
      },
    allMatcode: 'Барлық матеріалдар',
    allThick: 'Барлық қалыңдықтар',
    surplusName: 'Қалдықтар атауы',
    rectSurplus: 'Тікбұрышты қалдық',
    LTypeSurplus: 'L-тәрізді қалдық',
    noMatchSup: 'Қатысты деректер табылмады',
    jumpTo: 'Өту',
    page: 'Бет',
    newMatcode: 'Жаңа материал жасау',
    newColor: 'Жаңа түс жасау',
    autoCreateColor: 'Enter батырмасын басқанда автоматты түрде түстік карта жасалады',
    nameLimit: 'Қалдық атауы ең көп дегенде 10 таңбадан тұруы мүмкін',
    nameLimitNameErr: 'Қалдық атауы бос болмауы керек',
    tempLongTip: 'Тақтай ұзындығы тек сандардан тұруы керек',
    minLongLimit: 'Қысқа жақ ұзындығы тек сандардан тұруы керек',
    minLongEmptyTip: 'Қысқа жақ ұзындығы бос болмауы керек',
    minLongLimitMax: 'Қысқа жақ ұзындығы тақтай ұзындығынан аспауы керек',
    widthLimit: 'Тақтай ені тек сандардан тұруы керек',
    minWidthLimit: 'Қысқа жақ ені тек сандардан тұруы керек',
    minWidthEmptyLimit: 'Қысқа жақ ені бос болмауы керек',
    minWidthLimitMax: 'Қысқа жақ ені тақтай енінен аспауы керек',
    thickLimit: 'Тақтай қалыңдығы тек сандардан тұруы керек',
    thickEmptyLimit: 'Тақтай қалыңдығы бос болмауы керек',
    countInputLimit: 'Саны оң бүтін сан болуы керек',
    countEmptyLimit: 'Саны бос болмауы керек',
    remarkMaxlimit: 'Ескертулер ең көп дегенде 50 таңбадан тұруы мүмкін',
    orderAddressMaxlimit: 'Дереккөз тапсырыс мекенжайы 100 таң',
    orderIdMaxlimit: 'Дереккөз тапсырыс нөмірі 100 таң',
    createTime: 'Thời gian thêm',
    deleteTime: 'Silinme vakati',
    deleteReason: 'Silinme səbəbi',
    branchName: 'Kho dư liệu',
    orderAddress: 'Дереккөз тапсырыс мекенжайы',
    orderId: 'Дереккөз тапсырыс нөмірі',
    lockStatus: 'блоктау күйі',
    lockOrder: 'тапсырысты блоктау',
    enableSurplusLock: 'Қалысқан материалдарды бұғаттау функциясын іске қосу',
    isCloseSurplusLock: 'Функцияны өшірілгеннен кейін барлық қалысқан материалдар бұғатталып тасталады, жалғастырмақсыз ба',
    confirm: 'Жауапты түрде жабу',
    surplusTransfer: 'Қалысқы материалдарды түрлендіру',
    targetSurplusStore: 'Мақсатты қалысқы материалдар қоймасы',
    enableSurLockTip: 'Активация алдында, әрбір нүктелікте қолданылатын қалдырылған материалдар бұған түрде блокталады, басқа тапсырмалар оларды алмауға тырысады',
    addMainRule: 'Негізгі قانونды қосу',
    surplusRules: 'Қалыпты құрама барысындау ережелері',
    mainRulesTip: 'Негізгі قواعد аралығында ‘немесе’ қосылым бар, ж.ә. бір негізгі قواعды тығықтық алса, қалдық материалдар қоймасына кіретін болады',
    mainRulesTip1: 'Күйін қосулынан кейін, күйіне сәйкес келген қалдырылған материалдар бұл қуелгаға негізгі реттеуінде сақталады, ол қуелга толық болған соң, басқа бос қалдырылған материалдар қуелгасына сақталады',
    rule: 'қағида',
    addSubRule: 'Өріктік түрдеңізді қосу',
    subRuleTip: 'Өрістер арасыnda және қатыстығы бар, т.е. барлық және шарттардың барлығын тұйықтықта тұрғанда ғана қойылып, жинаққа қосылады',
    bigPlankMatCode: 'Үлкен плитка материалы',
    bigPlankThick: 'Құдыр пінді',
    bigPlankColor: 'Құрылғының түсі',
    greaterEqual: 'жоқық үшін де',
    lessEqual: 'кем дегенде жақсы қалады',
    capNumberCheck: 'Склад асайының жоғарғысы жолық саның енгізілуі керек!',
    capEmptyCheck: 'Складдың шегі жоқ бола алмайды!',
    surNameEmptyCheck: 'Қалып жатық атауы бос бола алмайды!',
    mainRuleLimit: 'Негізгі قانونның шегіне қарайды',
    delMainRuleTip: 'Бұл мәнін өшіру керек пе, жоқ па',
    matCodeEmptyCheck: 'Дайна платформасының материалы бос болуы мүмкін емес!',
    thickEmptyCheck: 'Дайына қалыңдығы бос болуы мүмкін емес!',
    textureEmptyCheck: 'Дайна көрінісі бос болуы мүмкін емес!',
    enableWarehouseSecondCon: 'Қалыпты құрамының реттеуін қайта растауды іске қосу',
    surplusWarehouseConfirm: 'Қалыпты құрамының рұқсатты түсіну',
    surplusWarehouseConfirm1: 'жинақтауды растау',
    closeSurplusConfirm: 'Хранение тіркелуін растауын сөндіру (қалайпын басқару бетінде қайта қосуға болады)',
    position: 'Қалыпқа жатық орны',
    nameRepeatTip: 'Бұл қалдықтың атауы бар болып тұр, өзгертіп, қайта сақтаңыз',
    surLimitTip: 'Ағымдағы қалдық қоймасы шекті мөлшерге жетті немесе кіріс көрсеткіштеріне сәйкес келмейді',
    surFailTip: 'Кіру сәтсіз болды, қалдықтар атауы қайталанады немесе қалдықтар сағына сақтау шегіне жетті немесе кіру ережелерін қанағаттандырмайды',
    surplusExistTip: 'Бір қатар қалдық материалдар қоймасында бар, бұл әрекет сәтсіз болды',
    surplusExistTip2: 'Қалдық материалдар қоймасында бар, бұл әрекет сәтсіз болды',
    currentPage: 'Қазіргі бет',
    totalPage: 'Барлығын таңдау'
    },
  printPage: {
    goto: 'Дереу бару',
    surplusSizeTittle: 'Қалдық өлшемі тым кішкентай ескерту',
    surplusSizeErrTip: 'Қалдық өлшемі тым кішкентай, қалдықтың ең кіші өлшемін орнату үшін сәйкес өндіріс желісіне өтіңіз!',
    opacityTip: 'Техникалық қолдауды EZsort ұсынады',
    opacityTip2: 'Ағымдағы тіркелгі Smart Color Labels сатып алмаған; егер сатып алған болсаңыз, Color Label бағдарламасында шкаф тіркелгісін байланыстырыңыз',
    loadFontTip: 'Қажетті қаріп ресурстық файлдарын жүктеу, күте тұрыңыз',
    leftAlign: 'Солға туралау',
    rightAlign: 'Оңға туралау',
    topAlign: 'Жоғарғы туралау',
    bottomAlign: 'Төменгі туралау',
    horizontalAlign: 'Көлденең орталық туралау',
    verticalAlign: 'Тік орталық туралау',
    horizontalSplit: 'Көлденең тең бөлу',
    verticalSplit: 'Тік тең бөлу',
    norTag: 'Дәстүрлі түпнұсқ',
    surTag: 'Қалдық үлкен тақтай',
    genTag: 'Жасау тегі',
    all: 'Барлығын таңдау',
    deleteWarning: 'Қайырлы ескерту',
    print: 'Қашықтыру',
    defaultTemplate: 'Әдетті шаблон（60 x 40）',
    editTemplate: 'Шаблонды өңдеу',
    deleteTip: 'Шаблонды жоюдан кейін оны қалпына келтіруге болмайды, шаблонды жоюға жоспарлануда мурайсыз ба?',
    tagSetting: 'Тегтерді орнату',
    rememberSetting: 'Орнатудан кейін орнатуларды сақтайды',
    genCutingTag: 'Кесу бөлшектеріне тегтерді құру',
    genSurplusTag: 'Қалдықтарға тегтерді құру',
    genPlankTag: 'Кескіштерге тегтерді құру',
    genPartTag: 'Кіші тақта белгілерін жасау',
    genNoCutTag: 'Кесбейтін тақта белгісін жасау',
    tagPosition: 'Тегтерді орналастыру орны',
    tagPositionTip: '(Тегтерді орналастыру машинасына туалды X/Y координаталарын толтыру керек)',
    Xposition: 'X координата',
    Yposition: 'Y координата',
    genPlankSuffix: 'Кескіштерге тегтерді орналастыру үшін файл аты суфіксі',
    arrangeMirror: 'Тегтердің суреттеріні көзге айналдыру',
    drillPlankBase: 'Бес-алты жақталық бұралу үстелдің базасы',
    drillPlankBaseTip: 'Тақта орналастырудың негізгі деректерін алу сәтсіз аяқталды. Кейінірек қайталап көріңіз!',
    suitAuto: 'Тегтерді автоматты түрде жоғалту/қосуға бейімделу:',
    colorLabel: 'Түс белгілерін жасау',
    colorRevert: 'Кіші тақырыптың түсін қарама-қарсы етіп белгілеу',
    displayEnAndZh: 'Бөлме/шкаф/панель атауын ағылшын және қытай тілдерінде көрсету',
    displayEnAndZhTip: 'Тек әдепкі бөлме/шкаф/панель атауларын қолдайды. Жеке атауларға өзгерткеннен кейін бұл мүмкіндік жұмыс істемейді',
    up: 'Жоғару',
    down: 'Төмен',
    default: 'Әдетті',
    printSetting: 'Қашықтыру орнату',
    oneToMore: 'Бір бетті көбірек бетке бölшектеу',
    perPage: 'Әр бет',
    coloumn: 'Столбец',
    tagMargin: 'Тегтер арас',
    coloumnMargin: 'Столбец арасы',
    specialMark: 'Арнайы белгі',
    opacity: 'Ашықтық',
    opacityTip3: 'BMP форматты суреттерде ашықтықты қолдау үшін шын түсті таңдаңыз',
    suite: 'Аутоматты бейімделу',
    svgListTip: 'Кішкентай тақта жапсырмасын жасау қосылмаған. Сол жақтағы ұяшықты таңдаңыз.',
    size: 'Өлшем',
    lightSide: 'Көрінетін кескіш',
    locFrontSide: 'Шкафтың алдыңғы жағы',
    openSide: 'Ешуішін ашу дірексія',
    extraTip: ' Ескерту: Ешіңізді бірден басып шығаруға тырысқанда, принтердің параметрлерінде қолданылатын өлшемді және оның ені мен кескішін қалпына келтіруішінмен жаңа парақатты қосыңыз, содан кейін жаңа парақатты басып шығаруға болады (мысалы: алдын ала парақат өлшемі 60×40, жаңа парақат өлшемі 40×60)',
    noMore: 'Бөлімдердің барлығы көрсетілген',
    prepareData: 'Деректер дайындалуда...',
    genTagFile: 'Тегтер жасалуда, беттерді ауыстырмаңыз, браузерді кішірейтпеңіз, тегтерді жоғары-төмен айналдырмаңыз!',
    waitGen: 'Тегтердің жүктелуін күтіп, содан кейін жүктеуді орындаңыз',
    tempLoading: 'Тег үлгісі жүктелуде, күтіңіз',
    front: 'Алдыңғы',
    open: 'Ашу',
    toEdit: 'Өңдеуге өту',
    simplifyOneCodeTip: 'Назар аударыңыз: бұл тег үлгісіндегі штрих-код қасиеті "Қарапайым штрих-код" функциясын қолдамайды, штрих-код қасиетін өзгертіңіз (ұсынылған штрих-код қасиеті: CODE128)',
    plankTemp: 'Шағын тақта тегінің үлгісі',
    surplusTemp: 'Қалдық тегінің үлгісі',
    enableSubTag: 'Қосалқы белгіні қосу',
    enableSubTagTip: 'Қосымша параметрлер > Шағын тақта қосалқы белгісін орнату > Қосалқы белгі жасаудың қолданылатын дереккөзін орнату бөлімінен баптауға болады. Қосқаннан кейін тек орнатылған дереккөздің қосалқы белгіде мәні болса ғана қосалқы белгі жасалады, әйтпесе жасалмайды.',
    goSet: 'Параметрлерге өту',
    mainTag: 'Шағын тақта негізгі белгісі',
    subTag: 'Шағын тақта қосалқы белгісі',
    downloadSubTagTip: 'Экспортталған белгілерде қосалқы белгі бар. Автоматты жапсыру өндірістік желісі әзірге қосалқы белгі жасай алмайды. Шығаруды жалғастырасыз ба?',
    embeddedSubTagTip: 'Қосалқы белгі функциясы қолдануға мүмкін емес. Қосалқы белгі функциясын қолдану үшін веб-негізделген айналасуды ашыңыз.',
    subTagPerSaveTip: 'Қосалқы белгі құқығы өтілді. Қосалқы белгіні қосуды қайтадан қолданыңыз.',
    subTagPerexportTip: 'Экспортируемый производственный файл содержит платные права дополнительной этикетки. Эта функция истекла и требует закрытия и повторного вывода.',
    tempNamePlaceHolder: 'Үлгінің атауын енгізіңіз',
    editTip: 'Өз қажеттіліктеріңізге сәйкес сол жақтағы түймелерді оң жақтағы тег қағазына жылжытып, тег үлгісін өңдеуді аяқтауға болады',
    oneCode: 'Штрих-код',
    image: 'Кескін',
    arrow: 'көрсеткіш',
    editPage: {
      digitLimitation: 'сан шектеуі',
      title: 'Тегтердің шаблонды өңдеу',
      reset: 'Әдетті параметрлерге қалпына келтіру',
      exit: 'Өңдеуді тоқтату',
      tagInfo: 'Тегтердің ақпараті',
      tagName: 'Тегтің атауы',
      tagSize: 'Тегтің өлшемі',
      tagData: 'Тегтердің деректері',
      dragTip: 'Қолмен бастап, деректердің тегтерін сүйреп тастаңыз',
      dataTip: 'Деректердің ақпараттарын оң жақтағы հատтада таңдаңыз',
      text: 'Мәтін',
      dataSource: 'Деректердің ақпараттар',
      graph: 'График',
      typograpyPic: 'Қалыптасу суреті',
      barCode: 'Штрих-код',
      QRCode: 'Құрлы штрих-код',
      plankMark: 'Кескіштің белгісі',
      holeSlotPic: 'Тешіктің суреті',
      edgeBandPic: 'Жақтау жолағы сызбасы',
      visibleEdgePic: 'Жарықтың шығыны көрсету',
      holeSlotPicZoom: 'Тесік ойық суретін үлкейту',
      rotateDeg: 'Бұрылу бұрышы',
      colorDeep: 'Түстің қанықтығы',
      surplusMark: 'Қалдық белгісі',
      surplusSizePic: 'Қалдық өлшем суреті',
      dataSize: 'Деректер өлшемі',
      extraList: 'Қосымша тізім',
      QRCodeFormat: 'QR код форматы',
      formatQR: 'QR форматы',
      formatDM: 'DM форматы',
      locIndex: 'Кабинет индексі',
      plankFrontSign: 'Панель белгісі',
      genNCSuffix: 'NC жалғауын жасау',
      table: 'Кесте',
      inputPlaceholder: 'Мәтінді енгізу үшін екішерті басыңыз',
      attribute: 'Қасиеттер',
      fontFamily: 'Қаріптің түрі',
      fontSize: 'Қариптің кемелді',
      fontWeight: 'Қариптің қалınдығы',
      flipOverProcessing: 'Бетті аударып өңдеу',
      showSideMachiningSequenceDiagramBorder: 'Беттің шетіндегі өңдеу тізбегі диаграммасын көрсету',
      showSideMachiningSequenceNumber: 'Беттің шетіндегі өңдеу тізбегінің нөмірін көрсету',
      autoRow: 'Автоматты түрде жаңа жол құру',
      rowMargin: 'Жолдар арас',
      autoFontSize: 'Қорытпаған мәтіндің кемелді автоматты түрде реттелу',
      statisticsDimension: ' Статистикалық өлшемдер',
      noLimit: 'Сінірсиз',
      sameOrderNo: ' Жекелей тапсырыс',
      sameRoom: 'Жекелей төбес',
      sameWardrobe: 'Жекелей кабинет',
      alignWay: 'Қарастыру әдісі',
      JustifyLeft: 'Сол жаққа қарастыру',
      JustifyRight: 'Оң жаққа қарастыру',
      JustifyCenter: 'Ортаға қарастыру',
      otherOpration: 'Басқа операциялар',
      attributeReset: 'Қасиеттерді қалпына келтіру',
      barCodeSize: 'Штрих-кодтың өлшемі',
      installPic: 'Қорынту суреті',
      plankCode2: 'Кескіштің штрих-код (noMark)',
      frontCode: 'Алдыңғы жақ штрих-код',
      backCode: 'Арқа жақ штрих-код',
      orderRemark: 'Тапсырыс туралы ескерту',
      NCFileName: 'Кескіштің файлының аты',
      NCFileNameTip: 'NC файл атауында қытай символдары болмауы және ұзындығы 10 символдан аспауы тиіс',
      showOpenSide: 'Қақпа ашу бағытын көрсету',
      limitFixed: 'Десятич сандық орнын шектеу',
      showFrontHS: 'Алдыңғы түйіндік-ойықтарды көрсету',
      showBackHS: 'Артқы түйіндік-ойықтарды көрсету',
      showPartEdge: 'Панель жиегін көрсету',
      showPlankSize: 'Панельдің өлшемін көрсету',
      tempNamePlaceholder: 'Тег атауын енгізіңіз',
      deleteAreaTip: 'Жою кеңесін таңдаңыз',
      suitShunt: 'Бекіту түйіндік-ойықтарды бөлуді таңдаңыз',
      suitShuntTip: 'Бекітуден кейін өңдеуге қатыспайтын түйіндік-ойықтардың бөліктері штрих-код жасамайды',
      noHoleSlot: 'Тешіксіз де штрих-код көрсетілуішін таңдаңыз',
      rotate: 'Штрих-кодты айналу',
      barcodeAtrribute: 'Штрих-кодтың қасиеттері',
      imgSize: 'Суреттің өлшемі',
      graphStyle: 'График стилі',
      noEdgeDisplay: 'Кескістің шеті 0 болса штрих-код көрсетілмейді',
      allEdgeNoDisplay: 'Жиектерді топтау көрсетілмейді',
      isShowDiffEdgeColor: 'Әртүрлі жиек түстерін көрсету',
      hideSameEdgeColorAsPlank: 'Панель түстерімен сәйкес кезде жиек түстері көрсетілмейді',
      hideSameEdgeColorAsPlankTip: 'Кіріктірілген бұлт пішімдеуі әзірге қолдау көрсетілмейді',
      imgRotate: 'Суретті айналдыру',
      circleD: 'Дөңгелек жақтау диаметрі',
      roomNo: 'Бөлме нөмірі',
      roomOrder: 'Шкаф нөмірі (бөлме бойынша реттеу)',
      alphabetically: 'Әріп бойынша сұрыптау',
      numberOrder: 'Сан бойынша сұрыптау',
      specialMarkup: 'Ерекше белгілеу белгілері',
      smallPlateMarking: 'Кіші тақтаның белгісі',
      arrow: 'Жіп',
      triangle: 'Үшбұрыш',
      sixSideDrillPlankBase: 'Алты жақты пішімдеу негізі',
      boldSettingTip: 'PDF қалың қаріпі қолдау көрсетпейді',
      frontEdge: 'Экранды шығының алдын ақылы',
      visibleEdge: 'Жарықтың шығыны көрсету',
      lineCount: 'Бір жолдағы символдар саны'
      },
    autoSaveToHistory: 'Тарихқа автоматты түрде сақталды!',
    firstPrintTip: 'Тікелей басып шығаруды бірінші рет пайдаланғанда, басып шығару параметрлерінде ұзындығы мен ені ауыстырылған жаңа қағаз өлшемін қосып, содан кейін жаңадан қосылған қағазды пайдаланыңыз',
    tagDownloading: 'Белгісі жүктелуде...',
    cutLaveEnd: 'Қалдық жапсырмалары әрбір үлкен тақтаның артында жасалады',
    deleteTemplate: 'Шаблонды өшіру',
    copyTemplateRenderUrl: 'Шаблонтың сілтемесін көшіріңіз',
    noPermission: 'Шаблонтың сілтемесін көшіруге рұқсаты жоқ, шаблонты жоюға жоспарлануда мурайсыз ба?',
    moreOperation: 'Көбірек әрекеттер',
    importTemplate: 'Шаблонды импорттау',
    importTemplateLink: 'Шаблонтың сілтемесін көшіріңіз, шаблонды импорттауға рұқсаты жоқ, шаблонды жоюға жоспарлануда мурайсыз ба?',
    importTemplateLinkPlaceholder: 'Шаблонтың сілтемесін көшіріңіз',
    noDeleteTemplate: 'Негізгі шаблон жоюға рұқсаты жоқ',
    tip1: 'Қазіргі шаблонда сілтеме көшіру мүмкін емес',
    tip2: 'Қазіргі шаблонның деректер сілтемесі көшірілді.',
    tip3: 'Шаблонтың сілтемесін көшіру сәтсіз аяқталды, әзірлеуіміз келесі ретте қайталана алады',
    tip4: 'Импортталған шаблон сілтемесі танылмады, қайта жүктеп алып қайта импорттаңыз.'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: 'Материал, түс, қалыңдық және үлкен тақта өлшемі бойынша әртүрлі қалталарға жіктеу (белгілеу файлдарымен бірге)',
    notOpeFolderPermission: 'Каталогпен рұқсат етілмеген әрекет',
    notFindFolder: 'Ағымдағы каталог ағымдағы клиентте анықталмады',
    productLineUniversal: 'Барлық өндіріс желілеріне бірдей қолданылады',
    effectCondition: 'Бұл параметр өзгергеннен кейін қайта орналасу ғана күшіне енеді',
    addPath: 'Жолды қосу',
    downloadPositionChangeByType: 'Жасалған файлдардың жүктеу орны {type} болып өзгертілді',
    isDeleteFolder: 'Пайдаланылған файл сақтау орнын жоюға сенімдісіз бе?',
    netWorkIsNotSafe: 'Сіздің желі ортаңыз қауіпсіз емес сияқты, біз бұл мүмкіндікті қосып алмаймыз, сіз бізге кері байланыс жасай аласыз',
    NotSupportBrowse: 'Сіздің браузеріңіз бұл функцияны қолдамайды. Пайдалану үшін <a href="https://www.microsoft.com/kk-kz/edge/download" target="_blank">Edge</a> браузерінің ең соңғы нұсқасын жүктеп алыңыз.',
    notSupportDisk: '[Жұмыс үстелі] және [C дискісі] сияқты жүйелік деңгейдегі каталогтарды таңдай алмайсыз',
    useFolderDownload: 'Өндірістік файлдар қысылмаған пішімде жүктеледі',
    downloadPosition: 'Файл жүктеу орны',
    changeUseFolder: 'Өзгерту',
    folderNameSetting: 'Қапшық параметрлері',
    mainFolder: 'Бірінші деңгейдегі қапшық',
    exportNameSetting: 'Экспортталған өңдеу файлдарыні тапсырыс нөміріне сәйкес атау',
    fileMax: 'Файл атауының ең көп',
    char: 'Символ',
    overTip: 'Қосымша бөліктер көрсетілмейді (таг суреттерінің қысқартмасы мен json файлдары бірінші деңгейдегі қапшық атауына сәйкес атайды)',
    example: 'Үлгі',
    engravingFolder: 'Оюл машинасы қапшық',
    electronicSawFolder: 'Электронды пил машинасы қапшық',
    labellingFolder: 'Етикеткалау машинасы қапшық',
    sideHoleDrillFolder: 'Жақ таңбалау машинасы қапшық',
    fiveDrillFolder: 'Бес таңбалау машинасы қапшық',
    sixDrillFolder: 'Алты таңбалау машинасы қапшық',
    PTPFolder: 'PTP қапшық',
    labellingTagFolder: 'Етикетка суреттері қапшық',
    surplusFolder: 'Қалдық файлдардың үлкен тақтасы',
    surplusBigPlankSetting: 'Қалдық үлкен тақтай кесу файлы, таңба суреттері және жапсырма файлдары жеке орналастырылған',
    surplusBigPlankSettingTip: 'Іске қосылғаннан кейін қалдықтардың NC файлы, таңба суреттері және жапсырма файлдары жеке бір папкада орналастырылады',
    folderMergeSetting: 'Қапшықтарды біріктіру орнату',
    folderMerge: 'Қапшықтарды біріктіру',
    mergeName: 'Біріктіру атау',
    subMergeFolder: 'Материалдің түсі, түсі және қалыңдығы бойынша кіші қапшыққа біріктіру:',
    subFolderName: 'Кіші қапшық атауы',
    splitChar: 'Бөлшектің белгісі',
    splitTip: '（/ : ? < > | . ” * және басқа да символдар енгізуге болмайды)',
    folderAutoAdd: 'Қапшық санының автоматты түрде өсу бастапқы мәні',
    resetTip: '(Күн сайын таңертеңге бастапқы мәнге қайта орнату)',
    emptyErrTip: 'ئۇچۇر بوش قالمايدۇ',
    repeatErrTip: 'ھۆججەت ئىسمى قايتىلانغان',
    mergeDataTip: 'Төсі, қалыңдығы, ұзындығы және ені немесе файл саны автоматты түрде өсуі керек',
    engravingFileSetting: 'Сүйектеу файлын орнату',
    engravingSplitZF: 'Терезелектің алдыңғы/артқы файлдарын ажыратып папкаларға салыңыз',
    engravingSplitZFTip: 'Бір, Екі, Үш автоматты этикеттеу машинасына сай келеді,',
    engravingSplitWorkstation: 'Гравировальная машина позиция бойынша папкаларға бөлінеді',
    engravingSplitWorkstationTip: 'Гравировальная машина и машина для резки гравировальной машины поддерживается',
    holeFileSetting: 'Босқын файл параметрлерін орнату',
    holeFileSingle: 'Берілген тапсырыстар бойынша түрлі папкаларда құралдың тесік қию файлдарын жеке орналастырыңыз'
    },
  moreSettings: {
    generalSetting: 'Жалпы параметрлер',
    outSyncTip: 'Бұлтты типтеудің бастапқы деректері шкафпен синхрондалмаған кезде қалқымалы терезе жасалады',
    secondarySwitchShow: 'Ою машинасының параметрлерінде ажыратқышпен басқарылатын қайталама мазмұн ажыратқыш өшірілгеннен кейін әлі де көрсетіледі',
    isFrameDoorTip: 'Рамка қақпасын өңдегенде ескерту терезесі жасалады',
    exPaibanTip: 'Бұлттық орналастырудың дұрыс емес қалдықтар/дұрыс емес кірістіру функциясын пайдаланғанда ескерту терезесі жасалады',
    isDesMaterialNoCutTip: 'Кесілмеген кіші тақтай материалдары үшін, ою машинасына тағайындалған тесіктер, ойықтар немесе бітік пішіндер болған кезде, ескерту терезесі жасалады',
    surpTagThresholdTextHalf1: 'Кiçik бөлік материалының (кесілген көппе материалынан бөлік) аянты',
    surpTagThresholdTextHalf2: 'дан кішкентай болганда, бөлік материалының таңбағын жасамай.',
    innerShapeToolMatch: 'Кескіш машинасында ішкі кескіш бөлшектердің өңдеуі үшін қажетті құралды автоматты түрде таңдайды',
    innerShapeToolMatchTip: 'Кескіш машинасында ішкі кескіш бөлшектердің өңдеуі үшін қажетті құралды автоматты түрде таңдайды',
    innerShapeToolMatchTip2: 'Ескерту: Қосылғаннан кейін, кескіш машинасы ең кіші қапшық құралын қолданады, қапшық құралының "қапшық ұзындығы" және "бір реттік ең үлкен өңдеу тереңдігі" параметрлерін қалайсыз, тек қана қалқымалы типтеуде қолданылады',
    surNotLayout: 'Мәтінің қазақша аудармасы: “Қалдық үлкен тақтайлар белгілі бір тақтай бөлшектерін орналастырмайды',
    surNotLayoutTip: 'Ашылғаннан кейін: 1. Қалдықтың үлкен тақтасында кіші тақталарды орнатпау керек, олардың атаулары төмендегі атауларды қамтиды. 2. Таңдау кезінде, бұл реттегі таңдаудың осы функцияларын қолдануды қолданушы таңдауы мүмкін.',
    addPlank: 'Қосымша тақтай атауын қосу',
    addPlankTip: 'Taqyrybyń engizu üshin kem degende bir kischikentay taqyrybyń engiziniz',
    thisInput: 'Бұл жерде енгізу',
    surNotLayoutMat: 'Қалдық құбырда белгіленген кіші тақтайша түсіру қажет емес',
    subTagSetting: 'Шағын тақта қосалқы белгісін орнату',
    subTagDataSource: 'Қосалқы белгі жасаудың қолданылатын дереккөзін орнату',
    subTagDataSourceTip: 'Қосқаннан кейін қосалқы белгі жасауды басқаратын дереккөздерді қосуға болады. Қосалқы белгіде сол дереккөз болса және дереккөзде мән болса, қосалқы белгі жасалады.',
    addSubTagDataSource: 'Дереккөз қосу',
    addSubTagDataSourceTip: 'Қайталанатын дереккөз қосуға болмайды',
    addSubTagDataSourceTip1: 'Кемінде бір дереккөз қосыңыз',
    addSubTagDataSourceTip2: 'Дереккөз бос болмауы керек, таңдаңыз',
    reuseMatchingPlankName: 'Қайта пайдалануда тақтай атауы бойынша сәйкестендіру',
    reuseMatchingPlankNameTip1: 'Бұл функция өшірулі кезде, орналастыруды қайта пайдалану материал, түс, қалыңдық, өлшемдер, текстура және жоғары жылтырдық қасиеттері бірдей тақталарды сәйкестендіреді',
    reuseMatchingPlankNameTip2: 'Бұл функция қосулы кезде, жоғарыдағы сәйкестендіру шарттарынан басқа, тақтай атауы бойынша сәйкестендіру де қосылады'
    },
  lineManager: {
    add: 'Өндіріс желісіні қосу',
    engraving: 'Кескіш машина',
    holeSlotEquip: 'Тесік және слотты өңдеу машина',
    workSetting: 'Өңдеу параметрлер',
    noUse: 'Қолданылмайды',
    warningTip: '* Ескерту: Төмендегі функцияларды орнатқаннан кейін, кескіш клиенттерімен қосылу бетінде сақтамаңыз, параметрлерді қалпына келтіруге болмайды!',
    engravingSetting: 'Кескіш машина параметрлер',
    workWay: 'Өңдеу әдісі',
    cutedSpecial: 'Өңделген тесік және слоттары:',
    noWork: 'Бұл параметр бес/алты таңбалау машинасының әдетті шаблонына әсер етпейді',
    onlyCut: 'Тек кескіш',
    onlyFrontHoleSlot: 'Тек панельдің алдыңғы жағындағы тесік және слоттары',
    onlyHoleSlot: 'Тек панельдің алдыңғы және артқы жағындағы тесік және слоттары',
    sideHoleSetting: 'Жақ таңбалау машина параметрлер',
    cutHoleSlot: 'Өңделген тесік және слоттары',
    minSize: 'Қысқа жақ өлшемі',
    maxSize: 'Ұзын жақ өлшемі',
    minSize2: 'мм аралық панельде барлығы',
    minSize3: 'қиші және түрлі бөлім',
    onlyFrontHoleSlotTip: 'Панельдің алдыңғы жағындағы тесік және слоттары',
    onlyFrontHoleSlotTip2: 'Сыртқы тесік және слоттарын қоса алмау',
    holeAndSlot: 'Торық және қазылыс',
    empty: 'бос',
    singleHole: 'Бір тесік',
    singleSlot: 'Бір слот',
    diameterRange: 'Тесіктің диаметрінің диапазоні',
    hDeepRange: 'Тесіктің тереңдігінің диапазоні',
    widthRange: 'Слоттың кеңдігінің диапазоні',
    sDeepRange: 'Слоттың тереңдігінің диапазоні',
    to: '—',
    specialHS: 'Бұрмақ бөлшектер мен бұрмақ слоттары',
    allowRoll: 'Кескіш машинаның бұрмақ бөлшектер мен бұрмақ слоттары өңдеуіне рұқсат ету',
    engravingPath: 'Кескіш машинасында панельдің бұрмақ бөлшектері өңделу',
    curve_range: 'Бұрмақ бөліктің ұзын жағы үлкен',
    curve_range2: 'панельдің барлық бұрмақ бөліктері',
    curveArea: 'Тұсқان шакылдың ауданы',
    drillSetting: 'Бес/алты таңбалау машина параметрлер',
    engravingCuted: 'Кескіш машинасында өңделген тесік және слоттары бес/алты таңбалау машинасында',
    engravingCutedSpecial: 'Кескіш машинасында өңделген бұрмақ бөліктері бес/алты таңбалау машинасында',
    genCuttingPath: 'Кесу деректерін қалыптастыру',
    otherCuted: 'Басқа жабдықтармен өңделген тесіктер мен ойықтар бес/алты жақты бұрғылауда',
    noGen: 'Қалыптысу жоқ',
    genCut: 'Қалыптысу және өңдеу',
    genNoCut: 'Қалыптысу, бірақ өңдеу жоқ',
    cutTip: ' Ескерту: Бұл параметр тек өзіңіздің бес/алты таңбалау машина файлына әсер етеді',
    maxShortSize: 'Ең үлкен қысқа яқтың өлшемі',
    maxLongSize: 'Ең ұзын жақ өлшемі',
    normalSlot: 'Қалыпты слот',
    specialSlot: 'Бұрмақ слот',
    combinSetting: 'Комбинациялық жабдықтар параметрлер',
    allowShortSize: 'Қысқа яқтың өлшеміне рұқсат ету',
    equipment1: 'Бірінші жабдық',
    equipment2: 'Екінші жабдық',
    noSameTip: ' Ескерту: Екі жабдықты да бірдей таңдауға болмайды',
    workRange: 'Бірінші жабдықтың өңдеу диапазоні',
    rangeWarning: ' Ескерту: Тек бірінші жабдықтың оңдеу диапазонды таңдауға болады. Бірінші жабдықтың оңдеу диапазонынан тыс болатын бөлшектер екінші жабдықта оңделуге болады. мұны мұқият істеу!',
    deleteWarning: 'Бұл өндіріс желісіні жоюдан кейін қалпына келтіруге болмайды (желісінің барлық параметрлері жойылады), онда жоюды тастықтайсыз ба?',
    top: 'Жоғарғы',
    inputCheck: '{msg} ең кішісі зортық мәннен аспайды',
    lockTip: 'Өндіріс желісі бұғатталды, операцияларға тысыңыз!',
    reNameTip: 'Әдетті өндіріс желісінің атауын өзгертеуге болмайды',
    permissonTip: 'Кімلیک bilgisi үтіп кетті, қайтадан кабинеттен осы бетті ашу!',
    permissonErr: 'Бұл рұқсат сізге берілмеген, аккаунт нұсқасын жаңарту!',
    permissionOneMacErr: 'Сіз қазір қол жетімді бір бұйрыq құрылғының жинақ саныңыз {idx} болып тұр. Қосу керек болса, satıcıға хабарласыңыз!',
    permissionSawErr: 'Бұл кескіш машинасының қолжетерлік емес, қосымша құрылғыны сатып алу үшін қолдау көрсету!',
    getAuthError: 'Құрылғы рұқсатын алу сәтсіз болды!',
    sawAddNumber: 'Сіздің қолданылатын электронды ара құралдар желісінің шегі таусылды. Қосымша қажет болса, сату бөліміне хабарласыңыз!',
    newLine: 'Жаңа өндіріс желісі {idx}',
    deleteCheck: 'Бәрін де жоюға болмайды',
    deving: 'Қазіргіде әзірлеуде',
    combinTip: 'Өңдеу құрылғыларының комбинациясын орнату үшін төмендегі орнына басыңыз',
    noUseEquip: 'Өңдеу құрылғысы іске қосылмаған',
    equipmentSelectTip: 'Комбинациялық жабдықтарда кескіш машина таңдалған болса, кескіш машинасы электронды пісіру машинасы таңдалуыға болмайды',
    lineLoading: 'Деректер жүктеледі',
    strenchType: 'Түзеткіш слот типі',
    aioProcessTip: 'Сіз "Барлығын бірден" құрылғысын қосқансыз, өңдеу режимі әдепкі бойынша тақтайлардың екі жағын да тесіктермен және ойықтармен өңдеу болып табылады',
    aioProcessTip2: 'Барлығын қосқаннан кейін арнайы тесіктер мен ойықтар кесу машинасы бөлімінде өңделеді',
    aioProcessTip3: 'Ескерту: Бұл функция XY осін ауыстыру функциясын қосқан кесу машиналарымен үйлесімді емес. Оны мұқият қолданыңыз',
    specialHoleTip: 'Ескерту: Жоғарыдағы "арнайы тесіктерді өңдеу" функциясын қолданған кезде "сквозное сверление" және "сквозное фрезерование" параметрлерін бір рет бұрғылап өту үшін орнатыңыз',
    specialHoleTip2: 'Ескерту: Жоғарыдағы "арнайы тесіктерді өңдеу" функциясын қолданған кезде кесу машинасының "сквозное сверление" және "сквозное фрезерование" параметрлерін бір рет бұрғылап өту үшін орнатыңыз',
    fiveSixNotTake: 'Бұл параметр бес/алты жағынан бұрғылау үшін әдепкі шаблондарға қолданылмайды',
    onlyFrontSide: 'Тек алдыңғы жағын өңдеу',
    onlyBackSide: 'Тек артқы жағын өңдеу',
    less: 'Кіші',
    equal: 'Тең',
    greater: 'Үлкен',
    or: 'Немесе',
    and: 'Және',
    bothFrontBack: 'Алдыңғы және артқы жағын өңдеу',
    shareDataErrTip: 'Бұл деректер {operatorPhone} арқылы қолданылады, ip: {actionIp}',
    restoreParams: 'Параметрлерді қалпына келтіру',
    loadMore: 'Көбірек жазыңыз',
    currentCombinationEquipment: 'Қазіргі таңдалған жабдықтар комбинациясы кесу жабдығын шыны кесу машинасына ауыстыруға мүмкіндік бермейді',
    selectEquipmentType: 'Жабдық түрін таңдаңыз',
    ruleRemark: 'Қағида ескертуі',
    remarkPlaceholder: 'Бұл қағида ескертуі бір мәлімет болып табылады, бұл қағида ескертуі қандай технологияларды өңдеуге болатынын еске түсіреді, ұмытпауға болады',
    onlyNoSideHoleSlotSmallPlank: 'Бүйірлік тесіктер мен қапықтары жоқ кішкентай тақталар ғана'
    },
  cuttingDock: {
    title: 'Кескіш машинаны қосу',
    autoStockCode: 'Автоматтық жоғары және төменгі материалдарды қосу код',
    stationStart: 'Станция басталу',
    stationStartCode1: '1-стансия басталу коды',
    stationStartCode1Placeholder: '1-стансия басталу кодын енгізу',
    stationStartCode2: '2-стансия басталу коды',
    stationStartCode2Placeholder: '2-стансия басталу кодын енгізу',
    stationEnd: 'Стансия аяқталу',
    stationEndCode1: '1-стансия аяқталу коды',
    stationEndCode1Placeholder: '1-стансия аяқталу кодын енгізу',
    stationEndCode2: '2-стансия аяқталу коды',
    stationEndCode2Placeholder: '2-стансия аяқталу кодын енгізу',
    frontBackStart: 'Алдыңғы және артқы бет басталу',
    frontBackEnd: 'Алдыңғы және артқы бет аяқталу',
    frontStartCode: 'Алдыңғы бет басталу коды',
    frontStartCodePlaceholder: 'Алдыңғы бет басталу кодын енгізу',
    frontEndCode: 'Алдыңғы бет аяқталу коды',
    frontEndCodePlaceholder: 'Алдыңғы бет аяқталу кодын енгізу',
    backStartCode: 'Артқы бет басталу коды',
    backStartCodePlaceholder: 'Артқы бет басталу кодын енгізу',
    backEndCode: 'Артқы бет аяқталу коды',
    backEndCodePlaceholder: 'Артқы бет аяқталу кодын енгізу',
    plankStart: 'Планканың ішіна бұрылуы басталу',
    plankEnd: 'Планканың ішіна бұрылуы аяқталу',
    plankRollCode1: '1-стансияның ішіне бұрылу коды',
    plankRollCode1Placeholder: '1-стансияның ішіне бұрылу кодын енгізу',
    plankRollCode2: '2-стансияның ішіне бұрылу коды',
    plankRollCode2Placeholder: '2-стансияның ішіне бұрылу кодын енгізу',
    autoBaitingCode: 'Автоматтық кескіш коды',
    autoBaitingCode1: '1-стансияның автоматтық кескіш коды',
    autoBaitingCode1Placeholder: '1-стансияның автоматтық кескіш кодын енгізу',
    autoBaitingCode2: '2-стансияның автоматтық кескіш коды',
    autoBaitingCode2Placeholder: '2-стансияның автоматтық кескіш кодын енгізу',
    thickMarkPermission: 'Сізде үлкен плита қалыңдығы белгісі рұқсаты жоқ, пайдалану үшін сату бөліміне хабарласыңыз',
    thickMark: 'Үлкен плита қалыңдығы белгісі',
    preStartEquipment: 'Алдын ала іске қосу жабдық',
    firstKnifePreCode: 'Бірінші кескіш алдын ала іске қосу коды',
    secondKnifePreCode: 'Екінші және одан әрбір кескіш алдын ала іске қосу коды',
    rowInsert: 'Сатыр енгізу',
    pumpPause: 'Вакуумдық сорғы тынықтау',
    pumpPauseTip: 'Ескерту: Бір станциялық жабдық үшін 1 және 2 станциялар бірдей «автоматты жүктеу коды» және «екі жақты өңдеудің алдыңғы түсініктеме коды» арқылы толтырылуы керек.',
    pumpPause2Tip: 'Ескертпе: Бір станциялық жабдық үшін 1-станция да, 2-станция да бірдей «вакуумдық сорғыны кідірту кодымен» толтырылуы керек.',
    pumpPauseCode1: '1-стансияның вакуумдық сорғы тынықтау коды',
    pumpPauseCode1Placeholder: '1-стансияның вакуумдық сорғы тынықтау кодын енгізу',
    pumpPauseCode2: '2-стансияның вакуумдық сорғы тынықтау коды',
    pumpPauseCode2Placeholder: '2-стансияның вакуумдық сорғы тынықтау кодын енгізу',
    annotationCode1: '1-ші орынның екі жақты өңдеуіш алдың жақ түсініктеме коды',
    annotationCode1Tip: 'Әртүрлі командалармен автоматтық қосуға арналған жабдыққа сәйкес келеді',
    annotationCode1Placeholder: '1-ші орынның екі жақты өңдеуіш алдың жақ түсініктеме коды енгізіңіз',
    annotationCode2: '2-ші орынның екі жақты өңдеуіш алдың жақ түсініктеме коды',
    annotationCode2Placeholder: '2-ші орынның екі жақты өңдеуіш алдың жақ түсініктеме коды енгізіңіз',
    upSpeedTip: 'Қосалқы жылдамдығын толтыруңыз',
    cutThickTip: 'Қосалқы кесу қалыңдығын толтыруңыз',
    sizeErrTip: 'Этикеткалау машинасында бастырушы планшеттің дұрыс өлшемін орнатуңыз!',
    offEdgeKnifeDiameter: 'Кескіштің кескіш бıрақ диаметріні толтыруңыз',
    slowDownSpeedTip: 'Кесу көлемін кеміту жолында тездету параметрлері дұрыс емес',
    permissionErr: 'Қазіргі тапсырмалық нұсқада, сақтауға болмайды',
    labellingTempErr: 'Этикеткалау машинасының шаблонды таңдаңыз',
    autoRollInputTip: 'Етикетка автоматты түрде айналуды қосу үшін, тиімді мәнді енгізіңіз',
    offlineTempFormat: 'Қазіргі этикеткалау машинасының файл пішімі қолданылмайды, растаңыз',
    autoStockCode1: '1-орын автоматтық жүктеме коды',
    autoStockCode1PlaceHolder: '1-орын автоматтық жүктеме кодын енгізіңіз',
    autoStockCode2PlaceHolder: '2-орын автоматтық жүктеме кодын енгізіңіз',
    autoStockCode2: '2-орын автоматтық жүктеме коды',
    pauseCode: 'Тынықтау коды',
    pauseCodePlaceHolder: 'Тынықтау кодын енгізіңіз',
    cuttingToolMaxDepthTip: 'Кескіштер қоймасындағы {errKey} кескішінің ең үлкен бір реттік қатауы кескіш ұзындығынан үлкен болуы мүмкін емес',
    cuttingParams: {
      title: 'Кескіш параметрі',
      stationWidth: 'Станок ені',
      stationWidthTip: 'Қалдық үлкен плиталарды қолданған кезде, ені бағытында тек қабылданған өлшем шегінде орналастыруға болады',
      holeSlotMainSide: 'Тесік және ойықтықтардің шоғырлануы',
      holeMainSide: 'Тесік шоғырлануы',
      slotMainSide: 'Ойықтық шоғырлануы',
      workPriority: '(Қызметтілік басымдығы: кесу тесіктері мен ойықтықтарды картаданың осы бетіндегі тесіктерге сәйкес кесу > Ойық бөлінісінде орнатылған арнайы ойықтар үлкен тақтаның алдыңғы жағында басымдыққа ие > Ойықтық шоғырлануы > Тесік шоғырлануы)',
      holeSlotSet: 'Тишек сондырау бассейни ишлеу настройкалары',
      hingeRollWork: 'Тіктегіш пен шарнирлік ойықтықтарды ірі картаның артқы бетінде кесу',
      followWork: 'Кесу тесіктері мен ойықтықтарды картаданың осы бетіндегі тесіктерге сәйкес кесу',
      autoMatchSide: 'Ортақ-қарамақтық ойықтық пен тесіктерді пропорционалды қарай бөлшектеу',
      backHSRate: 'Артқы бетіндегі ойықтық пен тесіктердің қарай болушыны',
      matchTip: '（Жарық панелі, атайын пішімді планшеттерді есептеудің орналасу схемасы немесе үлгіні сәйкестендіру осы параметрді қолданбайды）',
      specIalHoleAndSlotSurface: 'Специальные слоты и отверстия для пользовательской определения обрабатываемых поверхностей',
      specialRuleTip: 'Бұл орын бұралуы мүмкін',
      specialSlotsHoles: 'Бollikтер мен slotтар т tipi',
      holeType: 'Тесік түрі',
      specialRules: 'Қандай',
      normalHole: 'Аdaqаллы бollik',
      normalSlot: 'Аdaqаллы slot',
      holeDiam: 'БollikтеңбASI',
      slotLongSide: 'SlotтеңбASI ұзengi сirtі',
      slotShortSide: 'SlotтеңбASIқ singі сirtі',
      FixedmachSurface: 'Туруктуу обрабатываемая поверхность',
      deleteRuleTip: 'Бу қоида жойдан алуы барбы',
      blankFront: 'Большой доски фронтальная сторона',
      blankBack: 'Большой доски задняя сторона',
      addRules: 'Үйләм қоида',
      addRulesTip: 'Бир идишке бир нече каражат тушса, иштелип чыккан номери эң алдыңкы каражат жооп берет. Бир өртебе сүйрөп, каражаттын тартибин өзгөртсө болот',
      highGlossSetting: 'Жарық панелі параметрлері',
      heighGlossFront: 'Орналасу кезінде кіші панельдің жарық беті ірі панельге орналастырылады',
      highGlossPlankNoRotate: 'Жарық панелі айналмайтын',
      highGlossAutoRoll: 'Тек артқы тесіктері мен ойықтары бар ірі панельдер ғана автоматты түрде аударылады',
      highGlossAutoRollTip: "<span class='color-o-4'>(Қосқаннан кейін тек артқы тесіктері мен ойықтары бар ірі панельдер орналастыру кезінде автоматты түрде аударылады, бір жақты панельге айналады. Теңшелетін файл атауындағы \"Жарық бетін аударып, панельді орналастыру\" деректерімен бірге қолданыңыз)</span>",
      customHighGlossReverse: 'Жарық бетін аударып, панельді орналастыру',
      sideSlotPut: 'Жақын панельге ойықтықтарды орналастыру',
      optimize: 'Қызметтілік оптималдауды орындауда',
      sysDefault: 'Системаның әдетті параметрлері',
      plankInSide: 'Ірі панельдің ішкі жағы',
      plankOutSide: 'Ірі панельдің сыртқы жағы',
      specialNotWork: 'Бұл функсиял ерекше пішімді планшеттерге қолданылмайды',
      commonSide: 'Ортақ кесу',
      commonSetting: 'Бірдей бұрышты орнату',
      plankThickRange: 'Панельдің қалыңдығы аз болса да',
      useCommonSide: 'ортақ кесуді қолдану',
      zeroTip: 'Орналасу арақашықтығы 0 болуына қолдану керек, кесу бұрынғы кесу қабылдаған жағадан ауысуға болады, бұл функсияны қосқаннан кейін, бұрынғы кесудің бұрылышпен кесуді қолдануға болмайды.',
      useTip: 'Бұл функсияны қосқаннан кейін, бұрынғы кесудің бұрылышпен кесуді қолдануға болмайды, ескеріңіз!',
      commonSpeed: 'Ортақ кесу жылдамдығы',
      highSpeed: 'Жоғары жылдамдықпен кесу жылдамдығы',
      min: 'минут',
      notWorkTip: 'Панельдің кесуі ортақ кесуге сәйкес болса, ортақ кесудің жылдамдығы қолданылмайды',
      changeStartPoint: 'Екі жұмыс орның бастамашы нүктелерін ауыстыру',
      changeStartPointTip: 'Екі жұмыс орның бастамашы нүктелерін ауыстыруды қосқаннан кейін XY осьсімен ауысу функциясымен үйлесімсіз болады, мұны мұқият қолдану',
      flatOffset: 'Машина плосколығының ауысу',
      xRowChange: 'X осьінің координат бастық нүктелерін ауыстыру',
      bigplankPointChange: 'Үлкен тақтаның артқы жағының координаталық негіздерін ауыстыру',
      reverseXRowChange: 'X координаттарын ауыстыру',
      changebigplankPointTips: 'Бұл функцияны іске қосқаннан кейін "XY осін алмастыру" және "екі жұмыс орнының бастапқы нүктесін ауыстыру" функцияларымен үйлесімді емес. Оны абайлап қолданыңыз.',
      reverseYRowChange: 'Y координаттарын ауыстыру',
      plankMirrorTip: 'Панельді кесу машинасында镜像 кесу кезінде осы функцияны қолдану',
      notSameSize: 'Екі жұмыс орның үстелдің өлшемдері бір-бірінен әртүрлі',
      maxSize1: 'Бірінші жұмыс орның ең үлкен өлшемі',
      notSameSizeTip: 'Екі жұмыс орның үстелдің өлшемдері бір-бірінен әртүрлі болса, екі жұмыс орның файлдарын біріктіру функциясымен үйлесімсіз болады, мұны мұқият қолдану',
      maxSize2: 'Бі�ұрақтың ең үлкен өлшемі',
      autoSelectTip: 'Екі жұмыс орнының үстелінің өлшемдері бір-бірінен әртүрлі болғанда, осы функцияны қолданса, відповідің жұмыс орны ірі панельді кесуге автоматты түрде таңдалады',
      bigFlatLimit: 'Үлкен жұмыс орны кіші жұмыс орны кеспейтін ірі панельдерді кесуге тән:',
      surplusSetting: 'Қалдық орналасу',
      surplusPosition: 'Қалдық орналасу нүктесі',
      cutHoleWay: 'Тесіктің кесу әдісі',
      knifeFlat: 'Қашықтың сүреу бастық нүқтасы',
      flat: 'Үстел',
      plankFlat: 'Ірі панельдің беті',
      freeHeightZ: 'Бос уақытта Z бейіктігі',
      relativeHeight: 'Ірі панельдің бетіне қарайгі бейіктігі',
      cutDeepZ: 'Кесу тереңдігінің Z бейіктігі',
      cutDeepH: 'Толық тесіктің кесу әдісі',
      setDisableDoubleSidedThroughHole: 'Екі жақты тесік бұрғылауды өшіруді орнату',
      addHolesToRulesDisableDoubleSided: 'Сәйкес өткізгіш тесіктерді (толық бұрғыланған тесік) төмендегі ережелерге қосқаннан кейін, екі рет аударып тесіп өту күшін жояды',
      onceThrough: 'Бір рет кесу',
      rollThrough: 'Екі рет ауысу кесу',
      cutDeepS: 'Толық ойықтықтың кесу әдісі',
      plankCutDirection: 'Кіші панельдің кесу бағыты',
      clockDirSwitch: 'Теңшеу тесігі/ойығы және ішкі профильді кесу бағытын теңшеу',
      millHoleSlotDir: ' Теңшеу тесігі/ойығы бағыты',
      millInternalCurveDir: 'Ішкі профильді кесу бағыты',
      sDirection: 'Сәулеткеш бағыт',
      nDirection: 'Сәулеткеш бағыттың керісі',
      curveReplenish: 'Арқалық толтыру кесу командасы арқалық панельдерді кесуге',
      curveReplenishTip: 'Арқалық панельдерді кесуде заңбырлар пайда болса, осы функцияны қолдану',
      noGen: 'G17/G18/G19 бетінің командасын жасамау',
      arcInstruction: 'Шеңісті өңдеу командаларының алдындағы белгі',
      example: 'мисал',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: 'Арқалық кесуде I, J белгілері қолданылады',
      coverRate: 'Ойықтық кесу кезінде кесудің қапталушылығы:',
      roughTip: 'Қалдық пен ойықтық ішінде кесуде заңбырлар пайда болса, осы функцияны қолдану',
      clearCurve: 'Ойықтық кесуде толтырушы кесуде тегіс бұрыштар автоматты түрде тазалау:',
      curveUseTip: 'Ойықтық кесуде тегіс бұрыштар тазалау үшін осы функцияны қолдану, ескерту: осы функция жалғаушыларға қолданылмайды',
      slotCutWay: 'Ойықтық кесудің кесу бағыты',
      outToIn: 'Сырттан ішке ойықтық кесу',
      inToOut: 'Ішке сыртқа ойықтық кесу',
      zShapProcess: 'Жогору және төменгі Z әріптің түсінік ішіндегі штыртқа айналдыру сұйықтасу жолы',
      zShapProcessTip: 'Кірісті және көшірілген жолдар үшін әріптің толығындауына бейімделген, ножның жол жолмен қайталану деңгейі ножның радиусына тең болады',
      zSlotCuttingOverlapRate: 'Z тірінің жұлдыздық жіптерінің қатынасы',
      zSlotCuttingOverlapRateTip: 'Z тірінің жұлдыздық жіптерінің қатынасы өндіріс жылдамдығын баяулата алады, өндірістік құрылғыны іске қосудан кейін қайтадан өңдеуді қайталаңыз.',
      slotWorkLimit: '(Ойықтық кесудің кесу қатламдары > 1 болса ғана қолданылады)',
      minKnifeChange: 'Кесуде кесу қанатты басталу қаптауын азайту',
      preventBreakage: 'Жиектік ойық аралық жолағының үзілуін болдырмау',
      preventBreakageTip: 'Бұл параметр тек орналастыру кезінде алдыңғы беттегі ойықтарға қолданылады және «Арнайы ойықтар мен тесіктердің өңдеу бетін теңшеу» функциясымен бірге қолданылуы мүмкін',
      preventBreakageTip1: 'Ойық тақта жиегіне тым жақын орналасқанда, кесу кезінде сол жердегі бөлімше (қалған байланыс бөлігі) кернеудің шоғырлануынан оңай үзілетін жағдайды шеше алады',
      preventBreakageDistance: 'Тақта жиегінен қашықтық',
      preventBreakageLength: 'Жиекке жақын бөліктің ұзындығы',
      preventBreakageSlot: 'ойықтар',
      preventBreakageCutDeep: 'Алғашқы кесу тереңдігі',
      workSpeedOp: 'Кесу жылдамдығіні оңтайландыру',
      obliqueCut: 'Кесу кезінде кесу қанатты басталу',
      obliqueCutTip: 'Плита қалыңдығы белгісіз болса, барлық плита қалыңдығы кіші плиталар үшін әсер етеді',
      obliqueThickLabel: 'Кесу қанатты басталудың тиімді қалыңдығын өзгерту',
      obliqueThick: 'Кесу қанатты басталу қалыңдығын өзгерту',
      backObliqueThick: 'Арқалық кесуде кесу қанатты басталу қалыңдығын өзгерту',
      effectiveThickness: 'Қанатты басталу қалыңдығы',
      effectiveThicknessTip: 'Қанатты басталу қалыңдығы болуы керек, қою!',
      effectiveThicknessDuplicateTip: 'Қанатты басталу қалыңдығы қайталанбауы керек, өзгертіңіз',
      obliqueCutData: 'Қиғаш төмен қию қашықтығы',
      backOblique: 'Арқалық кесуде кесу қанатты басталу',
      obliqueSpeed: 'Кесу қанатты басталу жылдамдығы',
      obliqueSpeedTip: 'Қию және арқалық кесу',
      arcSpeed: 'Арқалық кесу жылдамдыгі',
      cuttingPreDistance: 'Кесу алдын ала қашықтығы',
      backKnife: 'Кесудің соққысын төмендету',
      openKnifeSpeed: 'Соққысын ашу жылдамдыгі',
      retractionCompensation: 'Кесу соққысының төмендету',
      retractionCompensationTip: 'Мәні ең үлкен 20',
      cutCornerSlow: 'Бұрыштар кесуде жылдамдыгі төмендету',
      addRow: 'Қосымша',
      bettwenDistance: 'Бұрыштардың алды-артқыштарі',
      cuttingSpeed: 'Кесу жылдамдыгі',
      stepCutting: 'Қатламдық кесу',
      splitSlot: 'Ойықтық екі рет кесу',
      splitPlank: 'Кіші панельдің екі рет кесуі',
      splitPlank2: 'Кіші панельдің екі рет кесуі',
      minSafeThick: 'Қалыңдығы көп',
      splitPlankTip: '（Құрамды панельдің кесуде қолданылмайды）',
      splitPlankTip2: '(Қамтамасыз етілмейді: Кесу кезіндегі қалдық кесімі)',
      cutPlankMethod: 'Панельдің кесу әдісі',
      cutPlankMethodTip: 'Төрт қабырғасынан кесу',
      cutPlankMethodTip2: 'Соңғы қабырғасынан кесу',
      specialShapCut: 'Құрамды панель екі рет кесу',
      specialShapCutTip: '（Құрамды панельдің кесуде қолданылмайды）',
      bridgeRetention: 'Көпірлі тірек нүктесі әдісі',
      bridgeRetentionTip: '(Ескерту: 1. Бұл функция әзірге сыртқы пішінді тақталарды қолдамайды. 2. Қиғаш төмен кесуді қолдамайды. 3. Байланыстырушы көпір жасалатын тақтаның ең кіші өлшемі 30мм.)',
      bridgeRetentionDesc: 'Тақта ішіндегі көптеген қуыс аймақтар тірек жеткіліксіз болғанда, кесу жолының дірілдеуін немесе жылжуын болдырмауға көмектеседі.',
      bridgePunchArea: 'Тесілген бөлік жалпы ауданнан асады',
      bridgeSize: 'Көпір өлшемі',
      bridgeGenMethod: 'Қалыптастыру тәсілі',
      bridgeAddTip: 'Ең көбі 10 жазба қосуға болады',
      bridgeCount: 'Көпір саны',
      bridgePlankLength: 'Тақта ұзындығы (L)',
      maxWH: 'Ұзындық немесе ені аз',
      areaLimit: 'Және алаңдық аз',
      secondDeep: 'Екінші рет кесу тереңдігі',
      splitPlankThickSetting: 'Қабатты кесу параметрлерін өлшемдеу',
      saveCustomSpeedTip: 'Өңдеу жылдамдығы бос болмауы керек',
      saveLayeredCuttingTip: 'Үш қабатты кесінділердің қосындысы пластинаның қалыңдығына тең болуы тиіс',
      saveLayeredRepeatTip: 'Бір материалдың бөлектеу атрибутының қалыңдығына әр түрлі қабатты деректерді орнату ұсынылмайды, артық деректерді жоюыңызды өтінемін!',
      splitPlankThick: 'Әр қатламда кесу әртүрлі қалыңдықта',
      movePlankSetting: 'Тайғанауға қарсы тақта параметрлері',
      newCutSequence: 'Жаңа кесу алгоритмі',
      newCutSequenceText: 'Әдепкі бойынша, үлкен тақтаның ортасындағы вакуумдық сорғыш күші ең күшті, бұл аймақтағы кіші тақталар соңында кесіледі',
      positionTip: 'Таңдау үшін сәйкес ауданды басыңыз',
      suctionPosition: 'Құбылыс пішінің күшті қабылдамасы',
      strongArea: 'Құрғау аймағы',
      minSuctionPlank: 'Эң кіші қабылданатын дошка',
      safeWidth: 'Ені',
      safeHeight: 'Биіктігі',
      safeTip: 'Табан нұсқаны тұтынбаса ал бірінші резке қалдыратын',
      scattered_layout: 'Кішкентай табандарды бөліп орналастыру',
      lastCutPointEnable: 'Үлкен тақтадағы соңғы кесілген кішкентай тақтаның кесу нүктесін баптау',
      lastCutPointEnableTip: 'Қосылғанда, әрбір үлкен тақтадағы соңғы кесілген кішкентай тақтаның кесу нүктесі белгіленген нүкте бойынша жасалады',
      lastCutPoint: 'Кесу нүктесінің орны',
      lastCutPointTip: 'Қосылғанда, әрбір үлкен тақтадағы соңғы кесілген кішкентай тақта осы кесу нүктесін пайдаланады',
      leftTop: 'Жоғарғы сол жақ',
      rightTop: 'Жоғарғы оң жақ',
      leftBottom: 'Төменгі сол жақ',
      rightBottom: 'Төменгі оң жақ',
      specifyTheMaterial: 'Материалды анықтаңыз',
      shapeSecondCutenable: 'Қосымша көзге сатылған талбанның екінші кезде сатылуы',
      addMaterial: 'Материал қосу',
      plankMaterial: 'Панель материал',
      specifyTheMaterialTip: 'Қосу қıldıңнан кейін, көшірші қысқару функциясы толық мәліметтердің материал талаптарын қамтамасын қабылдайтын панелдер үчүн ғана әсер қажет.',
      dispersePaibanTipOne: '1. Қосу қıldıңнан кейін, әңгімедегі материал талаптарын қамтамасын қабылдайтын панелдер үчүн ғана әсер қажет.',
      dispersePaibanTipTwo: '2. Қосу қıldıңнан кейін, әңгімедегі материал талаптарын қамтамасын қабылдайтын панелдер үчүн ғана әсер қажет.',
      totalThickLimit: 'Үш рет қатламдық кесудің толық қалыңдығы панельдің қалыңдығына тең болуы тиіс',
      offsetFollowStep: 'Солтү кесу де қатламдық кесуге сәйкес келеді',
      longPlankTip1: '1. Бұл функцияны қосқаннан немесе өшіргеннен кейін тарихта сақталған орналасу жазбалары NC жүктеген кезде қайта орналастырылуы керек',
      longPlankTip2: '2. Бұл функция іске қосылғаннан кейін [Кескіш машинаны қосу - Вакуумдық сорғыны тоқтату] бөлімінде вакуумдық сорғыны тоқтату кодын орнату керек, әйтпесе ұзын панельді кескендегі іілу мәселесін шешу мүмкін емес',
      longPlankTip3: '3. Төменде қосылған сүзгі шарттары деңгей бойынша ретімен тексеріледі; алдыңғы деңгейдің сүзгі шарттарын қанағаттандырған панельдер ғана келесі деңгейдің сүзгі шарттарына өтіп, бағалануға жатады.',
      secondCutting: 'Екінші рет кесу объекті',
      normalPlank: 'қалыпты панельдің',
      normalPlankTip: 'қалыпты панель: шкафтің ішкі және сыртқы ірі панельдері және кесу тізімінде тікелей қосылған панельдер',
      designatedTarget: 'Белгіленген объектілер',
      filterLevel1Label: '1-деңгей сүзгі',
      filterLevel1Category: 'тақта түрі',
      filterLevel2Label: '2-деңгей сүзгі',
      filterLevel2Category: 'өлшем шектеулері',
      filterLevel3Label: '3-деңгей сүзгі',
      filterLevel3Category: 'басқа',
      specifiedBoardForceEnable: 'Өлшем/басқа сүзгілерді елемеу, мәжбүрлі қосу',
      curveMaterialFilterTip: '(«Дөрекі емес тақта» белгіленгеннен кейін, материал сүзгісіне дейін тақта дөрекі емес болуы керек)',
      cuttingSettings: 'Кесу параметрлері',
      plankSizeLimitSuffix: ' тақталар',
      specifiedBoard: 'Тақта атауын кесуді көрсетіңіз',
      specifiedBoardTip: 'Ашылғаннан кейін, пластина атауы төменде қосылған пластина атауын қосқанда, қайталама кесу күшіне енеді',
      addPlankName: 'Тақта атын қосыңыз',
      plankNameEmpty: 'Тақта атауы бос болмауы керек, енгізіңіз',
      plankNameRequired: 'Кем дегенде бір тақта атауын қосыңыз',
      plankLongLimit: 'Ұазырлы бұрышты асқан',
      plankShortLimit: 'Қысқа егісі',
      cuttingSplit: 'Екі рет кесу',
      longExpand: 'Бірінші рет кесудің кеңейту дережесі: uzun егіс кеңейту',
      firstExpand: 'Алғашқы кесуде кеңейту',
      longExpandTip: 'Ұзын жағын кеңейту',
      longLimit: 'Ұзын жағы асып кетсе',
      cuttingSplitTip: 'Ұзын тақтайды екі рет кесу шарты',
      shortExpand: 'Қысқа егіс кеңейту',
      expandTip: 'ұзын/қысқа егістің өлшемдері әрқайсысы x мм-ге қосымша, ірі панельдің ірі және кіші егісінің кеңейту дережесі бірдей',
      pumpOffWay: 'Вакуумдық сорғыны тоқтату тәсілі',
      afterOnePlank: 'Бір ірі панельді кесуден кейін',
      afterAllPlank: 'Бүкіл ірі панельді кесуден кейін',
      numberFixed: 'Кіші сандардың ұсталу дережесі',
      bufferCode: 'Кесудің соққысы панельдің беткісінің буферлік командасы',
      layoutGap: 'Панельдердің орналасу аралығы',
      layoutGapTip: 'Назар аударыңыз: Орналасу алшақтығын 0-ге орнату орналасудың қабаттасуына әкелуі мүмкін',
      wasteCutting: 'Қалдықтарды автоматты түрде кесу',
      zkPointCustomize: 'Z-түймесінің көлбеу тесігін өңдеудің айналу нүктесін теңшеу',
      sawSetting: 'Аралау параметрлері',
      cuttingLimit: 'Кесудің кесу дережесі',
      waste: 'қалдықтар',
      wasteSizeLimit: 'Ең кіші өлшемі 100 мм-ден кем болмайды',
      topLeft: 'Сол жақ, жоғарғы жақ',
      topLeftD: 'Сол жоғарғы көше',
      bottomLeft: 'Сол жақ, төменгі жақ',
      bottomLeftD: 'Сол төменгі köше',
      topRight: 'Үңгі жақ, жоғарғы жақ',
      topRightD: 'Үңгі жоғарғы köше',
      bottomRight: 'Үңгі жақ, төменгі жақ',
      bottomRightD: 'Үңгі төменгі köше',
      firstTime: 'Бірінші рет',
      secondTime: 'Екінші рет',
      thirdTime: 'Үшінші рет',
      startCutting: 'Кесуді бастау',
      thickRange: 'Қалыңдықтың ≥',
      longCut: 'Ұзақ тақта өңдеу',
      edgeSetting: 'Кеңістікті орнату',
      cuttingOrder: 'Кесу реттілігі:',
      cuttingOrderTip: 'Бұл әдісте тақтадан тыс болу дурыны бар, оқиша пайдалану',
      plankFirst: 'Кіші тақталарды алдымен кесу',
      wasteFirst: 'Қалдықтарды алдымен кесу',
      offTip: 'Жабу кезінде кесу параметрлеріндегі кесу параметрлеріне сәйкес келеді',
      edgeCutDirection: 'Кесу бағыты',
      lGapTip: 'L-жүйесіндегі қалыңыздың үлкен плитка жоғалуының орналасуын автоматты түрде және сақтау құрлығының құршығына түрде сақтау, өңдеуілік қалыңыздың үлкен плиткасын бөлек, сондай-ақ, XY аспының алмастыру функциясымен қатысуға тиіс емес',
      cylinderDir: 'Сырлымның бағытын орнату',
      onlyLong: 'Қашықты болшаты төнделу',
      backCutOrder: 'Қарсы тараптағы шетті кесу тәртібі',
      backFirst: 'Қарсы тараптағы шетті кесудің алғашқы қатар',
      backSecond: 'Қарсы тараптағы тесік пен ойықтар өңделгеннен кейін шетті кесу',
      frontReCut: 'Алғашқы тараптағы шетті қайта кесу',
      frontReCutTip: 'Өрістету қылім шеттерін жылмақ етіп, із-қалдықтарды болдырмау үшін',
      useNewCut: 'Жаңа шетті кесу ережелерін іске қосу',
      newCutTip: 'Екі тараптағы ірі тақтаның алғашқы тараптағы шетті кесудің қосымша өлшеміні пайдалану үшін',
      fixedTip: 'Назар аударыңыз: Қалдық мәні 0 немесе 1 болған жағдайда орналасу қателері болуы мүмкін',
      cuttingSlow: 'Тақтаның беткі қабатын баяу кесу',
      holeSlow: 'Тақтаның беткі қабатын баяу тесіп өту',
      slotSlow: 'Тақтаның беткі қабатын баяу арна/құбыр/тесікті өңдеу',
      slowCode: 'Баяу командасын қолдану',
      code: 'Команда',
      bufferOffset: 'Тақтаның беткі қабатының биіктігін бұрышын өзгерту',
      zkRotatePoint: 'Айналу нүктесі',
      zkRotateDir: 'Айналу бұрышының көбею бағыты',
      restSizeLimit: 'Қалдық материалдың қалған өлшем аз',
      useSaw: 'Ара пышағын қолдану',
      unGenSawPath: 'Ұзындық кесу жолын жасамау',
      suitMachine: 'Толық алюминий дәнекерлеу тақтасын өңдеу үшін жарамды',
      plankBack: 'Үлкен тақтаның артқы жағы',
      plankLeft: 'Үлкен тақтаның сол жағы',
      plankRight: 'Үлкен тақтаның оң жағы',
      plankFront: 'Үлкен тақтаның алдыңғы жағы',
      frontSide: 'Алдыңғы жағы',
      backSide: 'Артқы жағы',
      rightSide: 'Оң жағы',
      leftSide: 'Сол жағы',
      singleMachineLimit: 'Бір жақты өңдеу тақтасының алдыңғы бетінде өңдеу жолын құру және алдымен өңдеу',
      singleMachineLimitTip: 'Біріккен машиналар мен арамен кесу үшін бұл функция қолданыла алмайды',
      setBatchPositionWaring: 'Кеңес: Егер сіз кесу нүктесін жылдам түзету режимін өшіруіңіз қажет болса, оң жақтағы «Кесу нүктесін түзету» түймесін алып тастаңыз',
      setBatchPosition: 'Кесу нүктелерін жаппай өзгерту',
      setBatchPositionAs: 'Кесу бағытын өзгерту:',
      activeBatchPosition: '{activePartCount}кішкентай тақта таңдалды',
      specialFrontSide: 'Ойық бөлінісінде орнатылған арнайы ойықтар үлкен тақтаның алдыңғы жағында басымдыққа ие',
      rollCountTip: 'Оймашы станоктың нақты өңдеуіне сәйкес аудару тақталарын есептеңіз',
      specialFrontSideTip: 'Ағымдағы өндірістік желіні ауыстыру қолдау көрсетілмейді, себебі ойықтарды бөлу кезінде арнайы ойықтарды үлкен тақтаның алдыңғы жағына орналастыру немесе ойықтарды бөлу қосылғаннан кейін гравировкалау машинасында өңделген артқы ойықтарға негізделген аудару санын есептеу функциясы қосылған.',
      doubleTrim: 'Қос жаппақты қысу',
      trim: 'қысу',
      trimTwoSide: 'ئوق ئالدى жانа қызықты',
      trimFourSide: 'төрт бұрышты қысу',
      rightInmShow: 'сол жақтағы суретте көрсетілгенінде',
      currentTrimDir: 'ағымдағы таңдалған қысу жиберу бағытyna',
      cylinderTip: 'бет атау қызылдыққа арнау',
      onlyShort: 'тек кымыл бұрышты қысу',
      singleTrim: 'бір жаппақты қысу жолын құру',
      hierarchyCutTwice: 'Секторлық миллинг және слоттың қаттығына түрленган қиылыс',
      knifeDia: 'нож диаметрі менше немесе сол жоқ',
      slotDeep: 'және қанат құрылығы көппенемесе сол жоқ',
      cutTwiceSlot: 'Уақытында, қаттық секторлық қиылыс',
      twiceSlotDeep: 'Екінші қатты қиылыс ұзындығы',
      cutTwiceCondition: 'Қиысу шарттары',
      zkPointCustomizeTip: 'XY артықтарының ауыстыруын іске қосу,әрекеттер жиберу жибынуының жағдайына қарсы ауысады және негізгі нүктесі қарсы ауысады',
      zkPointCustomizeTip1: 'XY аспạnын ауыстыру функциясы іске қосылған құрылғының осы функциясы іске асырылмайды',
      isCustom: 'Таңдаулы мәндетін іске қосу',
      useCutCon: 'Қиылыс түрін қолдану шарттары',
      singleSetPlankSizeSpeed: 'Арнайы тақтай өлшемдері үшін өңдеу жылдамдығын орнату',
      singleSetPlankSizeSpeedTip: '(1. Төмендегі өлшемдерге сәйкес келетін шағын тақтайлар белгіленген жылдамдықпен өңделеді. 2. Егер шағын тақтай бір уақытта бірнеше ережеге сәйкес келсе, ертерек реттік нөмірі бар ереже қолданылады. 3. Бұл функция ара пышағымен кесуге қолданылмайды.)',
      addSpeedRules: 'Ереже қосу',
      speedRules: 'Ереже',
      shortSideSize: 'Қысқа жағының өлшемі',
      lessThanEqual: 'Кіші немесе тең',
      and: 'Және',
      longSideSize: 'Ұзын жағының өлшемі',
      processingSpeed: 'Өңдеу жылдамдығы',
      trimLenCompensation: 'Қиып түзету ұзындығы:',
      trimGenerateAPath: '0 мәні жол құрмайды:',
      cuttingMethod: 'Кесу әдісі',
      horizontalCutting: 'Көлденең кесу',
      verticalCutting: 'Тік кесу',
      openKnifeDistance: 'Қайтарудың баяу жылдамдығы'
      },
    labelingSettings: {
      title: 'Етикеттерди орнатуу',
      output: 'Автоматтык этикетка файлдарын чыгаруу',
      specification: 'Этикетка файл форматы',
      codeFrontGenerate: 'Автоматтык этiketка коддор этикетка кодуңдун алдында түзүлөт',
      templateOffline: 'Колдонулган шаблон өчірди!',
      rollLabelling: 'Башка бетке этикетка орнотуу',
      flipSetting: {
        title: 'Башка бетке орнотуу',
        engravingFlipProcess: 'Оюш машинасы этикетка орнотуу режимине өңдеуді қосуңыз',
        flipTip: 'Оюш машинада башка бетке орнотуу керек болса, осы функцияны қосуңыз'
        },
      rotateSetting: {
        title: 'Этикеткаларды айналуу',
        rotateTip: 'Таختанын көлөмү кескен же тик кескен өлчөмден кичине болсо, этикетка 90° маяттынай дайыма айналат',
        horizontal: 'Таختанын кескен көлөмү',
        vertical: 'Тахтанын тик көлөмү',
        either: 'Тахтанын кескен же тик көлөмү'
        },
      countertopSetting: {
        title: 'Таختанын орнотуу',
        startPoint: 'Иштетүү орду:',
        upLeft: 'Жогору сол',
        upRight: 'Жогору оң',
        downLeft: 'Төмен сол',
        downRight: 'Төмен оң',
        baseExchange: 'Координат базасын алмаштуу:',
        exchangeX: 'X базасын алмаштуу',
        exchangeY: 'Y базасын алмаштуу'
        },
      offset: 'Этикетка координаттардын оффсет',
      offsetTip: 'Адатта этикетка координаттары кичинекей тактанын борборунда, ал эми кээ бир шаймандарда корректирлөө талап кылынат',
      label_rotate_offset: 'Белгілердің өтіріктіктері өзгерген соң',
      label_rotate_offset_tip: 'Белгілерді өтіріктік позициясы өзгерген соң көп айрылыс болса, өзгерту керек',
      label_rotate_offset_err_tip: 'Жапсырманы айналдырғаннан кейін координаталар ығысуын қосқаннан кейін, X және Y осінің координаталық ауытқулары қажет.',
      imgSetting: {
        title: 'Байнама суреттерін орнату',
        suffix: 'Байнама суреттерінің суффикси:',
        code: 'Сурет кодирулеу әдісі:',
        codeTip: 'Png, jpeg пішімдеу суреттерінің кодирулеуін сынықтай өзгертеді, бірақ кірікті бұлт пішімдеуі осы функсияны қолданбайды',
        imgRatio: 'Байнама суреттерінің өлшемдері:',
        slowDown: 'Байнама суреттерін шығару ефективділігін төмендетеді',
        color: 'Нағыз',
        bit: 'Қара-ақ',
        resolution: 'Байнама суреттерінің өлшемдері',
        resolutionPlaceholder: 'Өлшем',
        labelPool: 'Деректердің бейнамалар қоры',
        showKey: 'өріс көрсету',
        dragTip: 'Бейнамалар қорінен бейнамаларды сүйреп тастауға болады',
        labelImgName: 'Байнама суреттерінің атауы',
        labelImgNameErrTip: 'Байнама суреттерінің атауы бос болмайды',
        labelTip1: '[Бөлшектердің штрих-коды] немесе [Бейнамалардың нөмірі] дегенді өзіңіздің белгіліңізді пайдалануыңыз керек, болмаса суреттердің үстіне қалдыруысы проблема туындайды',
        labelTip3: '【Бейнамалардың нөмірі】 - бұл кесу тізіміндегі жоғарыдан төмен қарай қатарлардың нөмірі, құжаттың кесу бетіне қосылған қатарларға мүмкін емес',
        labelTip2: '3. Байнама машинасының жүйелік үлгісі осы функсияны қолданбайды',
        delimiter: 'Бөлшегіш:',
        inputTip: '/ : ? < > | . ” * және басқа да символдар енгізілуі мүмкін емес',
        numStart: 'Байнамалардің нөмірінің бастамақ сан',
        example: 'Байнама суреттерінің атауларын өзіңіздің белгілеуіңіз (мисал)',
        stockNumOffset: 'Қарақышқалардың номерларының қосылма бітігі келеді',
        divideFolders: 'Байнама суреттері үлкен панельге сәйкес әртүрлі қапшықтарға бөлінуі',
        foldersTip1: 'Ескерту: 1. Бұл функсия "Кесу машинасының файлдарын біріктіру" функциясымен бірге қолданылмайды',
        foldersTip2: '2. Бұл функсия кірікті булт пішімдеуге әлі қолданылмайды',
        stickIntoFolders: 'Байнама файлдарын тиісті үлкен панельдің байнама суреттері қапшықтарына қосу:',
        stickTip1: 'Ескерту: 1. Бұл функсия "NC жүктемесін бірге бейнамаларды экспорту" функциясымен бірге қолдануыңыз керек;',
        stickTip2: '2. Байнама үлгісінің файлдарды құру әдісіне "Бір файлды құру" дегенді таңдауыңыз, сонда ғана бұл функсия қолданылады;',
        stickTip3: '3. Бұл функсия кірікті булт пішімдеуге әлі қолданылмайды'
        },
      pdfSetting: {
        title: 'Жапсырма PDF параметрлері',
        pdfLabelName: 'PDF ھۆججەت ئىسمى',
        example: 'ئىختىيارىي PDF ھۆججەت ئىسمى (مىسال)',
        address: 'Жоба мекенжайы',
        orderNo: 'زاكاز نومۇرى',
        firstFolder: 'Бірінші деңгейлі қалта',
        customerName: 'Тұтынушы аты'
        },
      paibanImgSetting: {
        title: 'Қалыптастыру суретті орнату',
        tip: 'Өзгертілген пішімді суреттерді экспорттау режимі қосылды. Төмендегі бекітілген үлгі экспортталмайды. Оны экспорттау үшін, пішімдеу бетіндегі «Басқа параметрлер» бөлімінен бұл функцияны өшіріңіз',
        reparation: 'Қалыптастыру суреттерінің нөмірі автоматты түрде толықтыру',
        figure: 'Орны',
        inputTip: '1-99 аралығындағы цифрларді енгізіңіз',
        paibanImg: {
          export: 'Қалыптастыру суреттерін экспорттау',
          prefix: 'Қалыптастыру суреттерінің атау префикси',
          size: 'Қалыптастыру суреттерінің өлшемдері',
          format: 'Қалыптастыру суреттерінің форматы',
          directional: 'Қалыптастыру бағыты',
          vertical: 'Вертикальді',
          horizontal: 'Горизонталды'
          }
        },
      autolabel: 'Автоматты жапсырма реттеу тәртібі',
      customTemp: 'Тек тапсырыс бойынша шаблондарға қолданылады',
      cuttingLabelOder: 'Кесу тәртібі бойынша жапсырма қою',
      labelToUp: 'Құрастыру нәтижесі бойынша төменнен жоғарыға жапсырма қою',
      labelToDown: 'Құрастыру нәтижесі бойынша жоғарыдан төменге жапсырма қою',
      labelDodge: 'Жапсырма автоматты түрде кедергілерден қашады',
      nolabelForsurplus: 'Қалдық үлкен тақталар жапсырма файлдарын жасамайды',
      settingValue: 'Орнату мәнін таңдаңыз',
      enabelTip: 'Қосылған кезде, кішкене тақтаның көрсетілген мәндерге сәйкес келуі кезінде, жапсырма айналады',
      fixedHori: 'Жапсырманың көлденең шетіне тақтаның бекітілген шетіне параллельді таңдаңыз',
      fixedHoriTip: 'Тек текстурасыз тақталарға қолданылады, қосылған кезде, жапсырма тақтаның бекітілген шетіне параллельді болады',
      tagHori: 'Жапсырманың көлденең шеті',
      effectiveTarget: 'Өрекет ететін нысан',
      allPlank: 'Барлық тақталар',
      notcarePlank: 'Тек ұнтақсыз тақталар'
      },
    drillSettings: {
      title: 'Қалыптастыру бурғылау',
      enable: 'Қалыптастыру бурғылау தொகімін іске қосу',
      toolTable: {
        use: 'Іске қосу',
        number2: 'Station 2 Drill Number',
        number: 'Қалыптастыру бурғылау нөмірі',
        diameter: 'Бургылаң діаметрі',
        xOffset: 'X ауысу',
        yOffset: 'Y ауысу',
        moveZF: 'Z осьінің жылдам жылжымалы жылдамдығы',
        feedRate: 'Z осьінің өңдеу жылдамдығы',
        moveF: 'XY осьінің жылдам жылжымалы жылдамдығы',
        benchmarkDrill: 'Бастапқы бурғы',
        addKnife: 'Құрал қосу',
        deleteKnife: 'Құрал жою'
        },
      prefix: 'Қалыптастыру бурғылау префикси',
      suffix: 'Қалыптастыру бурғылау суффикси',
      startCode: 'Қалыптастыру бурғылау іске қосу коды',
      endCode: 'Қалыптастыру бурғылау тоқтату коды',
      combineKnife: 'Қалыптастыру бурғылау біріктіру',
      combineTable: {
        prefix: 'Қалыптастыру бурғылау нөмірінің префикси',
        suffix: 'Қалыптастыру бурғылау нөмірінің суффикси',
        mainHole: 'Негізгі тесік',
        extraHole: 'Қосымша тесік',
        notes: 'Біріктіру туралы ескерту',
        firstUseNotes: 'Біріктіруді алғашқы рет іске қосу туралы ескерту',
        addExtraHole: 'Қосымша тесік қосу',
        deleteExtraHole: 'Қосымша тесік жою',
        example: 'Үлгі'
        },
      tagPool: {
        drillRowNumber: 'Бұрғылау қатарының нөмірі'
        },
      processSetting: {
        title: 'Өңдеу параметрлері',
        mode: 'Қалыптастыру бурғылау режимі',
        processTip: 'Бұл әдістің іске қосудан кейін қалыптастыру бурғылау біріктіру функциясы іске қосылмайды',
        recentHole: 'Жақын жерде тесік іздеу (бұрғыларды тез ауыстыру)',
        groupHole: 'Топтама тесік іздеу (бір топтың тесіктерді іздегенде бұрғыларды ауыстыру)',
        drill_benchmark: 'Інструменттің бағыттамасы комбинациясы (Instrument direction combination)',
        drill_benchmark_Tip: '（Диққат：Бу ыкманы танлагандан кейин, бур дрель комбинациясынын аспап бағыттамасы функциясы ишке ашпай калады）',
        mainHole: 'Бас бөлшек (Base section)',
        secondaryHole: ' Көмек бөлшек (Auxiliary section)'
        },
      changeBenchDrillTip: 'Қалыптастыру бурғылау нөміріне енгізіңіз содан кейін таңдау'
      },
    NCExportSettings: {
      jumpSkipTip2: 'Үлкен тақта түсі, қалыңдығы және материал бойынша әртүрлі қалталарға жіктеу (белгілеу файлдарымен бірге), бірдей өлшемдегі үлкен тақтаның кесу материал файлдарын бір қалтаға орналастыру',
      title: 'NC экспорттау параметрлері',
      tab1: 'Кескіш машинасының файл атау параметрлері',
      tab2: 'Кескіш машинасының файл атау біріктіру',
      tab3: 'Кескіш машинасының файлындағы ескерту',
      tab4: 'Кескіш машинасының файлындағы тип',
      tab5: 'Кескіш машинасының файл қапшығы',
      tab6: 'Өңдеу指令 параметрлері',
      tab7: 'Файл пішімі параметрлері',
      fileNameSettings: {
        twoStationAutoSort: 'Екі орны автоматты сұрыптау',
        reparation: 'Болшақтаның нөмірінің цифрліктарды толықтыру',
        figure: 'Орны',
        labelerBegin: 'Етикеткіштің бастамасы',
        machineCenter: 'Өңдеу орталығының бастамасы',
        front: 'Алғыс бет:',
        back: 'Арқасы бет:',
        customizeName: 'Қажетті файл атау (пішім):',
        example: 'Қажетті файл атау (мысалы):',
        emptyTip: 'Алғыс және арқасы беттің файл белгілері бір мезгілде бос болушы болмайды',
        labelPool: 'Деректердің белгісі топ',
        dragTip: 'Белгісі топтағы белгілерді сүйреп немесе шерту арқылы кіріс қанатына көшіріңіз'
        },
      fileMerge: {
        engravingMerge: 'Кескіш машинасының файл біріктіру',
        zfMerge: 'Алғыс және арқасы беттің біріктіру',
        singleMerge: 'Бір орны біріктіру',
        doubleMerge: 'Екі орны біріктіру',
        fEndCode: 'Арқасы беттің аяқталу коды',
        zBeginCode: 'Алғыс беттің басталу коды',
        displayfbInfo: 'Файл атауында алғыс және арқасы беттің ақпараті көрсетілу',
        fBeginCode: 'Арқасы беттің басталу коды',
        zEndCode: 'Алғыс беттің аяқталу коды'
        },
      marginalNotes: {
        addPlankInfo: 'Кескіш файл бастамасына қазіргі үлкен тақта туралы ақпарат қосу:',
        plankInfo: 'Үлкен тақта туралы ақпарат:',
        addStationCodeFirst: 'Кескіш файл бастамасына станс коды қосу:',
        addStationCodeSecond: 'Кескіш файлде зым ауыстыру алдында станс коды қосу:'
        },
      fileType: {
        zAddtion: 'Z координатасының толықтыру:',
        addSemicolon: 'Әрбір NC саптың соңына тоқтау таңбасын қосу:',
        semicolonTip: 'Таңбашаны таңдағаннан кейін сарық қолтыңның өңдеу файлы де қолданылады',
        fileName: 'Файл атау',
        defaultName: 'Әдетті файл атау',
        dedicatedName: 'Жұлдызды құрылғыларға арналған файл атау',
        xhNotes: 'Жұлдызды E2-9 ескерту',
        format: 'Кескіш машинасының файл пішімі',
        example: 'Файл үлгі: NC файл',
        stillGenerate: 'Артқы жағы өңделмеген кезде де артқы аяқтау кодын қамтитын артқы NC файлын жасау',
        generateTip: 'Бұл функсия файл біріктіру функциясымен бірге қолданылмайды',
        fileNameErrTip: 'Файл атауға келесі символдарды қосуға болмайды: / : * ? "'
        },
      categorize: 'Үлкен тақтаның түсі, матеріалды, қалыңдығы қайсы папкада (этикетка файлдарымен бірге) біріктіру:',
      simplifyG: 'Өңдеу G инструкциясының қысқаша пішімі',
      ZToW: 'Кодты Z осьінен W осіне ауыстыру',
      knives: 'Кескіш зымдары',
      lineBreakSetting: 'Жаңа саттардың пішімінің параметрлері',
      codeFormatSetting: 'Файл кодтың пішімінің параметрлері',
      utf8bom: 'BOM бар UTF-8',
      oneCodeSetting: 'Тақтаның штрих-кодтың параметрлері',
      simplifyOneCode: 'Қарапайым пішімдегі штрих-кодтың генерациясы',
      codeLocation: 'Кодтың орналасуының параметрлері',
      generateLocation: 'Станс аяқталу коды арқасы беттің аяқталу коды алдында генералады',
      emergencySetting: 'Шұғылдық параметрлері',
      show: 'Шұғылдық параметрлерін көрсету',
      emergencyCode: 'Шұғылдық коды',
      params: 'Параметрлер',
      emergencyTip: 'Сатушы қызметкерлермен бірге кейбір азиятты функцияларды уақытша іске асыруға болады',
      holeSetting: 'Делтірілеу файлдың параметрлері',
      holeFileCategorize: 'Делтірілеу файлдарды әрбір тапсырыс бойынша отынша папкада біріктіру',
      holeTip: 'Клиенттің бұлтты тақталар үшін бұл параметрлерің кۈшінеді',
      specialCodeErr: 'Арнайы символдар енгізуге болмайды!',
      copySuccess: 'Көшіру ішке асырылды!',
      copyErr: 'Көшіру сәтсіз болды, Тегі сүйретуді сынап көріңіз!',
      lengthLimit: '15 цифрлықтар ғана енгізуге болады!',
      plankInfo: 'Тақтаның ақпараты',
      otherInfo: 'Басқа ақпарат',
      uniqueBarCode: 'Қаптама штрих-коды бірегей',
      uniqueBarCodeForPack: 'Қаптама үшін тақта штрих-коды бірегей',
      machineOrder: 'Құрал-сайманның өңдеу нөмірін жасау үшін файл атауы',
      folderSetting: 'Бірдей өлшемдегі үлкен тақталардың файлдарын бір папкада сақтау',
      labelImageINCFolder: 'Қойылған белгілердің сураттарын және біргелескен белгілік файлдарды NC папkasына орналастырыңыз',
      custom: 'сварді',
      folderSettingTip: 'Ескерту: Интеграцияланған орналастыру бұл функцияны қолдамайды',
      settingMoveTip: '"{func}" функциясы "{module}" бетіне көшірілді!',
      fileManagerFunction: 'Тесіктер файлы әр түрлі тапсырыстар бойынша бөлек папкаларда сақталады',
      gotoSetting: 'Бағдарламаларға өту',
      singleFileTitle: 'Жеке файлды өңдеу параметрлері',
      slectSingleProcess: 'Жеке шығару процесін таңдау',
      slectSingleProcessTip: 'Ақылы қайталама өңдеу процестері бар, жойып қайта сақтаңыз',
      setSingleRegularSize: 'Жеке шығару үшін әдеттегі тесік пен ойық өлшемін орнату',
      holeRange: 'Тесіктің қолданылу диапазоны',
      slotRange: 'Ойықтың қолданылу диапазоны',
      holeRangeTip: 'Тесіктің қолданылу диапазоны бос болмауы керек, толтырыңыз!',
      slotRangeTip: 'Ойықтың қолданылу диапазоны бос болмауы керек, толтырыңыз!',
      yhzc: 'Доға иілу бөлігіндегі түзу ойық',
      xbgy: 'Қиғаш Haitang бұрышы және қиғаш тұтқа',
      nbyx: 'Ішкі пішінсіз пішін',
      secondaryProcessingMerge: 'Қайталама өңдеу файлдарын біріктіру',
      secondaryProcessingMergeName: 'Біріктірілген файл атауы',
      secondaryProcessingMergeTip: 'Қосылғанда, экспортталған тақтада бірнеше қайталама өңдеу процесі болса, бір өңдеу файлына біріктіріледі',
      singleFileSetting: 'Жеке файлды өңдеуді қиғаш жиектермен, шие гүлінің бұрыштарымен және қиғаш тұтқалармен шығару',
      straightArcSlot: 'Жеке файлды өңдеуді көлбеу бұрышты жиектермен шығару'
      },
    aioMachineSetting: {
      openFunction: 'Байланыстыру үшін келесі функцияларды қосу қажет',
      openCarving: 'Ою машинасын қосу',
      xyReverseFunction: 'XY осін ауыстыру функциясы',
      carvingStartSet: 'Ою машинасының басталу нүктесін орнату',
      rightTop: 'Жоғарғы оң жақ бұрыш',
      carvingEdgeSet: 'Ою машинасының алдыңғы жиегін кесу мәнін реттеу',
      finalEdgeSame: 'Жалпы жиегін кесу мәнімен бірдей',
      beginCode: 'Бағдарламаның басталу коды',
      endCode: 'Бағдарламаның аяқталу коды',
      drillHole: 'Тесік бұрғылау',
      pullTrough: 'Арнаны тарту',
      showDataTemp: 'Деректер үлгісін көрсету',
      dataTemp: 'Деректер үлгісі',
      title: 'Бірліктегі машина параметрлері',
      outputFile: 'Бірліктегі машина өңдеу файлын шығару',
      outputFileTips: 'Бірліктегі машина іске қосілгенде, XY-ді орнамастыру, файлдарды біріктіру, атайын тіркелімді тесіктік шегуімен іске асыру қосымшалар міндетті емес, оқшамауыш пайдалану',
      fileType: 'Файл пішімі',
      select: 'Таңдау',
      diameter: 'Кескіш зымнің диаметрі',
      jidongTip: 'Әржақ шаруашылық машинасын қолдануғанда, тазалоочу станциясының бастауыш нүктесініңызгі жоғарғы бұрышқа орналастырып,',
      skill: 'функциясын іске қосыңыз',
      clampHandLength: 'Ұстағыш ұзындығы(L)',
      clampHandWidth: 'Ұстағыш ені(W)',
      clampHandMargin1: 'Қолды шетінен 1 қашықтықта қысыңыз(H1)',
      clampHandMargin2: 'Қолды шетінен 2 қашықтықта қысыңыз(H2)',
      duchClampHand: 'Саңылау ұясы қысу күйін болдырмайды',
      clampHandDirection: 'Қысу бағыты',
      left: 'сол жағы',
      right: 'оң жағы',
      top: 'жоғарғы жағы',
      bottom: 'Төменгі жағы'
      },
    oneDragTwo: {
      title: 'Бірден екі кескіш машина',
      outputMachineFile: 'Бірден екі кескіш машинаның өңдеу файлын шығару',
      outputMachineFileTips: 'Бірден екі кескіш машинаны іске қосілгенде, кескіш машинамен файлдарды біріктіру функциясымен іске асыру қосымшалар міндетті емес, оқшамауыш пайдалану',
      fileType: 'Файл пішімі',
      select: 'Таңдау',
      machineStart: 'Станс басталу нүктесі',
      positionClose: 'Жабу кезінде станс басталу нүктесінің кесу параметрлеріне сәйкес орналастыру',
      engravingPlus: 'Жедел кескіш машина'
      },
    sawEngraving: {
      title: 'Қайтудық бұрысу және үстіндеу машинасы',
      preLayNav: 'Қайтару және қатау машинасының баптаулары',
      preLayKnifeInput: 'Құрыш дәңгейінің диаметрі',
      enableSaw: 'Қайта қосу жүктеу және орналастыру машинысы',
      sawAioTip: 'Сізде дәнекерлеу панелі AIO шығару рұқсаты жоқ, қосу үшін сату бөліміне хабарласыңыз.',
      cutSet: 'Қайтару бұрысын қиысу баптаулары',
      weldingPlank: 'Қайтару бұрышы',
      doorFrame: 'Қабырға рамы',
      doorFrameTip1: 'Қиысу бұрышының радиусы үлкен болмауы керек',
      doorFrameTip2: '2.Қабырға рамының қабырғалары үлкен болмауы керек 3.Қабырға рамының қабырғалары үлкен болмауы керек',
      sawUsing: 'Қайтау бұрыштың қолданысу',
      trim: 'жиегін өңдеу',
      cutBlank: 'жылжыту және ауыстыру',
      backTrimOblique: 'артқы жиегін өңдеу',
      holeSlotOblique: 'қуышқыштың қуышы',
      plankThicknessUnit: 'қабырға қалыңдығы бірлігі',
      sawUseCond: 'Қатау бұйрығының қолдану шарттары',
      exportPartData: 'Бірліктегі машина өңдеу файлын шығару',
      sawAioTip2: 'Қамалдау үшін қамалдау машинасына қолданылады',
      hasUsing: 'Қол жолына жүктеу',
      onlyUse: 'қажеттен және қолданыңыз',
      cutMethod: 'қиылу тәсілі',
      oneKnifePull: 'бір қиындық бұрышты жіберу',
      onlyOneKnifePull: 'Уақытыңызда қалайтын құрт бұрыс қиімдеу',
      enableSawThick: 'Серпе түю дейінің қатынауын іске қосу',
      edgedDir: 'Едігін қайталмаған, қайталауды жоқ түрде бөгетілген үлкен тақта бұрышы',
      sameWidthPart: 'هرһə бир үлкен 판даWidth (көргені) esi бірдей болған кіші панелдерді жинайды',
      emptyPath: 'Кӧпірді режелдеу кезінде бос жол жарай алмау',
      sawUsePlank: 'Дәнекерленген болатты ара тақтайшасымен кесу',
      paibanGap: 'Дәнекерленген болатты орналастыру аралығы',
      minSurplusWidthDiff: 'Ең аз қалдық материалдың ен айырмашылығының сәйкестігі',
      minSurplusWidthDiffTip: 'Кішкентай пластина кішкентай пластина мен қалған материал арасындағы ені айырмашылығы осы мәннен аз болса ғана қалған материалға орналастырылады',
      sawReplaceEnable: 'Тік керіткіштің қиылу жолы керіткіш тақтамен алмастырылады',
      minSawLength: 'Керіткіш тақтамен алмастыру үшін ең аз қашықтық',
      keepDistance: 'Тік керіткіштің қиылу жолында қатарлап орналасқан кең тақталар арасындағы қашықтық',
      keepDistanceTip: 'Керектігі: Керіткіш тақтамен қиылысуын болдырмау үшін қашықтықты қалың етіп қалдыру',
      sortByLength: 'Біліктің ұзындығы бойынша реттеу',
      sortByLengthTip: 'Біліктің ұзындығы бойынша реттеу',
      plankAtTop: 'Біліктің жоғары жағында орналасқан кішкентай тақта',
      plankAtBottom: 'Біліктің төмен жағында орналасқан кішкентай тақта',
      useSawTipOne: 'Іске қосқаннан кейін тек қаптамадағы дәнекерленетін тақталардың кішкентай тақталары ғана ара қырқышпен өңделетін болады, дәнекерленбейтін тақталар тікелей пышақпен кесіледі',
      useSawTipTwo: 'Іске қосқаннан кейін "Үлкен тақталарды өзгеше реттеу" функциясында стандартты үлкен тақталар қолданылмайды. Аралас реттеу қажет болса, ерекше үлкен тақталар бөліміне дәнекерленетін тақталар мен ұялы тақталардың бастапқы деректерін қосыңыз',
      useSaiTipThree: 'Бұл функцияны қосқаннан кейін, орналастыру шешімі ара кесу орналастыруын пайдалануы керек',
      surplusStoreAndLabeling: 'Қалдық материалды кесуден кейін сақтау және таңбалау мүмкін',
      surplusMinLength: 'Қалдық материалдың ең аз қолдану ұзындығы',
      surplusMinSize: 'Қалдық материалдың ең аз қолдану өлшемі',
      crossCutOnlyMinSurplusSize: 'Қалдық материалдың ең аз қолдану өлшемі орындалса ғана көлденең кесу жолы жасалады',
      surplusStoreAndLabelingTip: '1、Үлкен тақтадағы жоғары немесе төмен жағында бос қалдық аймағы пайда болады, бұл аймақтың материалы бос болып, сақтау және таңбалау мүмкін',
      surplusStoreAndLabelingTip2: '2、Дәнекерленетін тақталар үшін "Қалдық материалды автоматты түрде кесу" функциясы әсер етпейді）',
      surplusStoreAndLabelingTip3: '（Іске қосқаннан кейін',
      backCutSurplus: 'Артқы жағынан қалдық материалды кесу',
      cutSurplusTip: 'Қосқаннан кейін, артқы жақты кесу тәртібін "Артқы жақ ойықты өңдеуден кейін кесу" деп орнатыңыз',
      top: 'жоғары жақ',
      bottom: 'төмен жақ',
      left: 'сол жақ',
      right: 'оң жақ',
      dockTip: 'Дүйсенбі тұрау бөлімдерін іске асыру үшін, түтілген тақтаның төрт жиекке түйіп, бүкіл жиекпейісінен айырылуының сәйкес көрсету керек, және қолмен өңдеу арқылы бір жолақты түрлендіру керек',
      sawToLayoutTip: 'Қиындықтың жүктеуін баптау қолдауы жоқ',
      sawToLayoutTip2: 'Ара қима орналастыру қазіргі уақытта белгіленген кескіш құралды таңдауды қолдамайды',
      tempPaiabanTip: 'Жылжықты қиылуды іске қосқан соң, түрлі құрылғыларды түрлі өлшемдерді бұтаңдатын пайдалану мүмкін емес. Қосу қажет есінде, алмаз дискі бұтаңдықта қосу үшін, өңдеу тізіміне өту және түрлі құрылғыларды бұтаңдыңыз!',
      generateCutSurplusPath: 'Алдымен қалған материалды кесіп тастайтын көлденең жолды жасаңыз',
      curSurplusPathTip: 'Іске қосқан соң, артқы жақты кесу ретін "артқы тесік/олқа өңдеуден кейін кесуді"'
      },
    robotArmDocking: {
      autoLine: 'Автоматты сызық байланысы',
      autoLineTip: 'Автоматты сызық қолдану үшін рұқсатыңыз жоқ немесе қолдануға рұқсат етілген автоматты сызықтар саны жеткіліксіз',
      title: 'Механикалық қолдың байланысуы',
      enable: 'Механикалық қолдың байланысын іске қосу',
      enableTip: 'Ашылып, өндірістік файл шығарғанда, механикалық қолдың қосылу файлы шығарылады'
      },
    laserCuttingMachine: {
      title: 'Лазерлік кесу біріктірілген машинасы',
      enable: 'Лазерлік кесу біріктірілген машинасын іске қосу',
      backSafeHeight: 'Артқы жағы бос болғанда Z биіктігі (H)',
      laserDistance: 'Алдыңғы/артқы жағында кескенде лазер пышағы мен тақтай беті арасындағы қашықтық',
      coordinateAxis: 'Координаталық ось',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: 'Кесу параметрлері',
      backKnifeStore: 'Артқы қиындық сақтау',
      noSupportOriginalMaterialKnife: '"Түпнұсқа материал кесу пышағы таңдау" функциясы әлі қолдау көрсетілмейді',
      laserKnifeTip: 'Кесу ашу: Ішкі тесілмеген пішіндерді өңдеу үшін қолданылады',
      laserKnifeTip2: 'Лазер пышағы: Тесілген тесік/олықтарды, ішкі пішіндерді, сыртқы контур кесуін өңдеу',
      laserKnifeTip3: 'Назар аударыңыз: Артқы Z осі әдепкі бойынша үстел бетіне дейінгі қашықтыққа сәйкес салыстырмалы координаттарды пайдаланады',
      laserKnifeTip4: 'Пышақ саны 1-ден кем болмауы керек',
      laserKnifeTip5: 'Кесу ашу пышағын жоюға болмайды',
      laserKnifeTip6: 'Кесу ашуды таңдаған пышақ жоқ екендігі анықталды, кем дегенде бір пышақты таңдаңыз',
      laserKnifeTip7: 'Лазер пышағы ішкі тесілмеген пішіндерді өңдей алмайды, "Кесу ашу" таңдауы автоматты түрде жойылды',
      laserKnifeTip8: 'Пышақ қоймасында "Кесу ашу" опциясы бар пышақты таңдаңыз, әйтпесе ішкі тесілмеген пішіндерді өңдей алмайсыз',
      laserKnifeTip9: 'Кесу ашу пышақ қоймасындағы лазер пышағы диаметрі мен лазер біріктірілген машинаның лазер пышағы диаметрі сәйкес келмейді, тексеріңіз',
      laserKnifeTip10: 'Кесу ашу пышақ қоймасындағы пышақ диаметрі мен лазер біріктірілген машинаның пышақ диаметрі сәйкес келмейді, тексеріңіз',
      laserKnifeTip11: 'Жабдықты қосу параметрлері өзгертілді, қайта орналастырыңыз',
      noLaserPermission: 'Лазер біріктірілген машинаны пайдалану рұқсаты жоқ, пайдаланбас бұрын сату бөлімімен байланысып лазер біріктірілген машинаны пайдалану рұқсатын сатып алыңыз',
      laserOpenCode: 'Лазерлік ашылу коды',
      laserCloseCode: 'Лазерлік жабу коды',
      laserToolSettings: 'Лазерлік пышақтардың параметрлері'
      },
    firstSave: 'Қолданушыған бұлшырымды тағйырламаңыз: Бұл қолданушыған ilkіші реттін buluт тағйырламамен жұмыс істеуде. Параметрлерді сақталғаннан кейін файлдардағы кескіш бағытының орынды екендігіне назар аударыңыз, заңылмайтын шығындардан сақтану үшін',
    knives: {
      xOffset1: 'X Coordinate Offset',
      yOffset1: 'Y Coordinate Offset',
      zOffset1: 'Z Coordinate Offset',
      insert: 'Қатарды енгізу',
      delete: 'Қатарды өшіру',
      tip: '（Ескерту: Қырлық тақырыбының мағлуматын немесе настройкаларды өзгерткен кейін, кабинеттердің жобаларын жасайтын пайдаланушылар кабинет клиентін қайта бастыруы керек, сондықтан жаңғы өзгерістер қолданылады!）',
      number: 'Нөмір',
      name: 'Атау',
      diameter: 'Зым диаметріΦ',
      sawDiameter: 'Ара Қылыш ҚалыңдығыΦ',
      cutting: 'Кесу',
      use: 'Пайдалану',
      moveZF: 'Z осьдің жылдам жылдамдығы',
      axis_offset: 'Оси координатасының ауытқуы',
      arc_radius: 'Доғаның радиусы',
      cutZF: 'Z осьдің өңдеу жылдамдығы',
      moveF: 'XY осьдің жылдам жылдамдығы',
      cutF: 'XY осьдің өңдеу жылдамдығы',
      startCode: 'Зым ауыстыру бастау коды',
      stopCode: 'Зым ауыстыру аяқталу коды',
      startCode2: '工位2换刀开始代码',
      stopCode2: '工位2换刀结束代码',
      knifeLength: 'Зым ұзындығы',
      maximum_single_depth: 'Зым қатауының ең үлкен бір реттік қатауы',
      specialShapeKnifeTip: 'Толық ішкі құрылымдар үшін',
      preStartCode: 'Алдын ала іске қосу коды',
      punchHoles: 'Тырнақ ішу',
      pullSlots: 'Слоттарды ішу',
      millHoles: 'Тырнақтарды фрезерлеу',
      millSlots: 'Слоттарды фрезерлеу',
      sawBlade: 'Кескіш',
      doubleSaw: 'Дуплексті станциялар үшін әртүрлі құралды өзгерту бастау кодтарын қосыңыз',
      singleStation: 'Бір станция',
      doubleStation: 'Дуплекс',
      sawBladeTip: 'Бұл функсия бірден екі кескіш машинасы мен бірлік машинасына қолданылмайды',
      serialNum: 'Серіалік нөмір',
      sawWidth: 'Зым қашықтығы',
      sawType: 'Кескіш түрі',
      cutDirection: 'Кесу бағыты',
      moveSpeed: 'Бос жүру жылдамдығы',
      cutSpeed: 'Өңдеу жылдамдығы',
      endCode: 'Зым ауыстыру аяқталу коды',
      sawDownCode: 'Зым ішу коды',
      sawUpCode: 'Зым ішудан шығу коды',
      abscissa: 'Жакшы координаттың алдынкісі',
      ordinate: 'Жакшы координаттың ортасы',
      sawHor: 'Жақшы кескіш',
      sawVer: 'Вертикаль кескіш',
      towardsZero: '0 координатасына қарай кесу',
      awayFromZero: '0 координатасынан алыс кесу',
      diameterDesc: 'Зым диаметрі Φ',
      xOffset: 'Жакшы координатасының ауытқу',
      yOffset: 'Орталық координатасының ауытқу',
      zOffset: 'Жоғарғы-төмен координатасының ауытқу',
      offsetX: 'X ауытқу',
      offsetY: 'Y ауытқу',
      offsetZ: 'Z ауытқу',
      offsetNo: 'Ауытқу нөмірі',
      knifeWidth: 'Зым қашықтығы',
      drill: 'Зым ішу',
      cut: 'Өңдеу',
      speed: 'Айналым ылдамдығы',
      type: 'Түрі',
      millHoleSlot: 'Тырнақ/слот фрезерлеу',
      rapidFeedSpeed: 'Жылдам жеткізу жылдамдығы',
      typeOption1: 'бұрғы тұмсығы ',
      typeOption2: 'Түзеткіш аспап',
      typeOption3: 'Құрылымдық пышақ',
      typeTip: 'Сараптай салынған соқпақ түріне сәйкес, ойықтар сәйкес соқпақпен өңделеді'
      },
    other: {
      title: 'Басқа',
      tip: '（Ескерту: Бирлектегі станс құрылғысы үшін 1 және 2 станстарын автоматтық тіркелім кодымен толтыру керек)'
      }
    },
  sideHoleMachine: {
    moreSetting: 'Қосымша параметрлер',
    sideStartCode: 'Алдыңғы өңдеуде бет ауысу кодын жасау',
    useArcCode: 'Доға кесуге арналған доғалық интерполяция командасы',
    coordSwitch: 'Координаталық Негізді Ауыстыру',
    updownCoordSwitch: 'Көтеру Координаталық Негізді Ауыстыру',
    xCoordSwitch: 'Горизонтальды координаттардың негіздерінің алмастыруы',
    yCoordSwitch: 'Вертикальды координаттардың негіздерінің алмастыруы',
    knifes: {
      number: 'Номер',
      diameter: 'Қасақ ені',
      type: 'Түрі',
      moveSpeed: 'Жылдамдықпен жылдамдық',
      doSpeed: 'Өңдеу жылдамдығы',
      startCode: 'Қасақ ауыстыру бастау коды',
      endCode: 'Қасақ ауыстыру аяқтау коды'
      },
    ymSetting: 'Yimu байланыс настройкасы',
    flanking: 'Сірткі өңдеу',
    frontProcess: 'Алдыңғы өңдеу',
    oldSetting: 'Ескі параметрлер',
    equipParamsSetting: 'Құрылғы параметрлерін орнату',
    holeSetting: 'Тырнақ параметрлерін орнату',
    raminoSetting: 'Lamino қосылу параметрлерін орнату',
    mortiseTenonSetting: 'Mortise и Tenon қосылу параметрлерін орнату',
    straight: 'Түз сызық',
    eccentric: 'Эксцентрлік модель',
    pbSize: 'Жоғарғы және төменгі сыну тақтасының өлшемі',
    slotOverlapRate: 'Слоттардың қабаттасу мөлшері',
    breakingBoardDirection: 'Сыну тақтасының бағыты (Тік және горизонталь)',
    coordinateValue: 'Координаталық мән',
    codeFormat: 'Файл кодирлеу форматы',
    suffixSetting: 'Файл суффиксін орнату',
    insertRow: 'Қатар енгізу',
    deleteRow: 'Қатар өшіру',
    equipmentParams: {
      equipPauseCode: 'Жабдықтар тоқтату коды',
      wiggleCode: 'Сілкіту коды',
      equipStartCode: 'Құрылғы іске қосу коды:',
      flipPauseCode: 'Өңделгені туқтату коды:',
      equipEndCode: 'Құрылғы іске қою коды:',
      equipStartCodePlaceholder: 'Құрылғы іске қосу коды енгізу',
      retractingCode: 'Құралды қайтару командаларының коды',
      retractingCodePlaceholder: 'Құралды қайтару командасының кодын енгізіңіз',
      flipPauseCodePlaceholder: 'Өңделгені туқтату коды енгізу',
      equipEndCodeTip: 'Құрылғы іске қою коды енгізу',
      sideChangeSetting: 'Сіделік ауыстыру орнату',
      workTip: 'Әдетте сол жақтан ① бастап, шымал бұраншқа қарай өңдеу істеу',
      frontTurnCode: 'Жоғарғы бет басталу коды:',
      frontTurnEndCode: 'Жоғары бет аяқталу коды:',
      frontTurnCodePlaceholder: 'Жоғары бет басталу коды енгізу',
      frontTurnEndCodePlaceholder: 'Жоғары бет аяқталу коды енгізу',
      leftTurnCode: 'Сол бет басталу коды:',
      leftTurnEndCode: 'Сол бет аяқталу коды:',
      leftTurnCodePlaceholder: 'Сол бет басталу коды енгізу',
      leftTurnEndCodePlaceholder: 'Сол бет аяқталу коды енгізу',
      downTurnCode: 'Төменгі бет басталу коды:',
      downTurnEndCode: 'Төменгі бет аяқталу коды:',
      downTurnCodePlaceholder: 'Төменгі бет басталу коды енгізу',
      downTurnEndCodePlaceholder: 'Төменгі бет аяқталу коды енгізу',
      rightTurnCode: 'Уң бет басталу коды:',
      rightTurnEndCode: 'Уң бет аяқталу коды:',
      rightTurnCodePlaceholder: 'Уң бет басталу коды енгізу',
      rightTurnEndCodePlaceholder: 'Уң бет аяқталу коды енгізу',
      topFlipCode: 'Өңделгені коды - жоғары',
      downFlipCode: 'Өңделгені коды - төмен',
      leftFlipCode: 'Өңделгені коды - сол',
      rightFlipCode: 'Өңделгені коды - уң',
      cylinderOutCode: 'Цилиндр шығус коды',
      cylinderbackCode: 'Цилиндр қайтару коды',
      cylinderbackDirective: 'Цилиндр қайтару нұсқаулығы',
      moveDirective: 'Қозғалыс нұсқаулығы',
      moveAxisCode: 'Қозғалыс ось',
      pushAxisCode: 'Цилиндр қозғалту ось',
      swingAxisCode: 'Кыймылдан ось',
      moveCode: 'Қозғалыс коды',
      punchCode: 'Өңдеу коды',
      free: 'Бос жүру',
      punchPart: 'Өңдеу бөлім',
      cutFaceCode: 'Тасқышты оңдеу коды',
      horVerCutFace: 'Кері-жұмысқышты тасы',
      horCutFace: 'Кері-тұру тасы',
      verCutFace: 'Жұмысқышты-тұру тасы',
      specifySmallBoardMaterialNoCut: 'Кіші тақта материалын кесуге белгілеу',
      specifySmallBoardMaterialNoCutTip: 'Материалда сәйкес кілт сөздері бар тақта тек 5/6 жақты бұрғылаумен өңделген тесік және ойық файлдарын ғана жасайды, кесбейді',
      addMaterialKeyword: 'Материал кілт сөзін қосу',
      keyword: 'Кілт сөз'
      },
    tagPool: 'Деректеріңіздің белгілері',
    dragTip: 'Белгілерді сүйреп таңдау',
    knives: 'Өңдеу құрал:',
    directives: 'Өңдеу нұсқаулығы:',
    slot: 'Тік оңдеу',
    cirWork: 'Кемерлі оңдеу',
    cirInter: 'Кемерлі оңдеудің толтыру',
    cirOption1: 'Кемерлі: G03 Кемерлі: G02',
    cirOption2: 'Кемерлі: G02 Кемерлі: G03',
    coordinate: {
      xPointSymbol: 'Көлденең координаты:',
      yPointSymbol: 'Жұмысқышты координаты:',
      zPointSymbol: 'Жүкілу координаты:',
      upright: 'Қостар',
      negative: 'Кемерлі'
      },
    encodeFormat: {
      format: 'Файл кодирлеу пішімі:',
      wrap: 'Жаңу шаруашылым пішімі:',
      formatOption1: 'UTF-8 пішімі',
      formatOption2: 'ANSI пішімі'
      },
    suffix: 'Файлдің суффиксін орнату:',
    enableFP: 'Өңдеудің алдыңғы бетін іске қосу',
    slotSetting: 'Керектендіру орнату',
    slotMillSetting: 'Канал тарту / фрезерлеу орнатулары',
    millSlot: 'Тесу және фрезерлеу арналарын қолдайды',
    millingSlotOverlapRate: 'Фрезерлеу арналарындағы қабаттасу мөлшері',
    millingHoleSlotOverlapRate: 'Тесу және фрезерлеу арналарының қабаттасу мөлшері',
    takeUpDirective: 'Қырғышты алу нұсқаулығы',
    workSeparately: 'Алдыңғы/ артқы беттің керектіңдірілім екі бөлімге бөліну',
    secondSlotLong: 'Екінші керектіңдірілімнің ұзындығы',
    enableOld: 'Ескі версияның жанбалау орнатуын іске қосу',
    default: 'Әдетті орнату',
    customizable1: 'Бірінші жеке орнату',
    customizable2: 'Екінші жеке орнату',
    customizable3: 'Үшінші жеке орнату',
    customizable4: 'Төртінші жеке орнату',
    knifeSetting: 'Қырғышты орнату',
    soltTip: '(Керектендіру/ керектіңдірілімді қосу)',
    specialSetting: 'Арнайы орнату',
    ramino: 'Рамино',
    sun: 'Суньмау',
    please: 'Күтініңіз',
    designatedKnives: 'Белгіленген қырғыш',
    designated: 'Белгіленген',
    workOrder: 'Өңдеу нұсқаулығы',
    other: 'Басқа',
    nameSetting: 'Суффикс орнату',
    repeatErr: 'Номер қайталанды, қайтадан орнатуіңіз керек'
    },
  electronicSaw: {
    importMaterial: 'Материалдар тізімін імпорттау',
    formSetting: 'Электронды пісіру машинасының нысандар орнату',
    fileFormat: 'Выходні форматі файлів для список материалдар:',
    isSmallFile: 'Экспорттау шағын пікір файл:',
    fileGroupRule: 'Электронды пісіру машинасының файлдарі бойынша түс, материал және қалыңдықтық бойынша әртүрлі кестелерде:',
    roomsByCategory: 'Электрондық жаттығу файлдары бөлмелерге бөлінген тақырыпта:',
    delimiter: 'бөлімші:',
    fileName: 'Файл атауы для список материалдар:',
    fineNameTip: 'Tên tệp danh sách cắt không được để trống!',
    fileNamePlaceholder: 'Өзіңіздің материалдар тізімі',
    outputFileEncoding: 'Выходні кодирування формату:',
    utf8: 'UTF-8 боммен',
    cellTab: 'Ұяшаларды табулатура қалыптастыру:',
    texture: 'Текстурасын көрсету:',
    special: 'Арнайы пішіру:',
    notSpecial: 'Арнайы емес',
    genSimpleLabelBarcode: 'Қарапайым форматтағы тегтер мен штрих-кодтарды генерау',
    uniqueBarCode: 'Қаптама штрих-коды бірегей',
    uniqueBarCodeTip: 'Активталғаннан кейін жалпы пішіндік тег баркод функциясы қолданылмайды',
    roboticArmDocking: 'Роботтық қолдағышты орнату',
    customeForm: 'Өзіңіздің нысандар',
    tagPool: 'Деректер тегтер жинағы',
    tagPoolTips: 'Тегтер жинағынан тегтерді сүйрету немесе көшірмелеуге басыңыз',
    displayHead: 'Кестенің бастысын көрсетпеу',
    addTableHead: 'Кестенің бастысын қосу',
    deleteTableHead: 'Кестенің бастысын жою',
    generateExample: 'Выходні нысандар үлгісіні генерау',
    importExample: 'Нысандар үлгісін імпорттау',
    importExampleTip: 'Імпортталған нысандар үлгісі электронды пісіру машинасының өзіңіздің нысандарыңызға референс болып табылады',
    importExampleErrTip: 'Материалдар тізімі әлі імпортталмаған, материалдар тізімін імпорттау',
    outputExample: 'Выходні нысандар үлгісі',
    outputExampleTip: 'Өзіңіздің нысандарыңыздың выходні үлгісі',
    outputExampleErrTip: 'Выходні нысандар үлгісі әлі генералмаған, выходні нысандар үлгісі генерау',
    defaultTableHead: 'Кестенің әдетті бастысы',
    deleteHeadErrTip: 'Жоюға болатын кестенің бастысы жоқ!',
    genNonString: 'Мәтіндік емес деректер түрін жасау',
    genNonStringTip: 'Жасалған кесте деректері электронды арамен танылмай жатса, қосып көруге болады',
    revertWidth: 'Жолақты қабырға ұзындығы мен енін ауыстыру'
    },
  lockModal: {
    passwordInput: 'Құпия сөзді енгізу',
    lockPassword: 'Құпия сөзді ашу ұсын',
    lockPasswordInput: 'Құпия сөзді ашу ұсын',
    passwordInputPlaceholder: 'Төрт таңбалық құпия сөзді енгізу',
    editPassword: 'Құпия сөзіні өңдеу',
    confirmPassword: 'Құпия сөзіні растау',
    setLockPwd: 'Құпия сөзді ашу ұсын',
    pwdFormatErr: 'Құпия сөздің пішімі дұрыс емес',
    sendMessageTo: 'Кодты смс-хабарламашы',
    captchaPlaceholder: 'Кодты енгізу',
    sendCaptcha: 'Кодты жіберу',
    sendSeccess: 'Смс-хабарлама жіберілді',
    sendFail: 'Смс-хабарлама жіберуге сәтсіз, кейінгіре тексеріңіз',
    updateSeccess: 'Құпия сөздің орнатылуы сәтті',
    editSuccess: 'Құпия сөздің өзгерісі сәтті',
    lockSeccess: 'Құпия сөзден ашу сәтті',
    lock: 'Ашу',
    lockSeccessTip: 'Бекіту сәтті',
    inputErrLimit: 'Қазіргі қатетіңіздің шегіні ашу, қайтадан құпия сөздің орнатылуын орнату!'
    },
  dock56Drill: {
    equipType: 'Құрылғы түрі',
    equipment: 'Устройство',
    fiveDock: 'Бес жақты бұрғылау машина',
    sixDock: 'Алты жақты бұрғылау машина',
    fileType: 'Құрылған файл түрі',
    templateOffline: 'Қолданылатын шаблондыңыз қызметтілігі тоқтатылды!',
    showExample: 'Деректер үлгісін көрсету',
    conNoticeTip: 'Қосымша ескерту:',
    conNoticeTip1: '"XY осьтері алмастыру" қолданылған оюу машинасында "Торғай және Сөре Өңдеу Құралы Автоматикалық Қатынас Алмастыру" функциясын қолдану қажет',
    conNoticeTip2: '2. Бес/алты жақты бұрғылау машинасында панельдің арнайы бөліктерді көрсету немесе өңдеу үшін шаблонда арнайы бөліктердің деректерін конфигурациялау керек',
    conNoticeTip3: '3. Бес/алты жақты бұрғылау машинасын алғашқы қолдану кезінде немесе шаблонды ауыстырғаннан кейін, қаптамасының сынақтық өндірісі істеуіш, содан кейін қалыпты өндіріске кіріңіз',
    conNoticeTip4: '4. Сынақтық өндіріске кіріп, панельдің алдыңғы және артқы бетіндегі тесіктің, тереңдің, орналасқан бетің және орналасуың дұрыс екендігіне мұқайық бақылау,қаптамалардің зергілікті көрінісі болмау үшін',
    example: 'Деректер үлгісі',
    commonSetting: 'Жалпы параметрлерді орнату',
    throughHoleSetting: 'Толық тесіктің екі бетіне дейін ішкірілу',
    throughSlotSetting: 'Толық слоттің екі бетіне дейін ішкірілу',
    nonHolesNotFiles: 'Квадраттық панельде тесіктер мен слоттары болмаса, файл ішкірілмейді:',
    frontFileIdentifier: 'Алдыңғы беттің файл белгісі:',
    oppositeFileIdentifier: 'Артқы беттің файл белгісі:',
    oppositeFileIdentifierTips: 'Қалыптастыру әдісі: алғашқы 13-шілікті панельдің кодты + белгілікі метін',
    arcDescription: 'Кемердің сипаттама әдісі',
    linePoints: 'Сызықтық пішірудің сипаттамасы',
    arcCommand: 'Кемердің командалық сипаттамасы',
    slotWidthSplit: 'Кең слоттың бірнеше жіңілік слоттарына айырылуы:',
    slotSplitWidth: 'Айырылғаннан кейінгі жіңілік слоттың ені:',
    mm: 'Ескерту: Айырыланатын нысандар қалыпты ректангульікті слоттар',
    isNotMergeSlot: 'Үшіншісің бар кенітті және терең слоттарды біріктіру:',
    slotPunchTip: 'Бұл функциясы тек жеке шаблондыңыздың артқы панель слоттары мен сандықтің астынары слоттарына ғана қолданылады',
    sizeRange: 'Үшіншісің бар кенітті және тереңсіздің кішісі',
    enableWorningTip: 'Бұл функциясы алдыңғы шеттің орналасу бағытымен бір мезгілде іске қосылмайды',
    longDirection: 'Панельдің ұзын бағытының орналасу бағыты',
    horizontal: 'Кеңдегі',
    vertical: 'Вертикалды',
    slotDirection: 'Бес/алты жақты бұрғылау машинасының слоттарының немесе арнайы пішірудің орналасу бағыты',
    default: 'Системаның әдетті параметрлері',
    frontLeft: 'Алдыңғы және сол жақ',
    frontRight: 'Алдыңғы және оң жақ',
    backLeft: 'артқы және сол',
    backRight: 'артқы және оң',
    frontDirection: 'Алдыңғы шеттің орналасу юнітелі',
    enableTip: 'Ескерту: Бұл функциясы тек бұлтты нұсқадау үшін қолданылады',
    fixedOn: 'Қаталды:',
    front: 'Алдыңғы бет',
    back: 'Артқы бет',
    left: 'Сол жақ',
    right: 'Оң жақ',
    coordinateValue: 'Координаттардың сақталған цифрлар саны:',
    decimalPlaces: 'Цифрлар',
    slotLengthCompensation: 'Ойық ұзындығының өтемақысы',
    curveholesLengthCompensation: 'Ішкі ерекше пішіндердің өтемақысы',
    slotCompensationEqualZero: 'Қашықтық нөл болған кезде ойық жиегінің өтемақысы',
    slotCompensationNotEqualZero: 'Қашықтық нөл болмаған кезде ойық жиегінің өтемақысы',
    slotCompensationTip: 'Өңдеу кезінде толық емес кішкентай дөңгелек бұрыштар немесе жеткіліксіз ұзындық байқалған кезде осы функцияны пайдаланыңыз',
    curveholesCompensationEqualZero: 'Қашықтық нөл болған кезде ойық жиегінің өтемақысы',
    curveholesCompensationTip: 'Тақтайдың ішіндегі ерекше пішіндерді фрезерлеу құралының радиусын енгізу қажет:',
    curveholesCompensationTip2: 'Тақтайдың ішіндегі ерекше пішіндерді фрезерлеу құралының радиусын енгізу қажет:',
    specialParameter: 'Арнайы параметрлерді орнату',
    output5FDrillSlotKnifeCode: 'XML2 фрезерлік слоттың құрал коді',
    output5FDrillShapeKnifeCode: 'XML2 фрезерлік пішірудің құрал коды',
    plankTexture: 'XML2 панельдің текстурасы',
    offset: 'XML2 фрезерлік пішірудің құралдарының компенсациясы',
    mprConHoleDir: 'Бес/алты жақты бұрғылау машинасының MPR файлінің сыртқы жанбалардағы тесіктің Z координатасының базалық плоскості',
    plankTop: 'Панельдің жоғарғы беті',
    plankBottom: 'Панельдің төменгі беті',
    codeInfo: 'ban форматты файл Code ақпаратты қамтиды:',
    bomFile: 'bom форматты файл шығару:',
    plankHeight: 'Панельдің биіктігінің сипаттамасы:',
    plankNum: 'Панельдің нөмірінің сипаттамасы:',
    backZpoint: 'Артқы слоттың Z координатасы:',
    plankThick: 'Панельдің қалыңдығы',
    slotDeep: 'Слоттің тереңдігі',
    outputMprFile: 'Файл түрі',
    oldMPR: 'Ескі MPR',
    newMPR: 'Жаңа MPR',
    mprFileZside: 'Бес/алты жақты бұрғылау машинасының MPR файлінің сыртқы жанбалардағы тесіктің Z координатасының базалық плоскості',
    fileTypeOffline: 'Қазіргі таңдаулықты бес/алты жақты бұрғылау машинасының файл түрі қызметтілігі тоқтатылды. Ескертуіш!',
    permissionErr: 'Қызметтеріңіз жоғалды, шаблоннан қайтадан осы бетті ашуіш!',
    banFileSetting: 'ban форматты файлды орнату',
    banFileCodeInfo: 'ban форматты файл Code ақпаратты қамтиды:',
    huahuaLine: 'Хуахуа автоматты желісі',
    huahuaLineTip: '(Қамтамасыз етілмейді: кесу кезіндегі қалдық кесімі)',
    huahuaPartFlag: {
      longSide: 'Ұзын жағы кіші',
      shortSide: 'немесе қысқа жағы кіші',
      partFlag: 'панельдің кішкентай тақта белгісін жасау',
      tip: 'Жапсыруда «Панель белгісі-кіші панель белгісі» деректерін көрсету қажет, Ха-ха автоматты желі файлында тиісті деректер автоматты түрде қосылады.'
      },
    plankPutWay: 'Тақтайды орналастыру тәсілі',
    plankPutWayTip: 'Ако текущата производствена линия е включена, автоматичната линия Huahua не поддържа отделното разположение на панелите',
    autoHandle: 'Қысқышты автоматты түрде айналып өту',
    manualHandle: 'Қолмен айналып өту параметрі',
    fixedFront: 'Тұрақты алдыңғы жиектеу',
    plankNamePlacement: 'Тақта атауы бойынша орналастыру',
    plankNamePlacementTip1: '1. Бапталғаннан кейін, тақта атауында берілген өріс болса, тақтаның сәйкес қабырғасы құрылғының көрсетілген жағына бекітіледі',
    plankNamePlacementTip2: '2. Бұл баптаудың басымдығы жоғарыдағы тақтаны орналастыру тәсілі баптауынан жоғары',
    plankNamePlacementTip3: '3. Бұл мүмкіндік тек бұлттық орналастыру үшін жарамды; ағымдағы өндіріс жолында Huahua автоматты сызығы қосылса, тақтаны бөлек орналастыру баптауы қолдау көрсетілмейді',
    addRow: 'Қатар қосу',
    plankNameTip: 'Тақтаның атауын енгізіңіз',
    plankSide: 'Тақта қабырғасы',
    deviceSide: 'Құрылғыға бекіту',
    weldingPlatePlacementEnable: 'Тұрақты қысқыштың жағындағы қысқыш',
    onlyBluen: 'Тек бұлттық орналастыру үшін жарамды',
    fixedEdge: 'Тұрақты ұзындықтық қысқыш',
    fixedEdgeRule: 'Қағида: Тақтайдың орналасуын анықтау',
    fixedEdgeRuleItem1: 'Қысқыштың жағындағы ұзындықтық қысқыш',
    fixedEdgeRuleItem2: 'Қысқыштың жағындағы қысқыш',
    fixedEdgeRuleItem3: 'Ойықтар мен ерекше пішіндер қысқыштың жағынан автоматты түрде айналып өтеді, бұл тақтайды өңдеуді жеңілдетеді',
    fixedEdgeRuleItem4: 'Приоритеттілік реті',
    satisfiedCondition: 'Шарт орындалды',
    handDirection: 'Қысқыштың орналасу бағыты',
    handleMachineTip: 'Айналдыру арқылы ойықтар мен ерекше пішіндер қысқыштың жағынан автоматты түрде айналып өтеді, бұл тақтайды өңдеуді жеңілдетеді',
    handleWidth: 'Қысқыштың ені',
    handleLength: 'Қысқыштың ұзындығы',
    handleMaxWidth: 'Жабдықтың өңдей алатын ең үлкен ені',
    usefulRange: 'Жарамды диапазон',
    plankLongSide: 'Тақтайдың ұзын жағы',
    usefulRangeTip: 'Егер тақтайдың ұзын жағын орналастыру қосылып, оның ұзын жағы осы жарамды диапазонда болса, ойық пен ерекше пішіннің орналасуы басымдыққа ие болады',
    moveTip: 'Бұлттық орналастырудағы файл белгісінің функциясы қайта орнатуға жылжиды',
    millingOuter: 'сыртқы формалық фрезерлеу',
    millingInner: '‌Ішкі ерекше пішінді фрезерлеу',
    drilling: 'Тесік істеу',
    slotting: 'Орық жасау',
    knivesTip1: '1. Фрезерлеуге арналған арнайы пышақты орнатқаннан кейін, кесу траекториясы пышақ радиусына қарай коррекцияланады',
    knivesTip2: '2. Формалық кесу қазіргі уақытта X-Y осьтерін ауыстыру функциясы бар ою станоктарын қолдамайды',
    internalCutting: 'Ішкі бітімі бейқим кесу кезінде, кескіш құралдың түсуі де, алынуы да ішкі жағында болуы керек. тақта.',
    externalCutting: 'Сыртқы ерекше пішіндердің қырқықтары мен қырқықтары қысқыштың ішінде орналасады. тақта.',
    externalCuttingDirection: 'Сыртқы ерекше пішіндердің қырқықтары мен қырқықтары қысқыштың ішінде орналасады',
    allExternalCutting: 'Барлық сыртқы пішіндер',
    onlyArcExternalCutting: 'Тік бұрышты сыртқы пішіндер тік бұрышты'
    },
  doorWallCabinet: {
    tempErrTip: 'Есік-қабырға-шкаф біріктірілген машинасына арналған үлгі қосылмағаны анықталды, сондықтан өңдеу файлын экспорттау мүмкін емес. Ескерту: қосқаннан кейін қайта орналастыру қажет.',
    title: 'Қабырға және шкафты құрастыру машинасы',
    guifang: 'Қосымша квадраттау',
    processingTechnology: 'Өндеу технологиясы',
    longPlateSecondarySquaring: 'Қосымша квадраттау',
    slotOnDoorPlate: 'Slot on Door Plate',
    setting: 'Қабырға және шкафты құрастыру машинасын баптау'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: 'Чықару файл пішімі',
    outputDefaultFileFormat: 'Қалыпты файлды шығару',
    outputMPRFormat: 'MPR пішімді файлды чыгару',
    fileFormatSettings: 'Файл пішімінің параметрлері',
    wrapSettings: 'Қайта бастау белгісінің пішімі:',
    enCodeSettings: 'Файл кодлау пішімі:',
    utf8bom: 'BOM бар UTF-8',
    partCoordinate: 'Кишіктік панельдің координатасы',
    xPointSymbol: 'Жақыстық координата:',
    yPointSymbol: 'Жүзілік координата:',
    zPointSymbol: 'Көтеру координата:',
    upRight: 'Қостар',
    negative: 'Қайтар',
    plankMirroring: 'Панельдің көрінісі',
    plankMirrorSetting: 'Панельдің көрінісінің параметрлері:',
    xAxis: 'X осьсінің көрінісі',
    yAxis: 'Y осьсінің көрінісі',
    mirrorTip: '（Панельдің көрінісіде осы функцияны қолдану）',
    knifeTable: {
      type: 'Түрі',
      diameter: 'Диаметр Φ',
      offsetX: 'X ауысу',
      offsetY: 'Y ауысу',
      offsetZ: 'Z ауысу',
      offsetNo: 'Ауысу нөмірі',
      drillVelocity: 'Қырқық ату [F]mm/min',
      cutVelocity: 'Қыру [F]mm/min',
      rotationSeep: 'Айналу шығымы [S]r/min',
      insertRow: 'Сатыр енгізу',
      deleteRow: 'Сатыр жою'
      },
    labelPool: 'Деректердің белгісі топ',
    dragTip: 'Белгісі топтағы белгілерді сүйреп же шерту арқылы шығу ісіне көшіріңіз',
    procedure: 'Процедура',
    beginCode: 'Процедура басталу коды:',
    endCode: 'Процедура аяқталу коды:',
    zzdKnifeBeginCode: 'Негізгі қырқық алмастыру басталу коды:',
    spindleCutter: 'Негізгі қырқық',
    zzdKnifeEndCode: 'Негізгі қырқық алмастыру аяқталу коды:',
    verticalDrill: 'Тік қырқық',
    czzBeginCode: 'Тік қырқық іске қосу коды:',
    czzEndCode: 'Тік қырқық іске тоқтау коды:',
    czzKnifeBeginCode: 'Тік қырқық алмастыру басталу коды:',
    czzKnifeEndCode: 'Тік қырқық алмастыру аяқталу коды:',
    sidetrack: 'Сіде трак',
    czBeginCode: 'Сіде трак іске қосу коды:',
    czEndCode: 'Сіде трак іске тоқтау коды:',
    czKnifeBeginCode: 'Сіде трак алмастыру басталу коды:',
    czKnifeEndCode: 'Сіде трак алмастыру аяқталу коды:',
    pauseCode: 'Тынықтау коды:',
    zSafeHeight: 'қауіпсіз аралық',
    spindleKnife: 'Нұрлық бұрыштың және вертикалды құрылғының Z арқатаның қауіпсіз бұрышты',
    sideDrillZ: 'Бұрыштың Z арқатаның қауіпсіз бұрышты',
    sideDrillXY: 'Бұрыштың X/Y арқатаның қауіпсіз аралығы',
    auxiliaryFunction: 'Қосымша функсия',
    xhDedicatedInfo: 'Жұлдызды құрылғыларға арналған ақпаратты жасау',
    xhCheckBox: 'Деректер:',
    outputSettings: 'Чыгару параметрлері:',
    partExegesis: 'Файлда кішіктік панельдің өлшемдері туралы түсініктемелерді жасау',
    knifeNo: 'Қырқық нөмірі',
    specailKnifeNo: 'Арнайы пішіруінші қырқық нөмірі:',
    slotKnifeNo: 'Слот қырқық нөмірі:',
    fileNamePlaceholder: 'Өзіңіздің іске кіріс тізіміңіз',
    slotDrill: 'Сыртқа тікеуіш қырқық'
    },
  glassEquip: {
    title: 'Шыны кескіш машина',
    fileType: 'Құрастыру файл түрі:',
    sizeReparation: 'Панельдің өлшемдеріні толықтыру:',
    cutPreSpace: 'Панельдерді кесу алдын ала аралық:',
    divideIntoFolders: 'Шыны түсі, материалы және қалыңдығы бойынша файлдар қапшығына жіктелу:'
    },
  translate: {
    search: 'Терминді табу үшін қытай тіліне немесе ресми аудармасына енгізуіңізді сұраймын',
    en: 'Ағылшынша',
    es: 'Испан тілі',
    ar: 'Араб тілі',
    kz: 'Қазақша',
    vi: 'Вьетнам тілі',
    th: 'Тайский язык',
    id: 'Индонезийский язык',
    ug: 'Ұйғыр',
    customTranslate: 'Реттелетін аударманы қосу үшін басыңыз',
    customText: 'Реттелетін аударма',
    text: 'Қытай тілі',
    targetLang: 'Ресми аудармасы',
    zh_hant: 'Дәстүрлі қытай'
    },
  preLayoutSetting: {
    title: 'Алдын ала орналастыру баптаулары',
    titleTip: 'Алдын ала орналасу параметрлерін алдын ала орнатуға болады, алдымен орналастырып, содан кейін өндіріс желісін таңдаңыз',
    settingTip: 'Өндіріс желісінде орнатылған параметрлер төмендегі алдын ала орналастыру параметрлерімен сәйкес келуі керек, сонда ғана өндірістік файлдарды шығару мүмкін болады, тек кесу машинасына қолданылады',
    emptyKnife: 'Құрал көрсетілмеген',
    noModify: 'Параметрлер өзгертілмеген, сақтаудың қажеті жоқ',
    reSet: 'Қалпына келтіру',
    gayPosition: 'Сұр блок артық материалдың орнын ауыстыру үшін ауыстырылуы мүмкін',
    surplusPosition: 'Ағымдағы артық материалдың орны',
    click: 'Басыңыз',
    grayStart: 'Сұр блок жұмыс орнын бастауды ауыстыру үшін ауыстырылуы мүмкін',
    currentStart: 'Ағымдағы жұмыс орнының басталуы',
    holeSlotSetting: 'Тишек сондырау бассейни ишлеу настройкалары',
    knifeDiameter: 'Кесу құралының диаметрі',
    currentVersion: 'Ағымдағы нұсқа',
    on: 'Қосу',
    off: 'Өшіру',
    firstShort: 'Алғашқы кесу - қысқа жағын кесу',
    firstLong: 'Алғашқы кесу - ұзын жағын кесу',
    cuttingSplitLong: 'Ұзын тақтаны екі рет кесу - ұзын жағының артықтығы',
    cuttingSplitShort: 'Ұзын тақтаны екі рет кесу - қысқа жағының артықтығы',
    plankThick: 'Кәдімгі тақтаның қалыңдығы ≥ ',
    singleDoorThick: 'Есік тақтасының қалыңдығы ≥ ',
    normalPlank: 'Кәдімгі тақта',
    confilictTip: 'Қондырғылардың қайшылығы бар: {confilictTotal} элемент',
    selectLine: 'Өндіріс желісін таңдаңыз',
    selectLinePlaceholder: 'Өндіріс желісін таңдаңыз',
    lineConfilictTip: 'Өндіріс желісін таңдау {line} мен қайшылыққа әкеледі',
    preWay: 'Алдын ала орналасу жоспары',
    paibanErrTip: 'Ұзын тақтаны өңдеу кезінде [ұзын және қысқа жақтарының кеңеюі] өзгерсе, орналасу сәтсіз болуы мүмкін',
    paibanTip: 'Бұл жолғы орналасуда үлкен тақта материалының кесу пышағы белгіленген, қайта орналасу қажет',
    reLayout: 'Ағымдағы өндіріс желісі бойынша қайта орналасу',
    fetchErr: 'Алдын ала орналастыру параметрлерін алу сәтсіз аяқталды',
    resetSuccess: 'Қалпына келтіру сәтті аяқталды',
    resetConfirm: 'Тарихи нұсқаға қайтару үшін растайсыз ба?',
    prolineName: 'Өндіріс желісінің атауы',
    layoutGap: 'Орналастыру аралығы',
    generalThickness: 'Екінші кесу нысаны - Әдеттегі тақтаның қалыңдығы',
    cutGeneralPlank: 'Екінші кесу нысаны - Әдеттегі тақта',
    cutSingleDoor: 'Екінші кесу нысаны - Есіктің панелі',
    secondary_cutting_board_list: 'Тақта атауын кесу тақтасының бөлігінің атау тізімін көрсетіңіз',
    changeProline: 'Өндіріс желісін ауыстыру',
    backTip: 'Өндіріс желісін таңдау үшін глобалды орналастыруға оралыңыз',
    preLayout: 'Алдын ала орналастыру схемасына сәйкес орналастыру',
    preWayEmpty: '(Бос)Алдын ала орналастыру схемасы',
    specialConfilictTip: 'Таңдалған өндіріс желісі доға фрезерлеу процесінің параметрлеріне әсер етеді, қайта орналасу қажет'
    },
  lunbo: {
    tips: 'Қолдану шетіктері',
    introduction: 'Функциялық сипаттама',
    qtDownloadText: 'Ескерту: Егер файл толық жүктелмесе, онда бұл файлды бұлтты пішімдеу веб-сайтынан жүктеуге болады!'
    },
  sendModal: {
    paibanImgType: 'Теру диаграммасының файл түрі'
    },
  authenticationModal: {
    title: 'QR Code темінліш қылыш',
    tip: 'Темінліш қылыш аяқталғанша қаптамасыз қалыңыз!',
    countdownTip: '{countdown} аяқталғаннан кейін',
    refreshTip: 'QR Code темінліш қылыш',
    qrcodeTip: 'Өндіріс жұмысын аяқтау үшін QR Code темінліш қылыш',
    qrcodeTip2: 'QR Code темінліш қылыш мүмкін емес болса, қаптамасыз қалыңыз',
    waiting: 'QR Code темінліш қылыш тартасыз',
    scanning: 'QR Code темінліш қылыш тартасыз, темінліш қылыш тартасыз',
    success: 'Темінліш қылыш мүмкін емес болса, темінліш қылыш тартасыз',
    error: 'Темінліш қылыш мүмкін емес болса, темінліш қылыш тартасыз',
    expired: 'QR Code темінліш қылыш аяқталғаннан кейін',
    tip2: 'Тіркелгі деректеріңіздің қауіпсіздігі үшін қазіргі операцияны орындайтын қызметкердің ақпаратын растаңыз',
    tip3: 'Өндіріс тестілеу үшін қаптамасыз қалыңыз, {fontStyleStart}қаптамасыз қалыңыз, қаптамасыз қалыңыз{fontStyleEnd}'
    },
  printTag: {
    dualLanguageTip: 'Сізде қытай-ағылшын қос тілді жапсырмаларды жасауға рұқсат жоқ, қазір тек алдын ала көру қолжетімді; толық пайдалану үшін сату бөліміне хабарласыңыз~',
    generateDualLanguageTagTip: 'Қытай-ағылшын қос тілді жапсырмаларды жасау',
    dualLanguageTip2: 'Бұл ақылы функция. Пайдаланбас бұрын қосу үшін сату бөліміне хабарласыңыз~',
    effectiveDataSource: 'Эффективные данные источника',
    partName: 'Тақта атауы'
    },
  userAccessToken: {
    createTime: 'Жасалу уақыты',
    lastUsedTime: 'Соңғы пайдалану уақыты',
    expireTime: 'Мерзімі өту уақыты',
    status: 'Күй',
    tokenNamePlaceholder: 'Токен атын енгізіңіз',
    expireTimeSelectPlaceholder: 'Мерзімі өту уақытын таңдаңыз',
    securityBannerTip: 'Жеке кіру токеніңізді басқалармен бөліспеңіз немесе браузерде немесе басқа клиент кодында ашып көрсетпеңіз. Аккаунтыңызды қорғау үшін, жария орында ашылған токендер автоматты түрде өшірілуі мүмкін.',
    expired: 'Мерзімі өткен',
    valid: 'Жарамды',
    remove: 'Жою',
    previewOnceWarning: 'Бұл токен тек бір рет көрсетіледі. Құпияны қауіпсіз, қолжетімді жерде сақтаңыз. Басқалармен бөліспеңіз немесе браузерде немесе басқа клиент кодында ашып көрсетпеңіз.',
    token: 'Токен',
    deleteConfirm: 'Бұл токенді жоюға сенімдісіз бе?',
    userAccessToken: 'Пайдаланушының кіру токені',
    dayUnit: 'күн',
    custom: 'Реттелетін',
    previewModalTitle: 'Жаңа жеке кіру токені',
    addModalTitle: 'Жаңа жеке кіру токенін қосу'
    },
  bujianStore: {
    inputPlaceholder: 'Тақта штрих-кодын енгізіп, толықтыруға арналған шағын тақтаны іздеу',
    noData: 'Дерек жоқ',
    loadingErr: 'Толықтыру тақталарын жүктеу сәтсіз аяқталды',
    bujianStore: 'Толықтыру қоймасы',
    awaitStore: 'Орналастыруды күту қоймасы',
    noDrag: 'Тақта орналастыруды күту қоймасына салу сәтсіз аяқталды',
    outOfCanvas: 'Тақта материалы, түсті және қалыңдығы қалай жазылғанын тексеріңіз'
    },
  alginTexture: {
    tip: 'Бұл әрекет тақта кездестіру деректерін тазалайды, жалғастыруды растайсыз ба?',
    tip2: 'Бұл әрекет тақталар арасындағы аралықты өзгертеді, өңдеу мәселелерін тудырады. Жалғастыруды растайсыз ба?',
    group: 'Технологиялық топ',
    groupTemp: 'Технологиялық топ бірінші',
    textureAlignmentPlank: 'Текстурасы теңестірілген тақтаны жылжыту мүмкін емес'
    },
  customizeFolder: {
    customizeFolder: 'Қаптамады баптау',
    customizeFolderTip: 'Ескерту: Қаптамаларды баптауды қосуғаннан кейін, бұрын орнатылған қаптамалар бөлінуы ережелері басылымын жоғалтады',
    processingFilesTitle: 'Файлдардың деректерін өңдеу',
    dragToFolderTip: 'Сол жақ қаптамаға көрілек немесе файл ретінде көтеруге болады',
    folderNameEmpty: 'Қаптаmanın атауы бос болмауы керек',
    folderNameExists: 'Ол边塞 атауы бар қаптама бар',
    fileNotFound: 'Дұрыс файлды алу сәтсіз болды',
    fileCannotBeClassified: 'Бұл типтік файлдар ешқандай классификация қаптамалары астында орналасуы мүмкін емес',
    cannotAddAtThisPosition: 'Бұл орналасу жерінде қосуға болмайды',
    fileAlreadyExists: '【{name}】бұл қаптамada бұрыннан бар',
    confirmDeleteFolder: 'Бұл қаптаманы жоюға сенімдісіз бе?',
    confirmDeleteItem: '【{name}】-ды жоюға сенімдісіз бе?',
    confirmDeleteFolderWithChildren: 'Бұл қаптаманың астында басқа қаптамалар/файлдар бар, оны жоюға сенімдісіз бе?',
    deleteFile: 'Файлды жою',
    addSubFolder: 'Қол қаптама қосу',
    editFolder: 'Қаптаманы өңдеу',
    deleteFolder: 'Қаптаманы жою',
    rootCannotDelete: 'Коренеу каталогы жойыла алмайды',
    newFolder: 'Жаңа қаптама',
    fileUsedCanDrag: 'Қолданылған - Кейін-жайысы көтеруге болады',
    fileDraggable: 'Көтеруге болады',
    addFileToFolder: '【{fileName}】-ды {folderName}-ға қосу',
    addFolderTitle: 'Қаптама қосу',
    editFolderTitle: 'Қаптаманы өңдеу',
    folderNameLabel: 'Қаптаmanın атауы',
    folderNamePlaceholder: 'Қаптаmanın атауын енгізіңіз',
    sequenceStartLabel: 'Жуылу секвенциясының бастау мәні',
    classifyMethodLabel: 'Классификация әдісі',
    nameLengthLimitLabel: 'Символдар ұзындығы սауырымы',
    tagInsertTip: 'Қаптаmanın атауына кирүү үшін теги басыңыз',
    classifyTagInsertTip: 'Қаптаmanın атауына кирүү үшін теги басыңыз, файлдар бекітілген тег бойынша классифицируется',
    engraving_front: 'Ортақ машинаның алдыңғы файлы',
    engraving_opposite: 'Ортақ машинаның қарсы файлы',
    engraving_merge: 'Ортақ машинаның біріктірілген файлы',
    engraving_mill: 'Екінші рет өңделген мінеқ жолақсының фрезкасы',
    engraving_haitang: 'Екінші рет өңделген қиялы Haitang бұрышының файлы',
    engraving_arc_slot: 'Екінші рет өңделген төменгі дairesel жолақының фрезкасы',
    engraving_line_slot: 'Екінші рет өңделген қалаулы аспап жолы',
    engraving_straight_arc_slot: 'Екінші рет өңделген дairesel ийілуы бөлігі түз жолақы',
    engraving_frame_door: 'Екінші рет өңделген сүйектік есік файлы',
    engraving_inner_shape: 'Екінші рет өңделген ішкі пішімі',
    engraving_hole: 'Екінші рет өңделген үнсіз дыбыл',
    engraving_slot: 'Екінші рет өңделген үнсіз قنوات',
    engraving_single_file_merge: 'Екінші рет өңделген файл біріктіру',
    electronic_saw: 'Электронды пилка файлы',
    glass: 'Шиша қесу машинасының файлы',
    glass_machine: 'Шиша қесу машинасы',
    side_machine: 'Ж kylы дыбыл машинасының файлы',
    side_machine_xml3: 'Ескі нұсқасы ж kylы дыбыл машинасының XML3 файлы',
    side_machine_txt: 'Ескі нұсқасы ж kylы дыбыл машинасының TXT файлы',
    side_machine_nc: 'Ескі нұсқасы ж kylы дыбыл машинасының NC файлы',
    dock56F: 'Бес/алты жаңбақлым дыбыл файлы',
    ptp: 'PTP файлы',
    aio: 'Біріктірген машинасының файлы',
    aio_anc: 'Көп функциялы машинаның алдыңғы ANC файлы',
    labeling_1: 'Белгілеу машинасының 1-ші файлы',
    labeling_2: 'Белгілеу машинасының 2-ші файлы',
    labeling_3: 'Белгілеу машинасының 3-ші файлы',
    robotic_arm: 'Роботік қолының файлы',
    label_image: 'Бейнес суретінің файлы',
    label_pdf: 'Бейнес PDF файлы',
    paiban_image: 'Типографиялық сурет файлы',
    paiban_pdf: 'Типографиялық сурет PDF файлы',
    engraving: 'Қорытынды машинасы',
    electronic: 'Электронды пилка',
    side_hole: 'Ж kylы дыбыл машинасы',
    drilling: 'Бес/алты жаңбақлым дыбыл',
    labeling: 'Белгілеу машинасы',
    robotic: 'Роботік қолы',
    label: 'Бейнес',
    warningTip: 'Ескерту: Фигуралық жақшалар 【{}】 және олардың ішіндегі мазмұн бүтін болуы керек, қолмен жоймаңыз немесе қоспаңыз!',
    fileClassifyError: 'Бұл файл {classifyNames} бойынша классификациялауы мүмкін емес',
    folderClassifyByTextureColorThickSize: 'Түс, материал, қалыңдығы және үлкен доска ölçі бойынша әр түрлі қаптамаларға классификациялау (белгілер файлдары бірге)',
    unnamed: 'Атыңыз жоқ',
    specialText: 'Арнайы',
    surplusText: 'Ашық материал',
    normalText: 'Қалыпты',
    plankText1: 'Тақта',
    resetTemplate: 'Қалпына келтіру үлгісі',
    resetTemplateConfirm: 'Үлгіні қалпына келтіруге сенімдісіз бе?',
    clearTemplate: 'Үлгіні тазалау',
    clearTemplateConfirm: 'Үлгіні тазалауға сенімдісіз бе?',
    legendFixedFolder: 'Бекітілген қаптама',
    legendClassifyFolder: 'Жіктеу қаптамасы',
    legendFixedTag: 'Бекітілген деректер',
    legendNormalTag: 'Динамикалық деректер',
    legendClassifyTag: 'Жіктеу динамикалық деректері',
    door_wall_aio: 'Қабырға және шкафты құрастыру машинасы',
    noPermission: 'Сізде қазір реттелетін қалталарды пайдалану рұқсаты жоқ. Пайдаланбас бұрын бұл функцияны сатып алу үшін сату бөліміне хабарласыңыз.',
    enableCustomFolder: 'Қалталарды өзгерту рұқсатын қосу',
    exporttagTip: 'Тег PDF және суретті бір уақытта экспорттағанда, әдепкі бойынша PDF жіберіледі'
    },
  paibanTask: {
    pausedTip: 'Geciktirilgen Veziyyet',
    deleteTip: '«{taskBatch}» тапсырмасын өшіруге қандай да бір қате жіберілді. Өшіруді қайтару мүмкін емес.',
    continueTip: 'Veziyyeti davam ettir',
    completed: 'Tamamlandı',
    failed: 'Veziyyet sığıncaqlandı',
    paused: 'Geciktirilgen Veziyyet',
    pending: 'Kelgen Veziyyet',
    running: 'Davom ettirilgen Veziyyet',
    extraTip: 'Макет тапсырмасы тек өткен аптаға ғана көрсетіледі. Тапсырманы аяқтаңыздан кейін оны өтінішке қойыңыз!',
    taskStatus: 'Veziyyet statusi',
    createTaskTip: 'Макет тапсырмасын құру, макеттен кіру',
    taskBatchTitle: 'Тапсырма партиясы',
    relatedOrderNosTitle: 'Байланысты тапсырыс нөмірлері',
    progressTitle: 'Орналастыру прогрессі',
    boardCountTitle: 'Тақта мөлшеріны бағалау',
    optimizedAreaTitle: 'Оптимизацияланған ауданны бағалау',
    productionLineTitle: 'Өндіріс желісі',
    operationTitle: 'Әрекет',
    optimizeRateTitle: 'Оптимизация деңгейін бағалау',
    optimizeRateTip: 'Автоматтық қиылысқан материалдың оптимизация деңгейі есептелмейді.',
    optimizeRateTip2: 'Орналастыру параметрлері бойынша жекеленген оптимизация деңгейі',
    boardCountTip: 'Тақта мөлшері параметрлері бойынша жекеленген',
    optimizedAreaTip: 'Оптимизацияланған аудан параметрлері бойынша жекеленген',
    paibanSettingTip: 'Өнім құрылымының параметрлері өзгерген. Текущие результаты компоновки могут конфликтовать с фактическими файлами экспорта производства. Рекомендуется повторная компоновка производства.',
    dataException: 'Деректер аномалиясы, өңдеуді қайта қарап көріңіз'
    },
  paibanSetting: {
    advancedSetting: 'Қосымша параметрлер',
    advancedFeature: 'Қосымша құралдар',
    surplusCutSpeedUp: 'Қалдық қиылудың автоматтық жылдамдауы',
    surplusCutSpeedUpTip4: 'Құралдарын дамытуда, күте тұрыңыз',
    surplusCutSpeedUpTip: 'Қалдық орналастыру аралығы автоматты түрде 0 болады',
    surplusCutSpeedUpTip2: 'Қалдық кесу автоматты түрде кесілген және жиектеу жолдарын өткізіп, кесу тиімділігін арттырады',
    surplusCutSpeedUpTip3: 'Бұл функция тек гравировальдық машиналар мен бір айналым гравировальдық машиналар үшін әрекет етеді (ортақ кесу және ортақ кесу жылдамдығымен бірге қолдануды қолдамайды)',
    surplusCutSpeedUpTip5: 'Только эффективно для машин гравирования и машин гравирования с одним поворотом',
    featureDisplay: 'Функция көрінісі',
    featureDisplayTip: 'Бұл бет тек функция кіру нүктелерінің көрсетілуін басқарады, функцияның қосу күйі мен параметр конфигурациясын өзгертпейді'
    },
  alignedPlan: {
    deepSearch: 'Толық талдау',
    deepSearchTip: 'Арнайы функция: қайта орналастыру арқылы есептеу тереңдігін арттырып, жақсырақ нәтиже алыңыз',
    deepSearchTip2: 'Толық талдауды жаңартқаннан кейін қайта орналастыру арқылы есептеу тереңдігін арттырыңыз. Қазір сынап көруге болады',
    deepSearchTip3: 'Толық талдау тақтаны үнемдейтін жақсырақ нұсқаны ұсынады',
    deepSearchTip4: 'Қазір Толық талдау орналастыру рұқсаты жоқ. Сатып алу үшін сатушыға хабарласыңыз.',
    deepSearchTip5: 'Толық талдауды жаңартқаннан кейін арнайы сервер есептеу қуатын пайдаланып, сапаны арттырыңыз. Қазір алдын ала қарауға болады'
    }
  }